// ═══════════════════════════════════════════════════════════════════════════
// TrueHealthAge — Tip Bank (700 clinically-vetted tips, ~100 per category)
//
// Generated from TrueHealthAge_Tip_Bank_700.csv. Each tip has:
//   - category   (sleep_recovery / energy_fatigue / heart_fitness / etc.)
//   - week       (suggested week 1-20 — fits 8-week protocol with rotation)
//   - theme      (sub-cluster within category — e.g. "Caffeine timing")
//   - core       (broader skill area)
//   - tip        (user-facing action — what they do)
//   - framing    (Coach K's wrapper around the tip — used for warmer copy)
//   - tracking   (what to measure for self-report)
//   - safety     (escalation criteria)
//   - mode       (physical | nutrition | behavioral — the lever this tip pulls)
//
// The picker requires one tip from each mode each week so the user always
// gets a movement habit, a food/drink habit, and a mind/behavior habit
// together. Mode classification was generated by scripts/classify_tips.mjs
// using keyword heuristics; hand-edits welcome where a tip is mis-bucketed.
//
// Used by pickTipsForUser() in tipPicker.js to personalize the 3 weekly
// actions based on chronotype, severity, risk tags, and fitness baseline.
// ═══════════════════════════════════════════════════════════════════════════

export const TIP_BANK = [
  {
    category: "sleep_recovery",
    week: 1,
    theme: "Wake anchor",
    core: "Body-clock anchor",
    tip: "Hold your wake time within 30 minutes of target today.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Hold your wake time within 30 minutes of target today.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 1,
    theme: "Wake anchor",
    core: "Body-clock anchor",
    tip: "Open blinds as soon as you wake up.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Open blinds as soon as you wake up.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 1,
    theme: "Wake anchor",
    core: "Body-clock anchor",
    tip: "Step outside for 5 minutes within 60 minutes of waking.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Step outside for 5 minutes within 60 minutes of waking.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 1,
    theme: "Wake anchor",
    core: "Body-clock anchor",
    tip: "Skip the snooze button once; sit up when the alarm goes off.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Skip the snooze button once; sit up when the alarm goes off.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 1,
    theme: "Wake anchor",
    core: "Body-clock anchor",
    tip: "Keep weekend wake time within 60 minutes of your usual time.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep weekend wake time within 60 minutes of your usual time.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 2,
    theme: "Morning light",
    core: "Body-clock anchor",
    tip: "Drink coffee or tea outside for 5 minutes.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Drink coffee or tea outside for 5 minutes.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 2,
    theme: "Morning light",
    core: "Body-clock anchor",
    tip: "Look toward outdoor light, not directly at the sun.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Look toward outdoor light, not directly at the sun.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 2,
    theme: "Morning light",
    core: "Body-clock anchor",
    tip: "If it is dark when you wake, turn on bright indoor light until sunrise.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: If it is dark when you wake, turn on bright indoor light until sunrise.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 2,
    theme: "Morning light",
    core: "Body-clock anchor",
    tip: "Take a 5-minute walk before starting screens.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take a 5-minute walk before starting screens.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 2,
    theme: "Morning light",
    core: "Body-clock anchor",
    tip: "Put a sticky note by the coffee maker: 'light first.'",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Put a sticky note by the coffee maker: 'light first.'",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 3,
    theme: "Caffeine timing",
    core: "Body-clock anchor",
    tip: "Set your caffeine cutoff at least 8 hours before your sleep window.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Set your caffeine cutoff at least 8 hours before your sleep window.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 3,
    theme: "Caffeine timing",
    core: "Body-clock anchor",
    tip: "Move the last coffee 30 minutes earlier than yesterday.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Move the last coffee 30 minutes earlier than yesterday.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "nutrition",
  },
  {
    category: "sleep_recovery",
    week: 3,
    theme: "Caffeine timing",
    core: "Body-clock anchor",
    tip: "Swap late caffeine for water or herbal tea.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Swap late caffeine for water or herbal tea.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "nutrition",
  },
  {
    category: "sleep_recovery",
    week: 3,
    theme: "Caffeine timing",
    core: "Body-clock anchor",
    tip: "Track the time of your last caffeine for one week.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track the time of your last caffeine for one week.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 3,
    theme: "Caffeine timing",
    core: "Body-clock anchor",
    tip: "Use a 10-minute walk for the afternoon dip instead of more caffeine.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use a 10-minute walk for the afternoon dip instead of more caffeine.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "physical",
  },
  {
    category: "sleep_recovery",
    week: 4,
    theme: "Wind-down routine",
    core: "Wind-down + sleep environment",
    tip: "Start a 30-minute wind-down before your own bedtime.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Start a 30-minute wind-down before your own bedtime.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 4,
    theme: "Wind-down routine",
    core: "Wind-down + sleep environment",
    tip: "Pick one repeatable wind-down cue: reading, stretching, music, or quiet conversation.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Pick one repeatable wind-down cue: reading, stretching, music, or quiet conversation.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 4,
    theme: "Wind-down routine",
    core: "Wind-down + sleep environment",
    tip: "Write tomorrow’s top 3 tasks before wind-down starts.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Write tomorrow’s top 3 tasks before wind-down starts.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 4,
    theme: "Wind-down routine",
    core: "Wind-down + sleep environment",
    tip: "Dim overhead lights during the last hour before bed.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Dim overhead lights during the last hour before bed.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 4,
    theme: "Wind-down routine",
    core: "Wind-down + sleep environment",
    tip: "Do the same 5-minute closing routine nightly.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do the same 5-minute closing routine nightly.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 5,
    theme: "Screens and bedroom",
    core: "Wind-down + sleep environment",
    tip: "Charge your phone across the room before bed.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Charge your phone across the room before bed.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 5,
    theme: "Screens and bedroom",
    core: "Wind-down + sleep environment",
    tip: "Keep the phone out of bed tonight.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep the phone out of bed tonight.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 5,
    theme: "Screens and bedroom",
    core: "Wind-down + sleep environment",
    tip: "Use night mode and lowest brightness if a screen is unavoidable.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use night mode and lowest brightness if a screen is unavoidable.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 5,
    theme: "Screens and bedroom",
    core: "Wind-down + sleep environment",
    tip: "Put a book, not a phone, on the nightstand.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Put a book, not a phone, on the nightstand.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 5,
    theme: "Screens and bedroom",
    core: "Wind-down + sleep environment",
    tip: "Set a 'screens done' alarm 30 minutes before bed.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Set a 'screens done' alarm 30 minutes before bed.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 6,
    theme: "Bedroom environment",
    core: "Wind-down + sleep environment",
    tip: "Make the room cooler before sleep.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Make the room cooler before sleep.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 6,
    theme: "Bedroom environment",
    core: "Wind-down + sleep environment",
    tip: "Use earplugs, white noise, or fan if noise is an issue.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use earplugs, white noise, or fan if noise is an issue.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 6,
    theme: "Bedroom environment",
    core: "Wind-down + sleep environment",
    tip: "Use an eye mask or blackout curtains if light leaks in.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use an eye mask or blackout curtains if light leaks in.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 6,
    theme: "Bedroom environment",
    core: "Wind-down + sleep environment",
    tip: "Keep work materials out of the bedroom tonight.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep work materials out of the bedroom tonight.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 6,
    theme: "Bedroom environment",
    core: "Wind-down + sleep environment",
    tip: "Make the bed inviting before evening so sleep feels easier later.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Make the bed inviting before evening so sleep feels easier later.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 7,
    theme: "Bedtime consistency",
    core: "Body-clock anchor",
    tip: "Get into bed within 30 minutes of your planned sleep window.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Get into bed within 30 minutes of your planned sleep window.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 7,
    theme: "Bedtime consistency",
    core: "Body-clock anchor",
    tip: "Do not move wake time later just because bedtime slipped.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not move wake time later just because bedtime slipped.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 7,
    theme: "Bedtime consistency",
    core: "Body-clock anchor",
    tip: "Pick a realistic bedtime, not the perfect one.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Pick a realistic bedtime, not the perfect one.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 7,
    theme: "Bedtime consistency",
    core: "Body-clock anchor",
    tip: "Set a cutoff alarm for the habit that keeps you up.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Set a cutoff alarm for the habit that keeps you up.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 7,
    theme: "Bedtime consistency",
    core: "Body-clock anchor",
    tip: "If you miss one night, hit the next sleep window without penalty.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: If you miss one night, hit the next sleep window without penalty.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 8,
    theme: "Sleep extension",
    core: "Recovery protection + medical escalation",
    tip: "Add 15 minutes to your sleep opportunity tonight.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add 15 minutes to your sleep opportunity tonight.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 8,
    theme: "Sleep extension",
    core: "Recovery protection + medical escalation",
    tip: "If you sleep under 7 hours, move bedtime 15 minutes earlier for three nights.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: If you sleep under 7 hours, move bedtime 15 minutes earlier for three nights.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 8,
    theme: "Sleep extension",
    core: "Recovery protection + medical escalation",
    tip: "Protect enough time in bed before adding supplements or gadgets.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Protect enough time in bed before adding supplements or gadgets.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 8,
    theme: "Sleep extension",
    core: "Recovery protection + medical escalation",
    tip: "Do not add 90 minutes at once; use 15–30 minute steps.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not add 90 minutes at once; use 15–30 minute steps.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 8,
    theme: "Sleep extension",
    core: "Recovery protection + medical escalation",
    tip: "Track actual sleep opportunity, not just sleep quality.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track actual sleep opportunity, not just sleep quality.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 9,
    theme: "Hydration timing",
    core: "Wind-down + sleep environment",
    tip: "Drink 16 oz of water early in your wake window.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Drink 16 oz of water early in your wake window.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "nutrition",
  },
  {
    category: "sleep_recovery",
    week: 9,
    theme: "Hydration timing",
    core: "Wind-down + sleep environment",
    tip: "Finish most fluids 2–3 hours before your sleep window.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Finish most fluids 2–3 hours before your sleep window.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 9,
    theme: "Hydration timing",
    core: "Wind-down + sleep environment",
    tip: "Use small sips only in the last hour before bed.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use small sips only in the last hour before bed.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 9,
    theme: "Hydration timing",
    core: "Wind-down + sleep environment",
    tip: "Move the after-dinner water to mid-afternoon.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Move the after-dinner water to mid-afternoon.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "nutrition",
  },
  {
    category: "sleep_recovery",
    week: 9,
    theme: "Hydration timing",
    core: "Wind-down + sleep environment",
    tip: "Track nighttime bathroom trips without judging them.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track nighttime bathroom trips without judging them.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 10,
    theme: "Meals and alcohol",
    core: "Wind-down + sleep environment",
    tip: "Finish large meals at least 2–3 hours before sleep when possible.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Finish large meals at least 2–3 hours before sleep when possible.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 10,
    theme: "Meals and alcohol",
    core: "Wind-down + sleep environment",
    tip: "If hungry late, choose a small protein-based snack.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: If hungry late, choose a small protein-based snack.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "nutrition",
  },
  {
    category: "sleep_recovery",
    week: 10,
    theme: "Meals and alcohol",
    core: "Wind-down + sleep environment",
    tip: "Notice whether alcohol worsens middle-of-night waking.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Notice whether alcohol worsens middle-of-night waking.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 10,
    theme: "Meals and alcohol",
    core: "Wind-down + sleep environment",
    tip: "Avoid heavy spicy meals close to bedtime.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Avoid heavy spicy meals close to bedtime.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 10,
    theme: "Meals and alcohol",
    core: "Wind-down + sleep environment",
    tip: "Track one night of dinner timing and sleep quality.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track one night of dinner timing and sleep quality.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 11,
    theme: "Nap strategy",
    core: "Body-clock anchor",
    tip: "Keep naps under 20 minutes.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep naps under 20 minutes.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 11,
    theme: "Nap strategy",
    core: "Body-clock anchor",
    tip: "Nap earlier in your wake window, not close to bedtime.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Nap earlier in your wake window, not close to bedtime.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 11,
    theme: "Nap strategy",
    core: "Body-clock anchor",
    tip: "If naps hurt nighttime sleep, skip them for one week.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: If naps hurt nighttime sleep, skip them for one week.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 11,
    theme: "Nap strategy",
    core: "Body-clock anchor",
    tip: "Use a walk or light exposure before choosing a nap.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use a walk or light exposure before choosing a nap.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 11,
    theme: "Nap strategy",
    core: "Body-clock anchor",
    tip: "Set an alarm before you close your eyes.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Set an alarm before you close your eyes.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 12,
    theme: "Middle-of-night waking",
    core: "Recovery protection + medical escalation",
    tip: "If awake at night, keep lights low.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: If awake at night, keep lights low.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 12,
    theme: "Middle-of-night waking",
    core: "Recovery protection + medical escalation",
    tip: "Do not check the time repeatedly.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not check the time repeatedly.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 12,
    theme: "Middle-of-night waking",
    core: "Recovery protection + medical escalation",
    tip: "Use boring breathing, not problem-solving.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use boring breathing, not problem-solving.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "physical",
  },
  {
    category: "sleep_recovery",
    week: 12,
    theme: "Middle-of-night waking",
    core: "Recovery protection + medical escalation",
    tip: "If you are awake too long, read something low-stimulation in dim light.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: If you are awake too long, read something low-stimulation in dim light.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 12,
    theme: "Middle-of-night waking",
    core: "Recovery protection + medical escalation",
    tip: "Track patterns: bathroom, stress, caffeine, alcohol, temperature.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track patterns: bathroom, stress, caffeine, alcohol, temperature.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 13,
    theme: "Sleep apnea screen",
    core: "Recovery protection + medical escalation",
    tip: "Ask a bed partner whether you snore, gasp, or pause breathing.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask a bed partner whether you snore, gasp, or pause breathing.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "physical",
  },
  {
    category: "sleep_recovery",
    week: 13,
    theme: "Sleep apnea screen",
    core: "Recovery protection + medical escalation",
    tip: "Write down morning headaches or dry mouth if present.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Write down morning headaches or dry mouth if present.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 13,
    theme: "Sleep apnea screen",
    core: "Recovery protection + medical escalation",
    tip: "Do not ignore daytime sleepiness with loud snoring.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not ignore daytime sleepiness with loud snoring.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 13,
    theme: "Sleep apnea screen",
    core: "Recovery protection + medical escalation",
    tip: "Send a doctor portal message if apnea signs are present.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Send a doctor portal message if apnea signs are present.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 13,
    theme: "Sleep apnea screen",
    core: "Recovery protection + medical escalation",
    tip: "Treat drowsy driving as urgent — pull over and seek help.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Treat drowsy driving as urgent — pull over and seek help.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 14,
    theme: "Shift-worker sleep",
    core: "Recovery protection + medical escalation",
    tip: "Define your personal 'day' and 'night' based on your schedule.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Define your personal 'day' and 'night' based on your schedule.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 14,
    theme: "Shift-worker sleep",
    core: "Recovery protection + medical escalation",
    tip: "Use bright light at the start of your work shift.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use bright light at the start of your work shift.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 14,
    theme: "Shift-worker sleep",
    core: "Recovery protection + medical escalation",
    tip: "Block light before your sleep window after a night shift.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Block light before your sleep window after a night shift.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 14,
    theme: "Shift-worker sleep",
    core: "Recovery protection + medical escalation",
    tip: "Protect sleep with eye mask, earplugs, and family boundaries.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Protect sleep with eye mask, earplugs, and family boundaries.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 14,
    theme: "Shift-worker sleep",
    core: "Recovery protection + medical escalation",
    tip: "Keep caffeine at least 6 hours away from sleep.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep caffeine at least 6 hours away from sleep.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 15,
    theme: "Travel/reset",
    core: "Body-clock anchor",
    tip: "Anchor to local morning light as soon as practical.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Anchor to local morning light as soon as practical.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 15,
    theme: "Travel/reset",
    core: "Body-clock anchor",
    tip: "Keep the first meal aligned with your new wake window.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep the first meal aligned with your new wake window.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 15,
    theme: "Travel/reset",
    core: "Body-clock anchor",
    tip: "Use a short walk to signal daytime after travel.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use a short walk to signal daytime after travel.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "physical",
  },
  {
    category: "sleep_recovery",
    week: 15,
    theme: "Travel/reset",
    core: "Body-clock anchor",
    tip: "Keep the first night simple: dark room, cool room, no phone in bed.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep the first night simple: dark room, cool room, no phone in bed.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 15,
    theme: "Travel/reset",
    core: "Body-clock anchor",
    tip: "Return to your usual wake anchor the day after travel.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Return to your usual wake anchor the day after travel.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 16,
    theme: "Recovery day",
    core: "Recovery protection + medical escalation",
    tip: "Take one slow morning after a hard week.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take one slow morning after a hard week.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 16,
    theme: "Recovery day",
    core: "Recovery protection + medical escalation",
    tip: "Plan a phone-free meal on a recovery day.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Plan a phone-free meal on a recovery day.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 16,
    theme: "Recovery day",
    core: "Recovery protection + medical escalation",
    tip: "Spend 15 minutes outside without making it exercise.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Spend 15 minutes outside without making it exercise.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 16,
    theme: "Recovery day",
    core: "Recovery protection + medical escalation",
    tip: "Skip one optional task to protect rest.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Skip one optional task to protect rest.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 16,
    theme: "Recovery day",
    core: "Recovery protection + medical escalation",
    tip: "Go to bed early enough to give your body a real chance.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Go to bed early enough to give your body a real chance.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 17,
    theme: "Stress spillover",
    core: "Wind-down + sleep environment",
    tip: "Write one worry on paper and one next action for tomorrow.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Write one worry on paper and one next action for tomorrow.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 17,
    theme: "Stress spillover",
    core: "Wind-down + sleep environment",
    tip: "Use 5 slow breaths before bed.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use 5 slow breaths before bed.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "physical",
  },
  {
    category: "sleep_recovery",
    week: 17,
    theme: "Stress spillover",
    core: "Wind-down + sleep environment",
    tip: "Relax jaw and shoulders when you get into bed.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Relax jaw and shoulders when you get into bed.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "physical",
  },
  {
    category: "sleep_recovery",
    week: 17,
    theme: "Stress spillover",
    core: "Wind-down + sleep environment",
    tip: "Do not solve work problems in bed.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not solve work problems in bed.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 17,
    theme: "Stress spillover",
    core: "Wind-down + sleep environment",
    tip: "Create a closing phrase: 'Not tonight — tomorrow.'",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Create a closing phrase: 'Not tonight — tomorrow.'",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 18,
    theme: "Exercise timing",
    core: "Body-clock anchor",
    tip: "Move your body during the day, even for 10 minutes.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Move your body during the day, even for 10 minutes.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 18,
    theme: "Exercise timing",
    core: "Body-clock anchor",
    tip: "If intense evening exercise keeps you wired, shift it earlier.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: If intense evening exercise keeps you wired, shift it earlier.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 18,
    theme: "Exercise timing",
    core: "Body-clock anchor",
    tip: "Use gentle stretching at night, not a hard workout.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use gentle stretching at night, not a hard workout.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "physical",
  },
  {
    category: "sleep_recovery",
    week: 18,
    theme: "Exercise timing",
    core: "Body-clock anchor",
    tip: "Take a post-dinner walk instead of late-night scrolling.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take a post-dinner walk instead of late-night scrolling.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "physical",
  },
  {
    category: "sleep_recovery",
    week: 18,
    theme: "Exercise timing",
    core: "Body-clock anchor",
    tip: "Track whether exercise days improve sleep depth.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track whether exercise days improve sleep depth.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 19,
    theme: "Sleep confidence",
    core: "Recovery protection + medical escalation",
    tip: "Stop grading every night as pass/fail.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stop grading every night as pass/fail.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 19,
    theme: "Sleep confidence",
    core: "Recovery protection + medical escalation",
    tip: "Judge the routine, not one night of sleep.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Judge the routine, not one night of sleep.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 19,
    theme: "Sleep confidence",
    core: "Recovery protection + medical escalation",
    tip: "Repeat the base habits another week before adding more.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Repeat the base habits another week before adding more.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 19,
    theme: "Sleep confidence",
    core: "Recovery protection + medical escalation",
    tip: "Use one small win: wake time, light, or phone away.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use one small win: wake time, light, or phone away.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 19,
    theme: "Sleep confidence",
    core: "Recovery protection + medical escalation",
    tip: "If sleep has not improved after 3 weeks of consistency, ask for medical help.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: If sleep has not improved after 3 weeks of consistency, ask for medical help.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 20,
    theme: "Maintenance",
    core: "Recovery protection + medical escalation",
    tip: "Keep the one sleep habit that helped most.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep the one sleep habit that helped most.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 20,
    theme: "Maintenance",
    core: "Recovery protection + medical escalation",
    tip: "Remove the sleep habit that added stress but did not help.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Remove the sleep habit that added stress but did not help.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 20,
    theme: "Maintenance",
    core: "Recovery protection + medical escalation",
    tip: "Pick a travel version of your routine.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Pick a travel version of your routine.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 20,
    theme: "Maintenance",
    core: "Recovery protection + medical escalation",
    tip: "Review sleep red flags once a month.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Review sleep red flags once a month.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "sleep_recovery",
    week: 20,
    theme: "Maintenance",
    core: "Recovery protection + medical escalation",
    tip: "Protect sleep before adding more health goals.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Protect sleep before adding more health goals.",
    tracking: "Nights completed / sleep quality 1–10",
    safety: "Escalate loud snoring, gasping, insomnia >3 weeks, severe daytime sleepiness, or drowsy driving.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 1,
    theme: "Food awareness",
    core: "Calorie awareness + food tracking",
    tip: "Take a photo of every meal, snack, and drink today.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take a photo of every meal, snack, and drink today.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 1,
    theme: "Food awareness",
    core: "Calorie awareness + food tracking",
    tip: "Write down food before you eat it for one meal.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Write down food before you eat it for one meal.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 1,
    theme: "Food awareness",
    core: "Calorie awareness + food tracking",
    tip: "Track drinks with calories for one day.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track drinks with calories for one day.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 1,
    theme: "Food awareness",
    core: "Calorie awareness + food tracking",
    tip: "Use a simple 1–10 hunger rating before dinner.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use a simple 1–10 hunger rating before dinner.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 1,
    theme: "Food awareness",
    core: "Calorie awareness + food tracking",
    tip: "Review photos at night and look for one easy swap.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Review photos at night and look for one easy swap.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 2,
    theme: "Calorie deficit basics",
    core: "Calorie awareness + food tracking",
    tip: "Remove one extra bite habit: finishing plates, grazing, or leftovers.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Remove one extra bite habit: finishing plates, grazing, or leftovers.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 2,
    theme: "Calorie deficit basics",
    core: "Calorie awareness + food tracking",
    tip: "Use a smaller plate for one meal.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use a smaller plate for one meal.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 2,
    theme: "Calorie deficit basics",
    core: "Calorie awareness + food tracking",
    tip: "Stop eating at comfortably satisfied, not stuffed.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stop eating at comfortably satisfied, not stuffed.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 2,
    theme: "Calorie deficit basics",
    core: "Calorie awareness + food tracking",
    tip: "Leave 3 bites behind once today if you are full.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Leave 3 bites behind once today if you are full.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 2,
    theme: "Calorie deficit basics",
    core: "Calorie awareness + food tracking",
    tip: "Identify the highest-calorie habit in your day without judging it.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Identify the highest-calorie habit in your day without judging it.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 3,
    theme: "Protein anchor",
    core: "Protein/fiber/added-sugar control",
    tip: "Add protein to breakfast or your first meal.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add protein to breakfast or your first meal.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 3,
    theme: "Protein anchor",
    core: "Protein/fiber/added-sugar control",
    tip: "Build one meal around eggs, Greek yogurt, fish, poultry, tofu, beans, or a shake.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Build one meal around eggs, Greek yogurt, fish, poultry, tofu, beans, or a shake.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 3,
    theme: "Protein anchor",
    core: "Protein/fiber/added-sugar control",
    tip: "Put protein on the plate before starch.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Put protein on the plate before starch.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 3,
    theme: "Protein anchor",
    core: "Protein/fiber/added-sugar control",
    tip: "Use a protein snack instead of a sweet snack once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use a protein snack instead of a sweet snack once.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 3,
    theme: "Protein anchor",
    core: "Protein/fiber/added-sugar control",
    tip: "Track whether protein reduces cravings later.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track whether protein reduces cravings later.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 4,
    theme: "Fiber and plants",
    core: "Protein/fiber/added-sugar control",
    tip: "Add one fruit or vegetable to lunch.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add one fruit or vegetable to lunch.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 4,
    theme: "Fiber and plants",
    core: "Protein/fiber/added-sugar control",
    tip: "Add beans, lentils, oats, berries, or vegetables once today.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add beans, lentils, oats, berries, or vegetables once today.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 4,
    theme: "Fiber and plants",
    core: "Protein/fiber/added-sugar control",
    tip: "Make half of one plate non-starchy vegetables.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Make half of one plate non-starchy vegetables.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 4,
    theme: "Fiber and plants",
    core: "Protein/fiber/added-sugar control",
    tip: "Use salad or vegetables before the main meal.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use salad or vegetables before the main meal.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 4,
    theme: "Fiber and plants",
    core: "Protein/fiber/added-sugar control",
    tip: "Add fiber before removing food.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add fiber before removing food.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 5,
    theme: "Added sugar reduction",
    core: "Protein/fiber/added-sugar control",
    tip: "Replace one sugary drink with water, unsweet tea, or zero-sugar option.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Replace one sugary drink with water, unsweet tea, or zero-sugar option.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 5,
    theme: "Added sugar reduction",
    core: "Protein/fiber/added-sugar control",
    tip: "Pick one dessert day instead of automatic dessert.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Pick one dessert day instead of automatic dessert.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 5,
    theme: "Added sugar reduction",
    core: "Protein/fiber/added-sugar control",
    tip: "Read one label for added sugar.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Read one label for added sugar.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 5,
    theme: "Added sugar reduction",
    core: "Protein/fiber/added-sugar control",
    tip: "Swap candy/cookies for fruit plus protein once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Swap candy/cookies for fruit plus protein once.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 5,
    theme: "Added sugar reduction",
    core: "Protein/fiber/added-sugar control",
    tip: "Move sweets out of arm’s reach, not out of your life forever.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Move sweets out of arm’s reach, not out of your life forever.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 6,
    theme: "Refined carb reset",
    core: "Protein/fiber/added-sugar control",
    tip: "Choose one meal with protein + vegetables before refined carbs.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Choose one meal with protein + vegetables before refined carbs.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 6,
    theme: "Refined carb reset",
    core: "Protein/fiber/added-sugar control",
    tip: "Swap white bread/pasta/rice for whole-grain or smaller portion once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Swap white bread/pasta/rice for whole-grain or smaller portion once.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 6,
    theme: "Refined carb reset",
    core: "Protein/fiber/added-sugar control",
    tip: "Keep carbs, but pair them with protein or fat.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep carbs, but pair them with protein or fat.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 6,
    theme: "Refined carb reset",
    core: "Protein/fiber/added-sugar control",
    tip: "Skip the carb-only snack today.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Skip the carb-only snack today.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 6,
    theme: "Refined carb reset",
    core: "Protein/fiber/added-sugar control",
    tip: "Track energy after a lower-refined-carb lunch.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track energy after a lower-refined-carb lunch.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 7,
    theme: "Walking after meals",
    core: "Daily movement + strength preservation",
    tip: "Walk 5–10 minutes after one meal.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Walk 5–10 minutes after one meal.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 7,
    theme: "Walking after meals",
    core: "Daily movement + strength preservation",
    tip: "Use the first 5 minutes after dinner as your walk cue.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use the first 5 minutes after dinner as your walk cue.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 7,
    theme: "Walking after meals",
    core: "Daily movement + strength preservation",
    tip: "Walk indoors if weather is bad.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Walk indoors if weather is bad.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 7,
    theme: "Walking after meals",
    core: "Daily movement + strength preservation",
    tip: "Invite someone for the after-meal walk.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Invite someone for the after-meal walk.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 7,
    theme: "Walking after meals",
    core: "Daily movement + strength preservation",
    tip: "Track digestion and energy after the walk.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track digestion and energy after the walk.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 8,
    theme: "Step progression",
    core: "Daily movement + strength preservation",
    tip: "Add 1,000 steps over your current baseline.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add 1,000 steps over your current baseline.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 8,
    theme: "Step progression",
    core: "Daily movement + strength preservation",
    tip: "Take one phone call walking.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take one phone call walking.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 8,
    theme: "Step progression",
    core: "Daily movement + strength preservation",
    tip: "Park farther away once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Park farther away once.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 8,
    theme: "Step progression",
    core: "Daily movement + strength preservation",
    tip: "Use stairs once if safe.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use stairs once if safe.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 8,
    theme: "Step progression",
    core: "Daily movement + strength preservation",
    tip: "Walk the long route to one routine destination.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Walk the long route to one routine destination.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 9,
    theme: "Strength preservation",
    core: "Daily movement + strength preservation",
    tip: "Do 2 sets of chair squats or sit-to-stands.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do 2 sets of chair squats or sit-to-stands.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 9,
    theme: "Strength preservation",
    core: "Daily movement + strength preservation",
    tip: "Do wall push-ups for one minute.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do wall push-ups for one minute.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 9,
    theme: "Strength preservation",
    core: "Daily movement + strength preservation",
    tip: "Carry groceries or light weights with good form.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Carry groceries or light weights with good form.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 9,
    theme: "Strength preservation",
    core: "Daily movement + strength preservation",
    tip: "Schedule one short strength session this week.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Schedule one short strength session this week.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 9,
    theme: "Strength preservation",
    core: "Daily movement + strength preservation",
    tip: "Train muscles before chasing scale speed.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Train muscles before chasing scale speed.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 10,
    theme: "Meal timing",
    core: "Calorie awareness + food tracking",
    tip: "Create a consistent first meal time for 3 days.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Create a consistent first meal time for 3 days.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 10,
    theme: "Meal timing",
    core: "Calorie awareness + food tracking",
    tip: "Stop random grazing after dinner one night.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stop random grazing after dinner one night.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 10,
    theme: "Meal timing",
    core: "Calorie awareness + food tracking",
    tip: "Use a planned snack instead of open-ended snacking.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use a planned snack instead of open-ended snacking.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 10,
    theme: "Meal timing",
    core: "Calorie awareness + food tracking",
    tip: "Define your kitchen-closed time relative to bedtime.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Define your kitchen-closed time relative to bedtime.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 10,
    theme: "Meal timing",
    core: "Calorie awareness + food tracking",
    tip: "Delay a craving for 10 minutes and reassess.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Delay a craving for 10 minutes and reassess.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 11,
    theme: "Meal prep",
    core: "Protein/fiber/added-sugar control",
    tip: "Prep one protein option for tomorrow.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Prep one protein option for tomorrow.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 11,
    theme: "Meal prep",
    core: "Protein/fiber/added-sugar control",
    tip: "Wash or cut fruit/vegetables so they are easy to grab.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Wash or cut fruit/vegetables so they are easy to grab.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 11,
    theme: "Meal prep",
    core: "Protein/fiber/added-sugar control",
    tip: "Plan one emergency meal that is better than takeout.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Plan one emergency meal that is better than takeout.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 11,
    theme: "Meal prep",
    core: "Protein/fiber/added-sugar control",
    tip: "Keep a protein snack at work or in the car.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep a protein snack at work or in the car.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 11,
    theme: "Meal prep",
    core: "Protein/fiber/added-sugar control",
    tip: "Make tomorrow’s lunch before tonight’s willpower disappears.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Make tomorrow’s lunch before tonight’s willpower disappears.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 12,
    theme: "Portion skills",
    core: "Calorie awareness + food tracking",
    tip: "Serve food from the kitchen, not family-style at the table.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Serve food from the kitchen, not family-style at the table.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 12,
    theme: "Portion skills",
    core: "Calorie awareness + food tracking",
    tip: "Plate once, then pause before seconds.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Plate once, then pause before seconds.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 12,
    theme: "Portion skills",
    core: "Calorie awareness + food tracking",
    tip: "Use a palm-size protein and fist-size fiber target.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use a palm-size protein and fist-size fiber target.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 12,
    theme: "Portion skills",
    core: "Calorie awareness + food tracking",
    tip: "Put snacks in a bowl instead of eating from the bag.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Put snacks in a bowl instead of eating from the bag.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 12,
    theme: "Portion skills",
    core: "Calorie awareness + food tracking",
    tip: "Wait 10 minutes before deciding on more.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Wait 10 minutes before deciding on more.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 13,
    theme: "Restaurant strategy",
    core: "Calorie awareness + food tracking",
    tip: "Look at the menu before arriving.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Look at the menu before arriving.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 13,
    theme: "Restaurant strategy",
    core: "Calorie awareness + food tracking",
    tip: "Choose protein first when ordering.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Choose protein first when ordering.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 13,
    theme: "Restaurant strategy",
    core: "Calorie awareness + food tracking",
    tip: "Ask for sauce/dressing on the side once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask for sauce/dressing on the side once.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 13,
    theme: "Restaurant strategy",
    core: "Calorie awareness + food tracking",
    tip: "Box half before you start if portions are huge.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Box half before you start if portions are huge.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 13,
    theme: "Restaurant strategy",
    core: "Calorie awareness + food tracking",
    tip: "Enjoy the meal without turning it into a free-for-all.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Enjoy the meal without turning it into a free-for-all.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 14,
    theme: "Cravings protocol",
    core: "Protein/fiber/added-sugar control",
    tip: "Ask: hungry, stressed, tired, or bored?",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask: hungry, stressed, tired, or bored?",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 14,
    theme: "Cravings protocol",
    core: "Protein/fiber/added-sugar control",
    tip: "Drink water and wait 10 minutes before a craving snack.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Drink water and wait 10 minutes before a craving snack.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 14,
    theme: "Cravings protocol",
    core: "Protein/fiber/added-sugar control",
    tip: "Use a planned sweet instead of random grazing.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use a planned sweet instead of random grazing.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 14,
    theme: "Cravings protocol",
    core: "Protein/fiber/added-sugar control",
    tip: "Pair a craving food with protein, not shame.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Pair a craving food with protein, not shame.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 14,
    theme: "Cravings protocol",
    core: "Protein/fiber/added-sugar control",
    tip: "Notice the craving pattern, not your character.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Notice the craving pattern, not your character.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 15,
    theme: "Weekend control",
    core: "Calorie awareness + food tracking",
    tip: "Pick one weekend meal to track honestly.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Pick one weekend meal to track honestly.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 15,
    theme: "Weekend control",
    core: "Calorie awareness + food tracking",
    tip: "Keep breakfast structured on Saturday or Sunday.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep breakfast structured on Saturday or Sunday.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 15,
    theme: "Weekend control",
    core: "Calorie awareness + food tracking",
    tip: "Walk after the largest weekend meal.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Walk after the largest weekend meal.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 15,
    theme: "Weekend control",
    core: "Calorie awareness + food tracking",
    tip: "Do not let one indulgence become a weekend spiral.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not let one indulgence become a weekend spiral.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 15,
    theme: "Weekend control",
    core: "Calorie awareness + food tracking",
    tip: "Plan Monday’s breakfast before Sunday night.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Plan Monday’s breakfast before Sunday night.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 16,
    theme: "Sleep and weight",
    core: "Daily movement + strength preservation",
    tip: "Protect 7+ hours of sleep opportunity once this week.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Protect 7+ hours of sleep opportunity once this week.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 16,
    theme: "Sleep and weight",
    core: "Daily movement + strength preservation",
    tip: "Notice whether poor sleep drives hunger.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Notice whether poor sleep drives hunger.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 16,
    theme: "Sleep and weight",
    core: "Daily movement + strength preservation",
    tip: "Use a wind-down instead of late snacking once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use a wind-down instead of late snacking once.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 16,
    theme: "Sleep and weight",
    core: "Daily movement + strength preservation",
    tip: "Move caffeine earlier to protect sleep.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Move caffeine earlier to protect sleep.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 16,
    theme: "Sleep and weight",
    core: "Daily movement + strength preservation",
    tip: "Do not cut calories harder after bad sleep; get steady.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not cut calories harder after bad sleep; get steady.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 17,
    theme: "Stress eating",
    core: "Protein/fiber/added-sugar control",
    tip: "Use 2 minutes of breathing before stress snacking.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use 2 minutes of breathing before stress snacking.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 17,
    theme: "Stress eating",
    core: "Protein/fiber/added-sugar control",
    tip: "Write the stressor before deciding to eat.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Write the stressor before deciding to eat.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 17,
    theme: "Stress eating",
    core: "Protein/fiber/added-sugar control",
    tip: "Take a 5-minute walk before the snack.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take a 5-minute walk before the snack.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 17,
    theme: "Stress eating",
    core: "Protein/fiber/added-sugar control",
    tip: "Keep a satisfying planned snack available.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep a satisfying planned snack available.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 17,
    theme: "Stress eating",
    core: "Protein/fiber/added-sugar control",
    tip: "Ask for support instead of using food as the only tool.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask for support instead of using food as the only tool.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 18,
    theme: "Scale and measurements",
    core: "Calorie awareness + food tracking",
    tip: "Weigh at the same time once or twice this week.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Weigh at the same time once or twice this week.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 18,
    theme: "Scale and measurements",
    core: "Calorie awareness + food tracking",
    tip: "Track waist measurement once per month, not daily.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track waist measurement once per month, not daily.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 18,
    theme: "Scale and measurements",
    core: "Calorie awareness + food tracking",
    tip: "Look at trend, not one weigh-in.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Look at trend, not one weigh-in.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 18,
    theme: "Scale and measurements",
    core: "Calorie awareness + food tracking",
    tip: "Use adherence metrics alongside body weight.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use adherence metrics alongside body weight.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 18,
    theme: "Scale and measurements",
    core: "Calorie awareness + food tracking",
    tip: "Celebrate consistency before scale change.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Celebrate consistency before scale change.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 19,
    theme: "Reintroduction",
    core: "Protein/fiber/added-sugar control",
    tip: "Reintroduce one carb intentionally, not randomly.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Reintroduce one carb intentionally, not randomly.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 19,
    theme: "Reintroduction",
    core: "Protein/fiber/added-sugar control",
    tip: "Add back fruit, beans, oats, or potatoes before sweets.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add back fruit, beans, oats, or potatoes before sweets.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 19,
    theme: "Reintroduction",
    core: "Protein/fiber/added-sugar control",
    tip: "Notice energy, cravings, and digestion after reintroduction.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Notice energy, cravings, and digestion after reintroduction.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 19,
    theme: "Reintroduction",
    core: "Protein/fiber/added-sugar control",
    tip: "Keep portions reasonable while testing.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep portions reasonable while testing.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "nutrition",
  },
  {
    category: "weight_metabolism",
    week: 19,
    theme: "Reintroduction",
    core: "Protein/fiber/added-sugar control",
    tip: "Keep the food log during reintroduction.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep the food log during reintroduction.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "behavioral",
  },
  {
    category: "weight_metabolism",
    week: 20,
    theme: "Maintenance",
    core: "Daily movement + strength preservation",
    tip: "Keep one meal structure that worked.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep one meal structure that worked.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 20,
    theme: "Maintenance",
    core: "Daily movement + strength preservation",
    tip: "Keep one walk anchor that felt easiest.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep one walk anchor that felt easiest.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 20,
    theme: "Maintenance",
    core: "Daily movement + strength preservation",
    tip: "Keep strength twice weekly as weight comes down.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep strength twice weekly as weight comes down.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 20,
    theme: "Maintenance",
    core: "Daily movement + strength preservation",
    tip: "Plan a high-risk situation before it happens.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Plan a high-risk situation before it happens.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "weight_metabolism",
    week: 20,
    theme: "Maintenance",
    core: "Daily movement + strength preservation",
    tip: "Use the 80% routine — not perfect, just repeatable.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use the 80% routine — not perfect, just repeatable.",
    tracking: "Food-log days / walks / weight trend",
    safety: "Escalate pregnancy, eating-disorder history, diabetes meds, rapid weight change, or BMI/medical concerns.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 1,
    theme: "Walking baseline",
    core: "Aerobic base progression",
    tip: "Take one 10-minute walk at conversational pace.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take one 10-minute walk at conversational pace.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 1,
    theme: "Walking baseline",
    core: "Aerobic base progression",
    tip: "Add 1,000 steps to your usual baseline.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add 1,000 steps to your usual baseline.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 1,
    theme: "Walking baseline",
    core: "Aerobic base progression",
    tip: "Walk after lunch or dinner once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Walk after lunch or dinner once.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 1,
    theme: "Walking baseline",
    core: "Aerobic base progression",
    tip: "Use a timer, not motivation, to start.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use a timer, not motivation, to start.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 1,
    theme: "Walking baseline",
    core: "Aerobic base progression",
    tip: "Log minutes walked, not calories burned.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Log minutes walked, not calories burned.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "behavioral",
  },
  {
    category: "heart_fitness",
    week: 2,
    theme: "Build toward guideline minutes",
    core: "Aerobic base progression",
    tip: "Add 5 minutes to one walk.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add 5 minutes to one walk.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 2,
    theme: "Build toward guideline minutes",
    core: "Aerobic base progression",
    tip: "Hit 30 minutes total movement today in any pieces.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Hit 30 minutes total movement today in any pieces.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 2,
    theme: "Build toward guideline minutes",
    core: "Aerobic base progression",
    tip: "Plan 5 days with 20–30 minutes of moderate movement.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Plan 5 days with 20–30 minutes of moderate movement.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 2,
    theme: "Build toward guideline minutes",
    core: "Aerobic base progression",
    tip: "Use the talk test: you can speak but not sing.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use the talk test: you can speak but not sing.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 2,
    theme: "Build toward guideline minutes",
    core: "Aerobic base progression",
    tip: "Repeat the same dose for a week before increasing.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Repeat the same dose for a week before increasing.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 3,
    theme: "Strength foundation",
    core: "Strength + mobility support",
    tip: "Do 2 sets of sit-to-stands.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do 2 sets of sit-to-stands.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 3,
    theme: "Strength foundation",
    core: "Strength + mobility support",
    tip: "Do wall push-ups or counter push-ups.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do wall push-ups or counter push-ups.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 3,
    theme: "Strength foundation",
    core: "Strength + mobility support",
    tip: "Practice a hip hinge with no weight.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Practice a hip hinge with no weight.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 3,
    theme: "Strength foundation",
    core: "Strength + mobility support",
    tip: "Do calf raises while brushing teeth.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do calf raises while brushing teeth.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 3,
    theme: "Strength foundation",
    core: "Strength + mobility support",
    tip: "Schedule two short strength days this week.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Schedule two short strength days this week.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "behavioral",
  },
  {
    category: "heart_fitness",
    week: 4,
    theme: "Mobility and balance",
    core: "Strength + mobility support",
    tip: "Stand on one foot near support for 20 seconds.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stand on one foot near support for 20 seconds.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 4,
    theme: "Mobility and balance",
    core: "Strength + mobility support",
    tip: "Stretch calves or hips for 2 minutes.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stretch calves or hips for 2 minutes.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 4,
    theme: "Mobility and balance",
    core: "Strength + mobility support",
    tip: "Do 5 controlled step-ups if safe.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do 5 controlled step-ups if safe.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 4,
    theme: "Mobility and balance",
    core: "Strength + mobility support",
    tip: "Practice getting up from a chair without using hands.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Practice getting up from a chair without using hands.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 4,
    theme: "Mobility and balance",
    core: "Strength + mobility support",
    tip: "Add mobility after walks, not as a separate project.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add mobility after walks, not as a separate project.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 5,
    theme: "Blood pressure awareness",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Measure BP seated with feet flat if you have a cuff.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Measure BP seated with feet flat if you have a cuff.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "behavioral",
  },
  {
    category: "heart_fitness",
    week: 5,
    theme: "Blood pressure awareness",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Take two readings one minute apart.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take two readings one minute apart.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "behavioral",
  },
  {
    category: "heart_fitness",
    week: 5,
    theme: "Blood pressure awareness",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Do not diagnose from one high reading; record and follow up.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not diagnose from one high reading; record and follow up.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "behavioral",
  },
  {
    category: "heart_fitness",
    week: 5,
    theme: "Blood pressure awareness",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Bring your cuff or readings to your clinician.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Bring your cuff or readings to your clinician.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "behavioral",
  },
  {
    category: "heart_fitness",
    week: 5,
    theme: "Blood pressure awareness",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Know that 180/120 with symptoms is emergency territory.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Know that 180/120 with symptoms is emergency territory.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "behavioral",
  },
  {
    category: "heart_fitness",
    week: 6,
    theme: "Sodium and potassium foods",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Choose one lower-sodium swap today.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Choose one lower-sodium swap today.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "nutrition",
  },
  {
    category: "heart_fitness",
    week: 6,
    theme: "Sodium and potassium foods",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Add one potassium-rich food if appropriate: fruit, beans, greens, yogurt, or potato.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add one potassium-rich food if appropriate: fruit, beans, greens, yogurt, or potato.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "nutrition",
  },
  {
    category: "heart_fitness",
    week: 6,
    theme: "Sodium and potassium foods",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Read sodium on one packaged food label.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Read sodium on one packaged food label.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "nutrition",
  },
  {
    category: "heart_fitness",
    week: 6,
    theme: "Sodium and potassium foods",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Use herbs/spices before adding salt.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use herbs/spices before adding salt.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "nutrition",
  },
  {
    category: "heart_fitness",
    week: 6,
    theme: "Sodium and potassium foods",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Ask your clinician about potassium if you have kidney disease or take BP meds.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask your clinician about potassium if you have kidney disease or take BP meds.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "nutrition",
  },
  {
    category: "heart_fitness",
    week: 7,
    theme: "Cardio progression",
    core: "Aerobic base progression",
    tip: "Increase weekly cardio minutes by no more than about 10–20%.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Increase weekly cardio minutes by no more than about 10–20%.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 7,
    theme: "Cardio progression",
    core: "Aerobic base progression",
    tip: "Keep most cardio easy enough to repeat tomorrow.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep most cardio easy enough to repeat tomorrow.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 7,
    theme: "Cardio progression",
    core: "Aerobic base progression",
    tip: "Add one hill or faster minute only if your base is stable.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add one hill or faster minute only if your base is stable.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 7,
    theme: "Cardio progression",
    core: "Aerobic base progression",
    tip: "Track RPE 1–10 after walking.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track RPE 1–10 after walking.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "behavioral",
  },
  {
    category: "heart_fitness",
    week: 7,
    theme: "Cardio progression",
    core: "Aerobic base progression",
    tip: "Use recovery days as part of training.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use recovery days as part of training.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 8,
    theme: "Intervals for ready users",
    core: "Aerobic base progression",
    tip: "Add 3 x 30-second brisk intervals during a walk if already comfortable.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add 3 x 30-second brisk intervals during a walk if already comfortable.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 8,
    theme: "Intervals for ready users",
    core: "Aerobic base progression",
    tip: "Recover fully between brisk efforts.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Recover fully between brisk efforts.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 8,
    theme: "Intervals for ready users",
    core: "Aerobic base progression",
    tip: "Do not add intervals if walking already feels hard.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not add intervals if walking already feels hard.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 8,
    theme: "Intervals for ready users",
    core: "Aerobic base progression",
    tip: "Keep intervals once weekly at first.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep intervals once weekly at first.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 8,
    theme: "Intervals for ready users",
    core: "Aerobic base progression",
    tip: "Stop intervals for chest pain, dizziness, or unusual breathlessness.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stop intervals for chest pain, dizziness, or unusual breathlessness.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 9,
    theme: "Sedentary break",
    core: "Aerobic base progression",
    tip: "Stand up once every hour.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stand up once every hour.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 9,
    theme: "Sedentary break",
    core: "Aerobic base progression",
    tip: "Walk for 2 minutes after long sitting.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Walk for 2 minutes after long sitting.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 9,
    theme: "Sedentary break",
    core: "Aerobic base progression",
    tip: "Take one call standing.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take one call standing.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 9,
    theme: "Sedentary break",
    core: "Aerobic base progression",
    tip: "Use stairs once if safe.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use stairs once if safe.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 9,
    theme: "Sedentary break",
    core: "Aerobic base progression",
    tip: "Put water farther away so you have to get up.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Put water farther away so you have to get up.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 10,
    theme: "Heart-healthy plate",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Add vegetables to one meal.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add vegetables to one meal.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "nutrition",
  },
  {
    category: "heart_fitness",
    week: 10,
    theme: "Heart-healthy plate",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Choose fish, beans, poultry, tofu, or lean protein once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Choose fish, beans, poultry, tofu, or lean protein once.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "nutrition",
  },
  {
    category: "heart_fitness",
    week: 10,
    theme: "Heart-healthy plate",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Use olive oil, nuts, or avocado instead of fried foods once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use olive oil, nuts, or avocado instead of fried foods once.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "nutrition",
  },
  {
    category: "heart_fitness",
    week: 10,
    theme: "Heart-healthy plate",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Choose whole grain over refined grain once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Choose whole grain over refined grain once.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "nutrition",
  },
  {
    category: "heart_fitness",
    week: 10,
    theme: "Heart-healthy plate",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Limit one processed/high-sodium food today.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Limit one processed/high-sodium food today.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "nutrition",
  },
  {
    category: "heart_fitness",
    week: 11,
    theme: "Sleep and heart",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Protect a 7-hour sleep opportunity tonight.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Protect a 7-hour sleep opportunity tonight.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "behavioral",
  },
  {
    category: "heart_fitness",
    week: 11,
    theme: "Sleep and heart",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Screen for snoring plus daytime sleepiness.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Screen for snoring plus daytime sleepiness.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "behavioral",
  },
  {
    category: "heart_fitness",
    week: 11,
    theme: "Sleep and heart",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Move caffeine earlier to protect sleep.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Move caffeine earlier to protect sleep.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "nutrition",
  },
  {
    category: "heart_fitness",
    week: 11,
    theme: "Sleep and heart",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Keep phone out of bed tonight.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep phone out of bed tonight.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "behavioral",
  },
  {
    category: "heart_fitness",
    week: 11,
    theme: "Sleep and heart",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Treat sleep as heart training, not laziness.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Treat sleep as heart training, not laziness.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 12,
    theme: "Nicotine and exposure",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Track nicotine exposure honestly today.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track nicotine exposure honestly today.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "behavioral",
  },
  {
    category: "heart_fitness",
    week: 12,
    theme: "Nicotine and exposure",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Make one smoke-free environment choice.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Make one smoke-free environment choice.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 12,
    theme: "Nicotine and exposure",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Delay first nicotine use by 10 minutes if quitting feels too big.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Delay first nicotine use by 10 minutes if quitting feels too big.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 12,
    theme: "Nicotine and exposure",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Ask your clinician about cessation support.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask your clinician about cessation support.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "behavioral",
  },
  {
    category: "heart_fitness",
    week: 12,
    theme: "Nicotine and exposure",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Do not rely on willpower alone for tobacco cessation.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not rely on willpower alone for tobacco cessation.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 13,
    theme: "Recovery between workouts",
    core: "Strength + mobility support",
    tip: "Take an easy walk after a hard day.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take an easy walk after a hard day.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 13,
    theme: "Recovery between workouts",
    core: "Strength + mobility support",
    tip: "Do not stack hard cardio and hard strength when sore.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not stack hard cardio and hard strength when sore.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 13,
    theme: "Recovery between workouts",
    core: "Strength + mobility support",
    tip: "Use sleep quality as training feedback.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use sleep quality as training feedback.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 13,
    theme: "Recovery between workouts",
    core: "Strength + mobility support",
    tip: "Take one rest or mobility day.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take one rest or mobility day.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 13,
    theme: "Recovery between workouts",
    core: "Strength + mobility support",
    tip: "Track soreness, not just effort.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track soreness, not just effort.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "behavioral",
  },
  {
    category: "heart_fitness",
    week: 14,
    theme: "Stairs and daily cardio",
    core: "Aerobic base progression",
    tip: "Climb one flight of stairs if safe.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Climb one flight of stairs if safe.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 14,
    theme: "Stairs and daily cardio",
    core: "Aerobic base progression",
    tip: "Walk an extra lap around a store.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Walk an extra lap around a store.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 14,
    theme: "Stairs and daily cardio",
    core: "Aerobic base progression",
    tip: "Use the far bathroom once at work.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use the far bathroom once at work.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 14,
    theme: "Stairs and daily cardio",
    core: "Aerobic base progression",
    tip: "Do a 5-minute brisk walk before lunch.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do a 5-minute brisk walk before lunch.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 14,
    theme: "Stairs and daily cardio",
    core: "Aerobic base progression",
    tip: "Make daily life slightly less convenient on purpose.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Make daily life slightly less convenient on purpose.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 15,
    theme: "Doctor clearance cues",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Stop exercise for chest pain or pressure.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stop exercise for chest pain or pressure.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 15,
    theme: "Doctor clearance cues",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Stop for fainting, severe dizziness, or new irregular heartbeat.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stop for fainting, severe dizziness, or new irregular heartbeat.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 15,
    theme: "Doctor clearance cues",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Stop if breathlessness is out of proportion to effort.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stop if breathlessness is out of proportion to effort.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 15,
    theme: "Doctor clearance cues",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Report new leg swelling or unexplained fatigue.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Report new leg swelling or unexplained fatigue.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 15,
    theme: "Doctor clearance cues",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Ask for medical clearance if symptoms are present before progressing.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask for medical clearance if symptoms are present before progressing.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 16,
    theme: "Consistency over intensity",
    core: "Aerobic base progression",
    tip: "Repeat the same easy walk for 7 days.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Repeat the same easy walk for 7 days.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 16,
    theme: "Consistency over intensity",
    core: "Aerobic base progression",
    tip: "Do not chase soreness.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not chase soreness.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 16,
    theme: "Consistency over intensity",
    core: "Aerobic base progression",
    tip: "Use a calendar checkmark for movement.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use a calendar checkmark for movement.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 16,
    theme: "Consistency over intensity",
    core: "Aerobic base progression",
    tip: "Pick the easiest time of day and protect it.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Pick the easiest time of day and protect it.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 16,
    theme: "Consistency over intensity",
    core: "Aerobic base progression",
    tip: "Keep the dose small enough to repeat.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep the dose small enough to repeat.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 17,
    theme: "Strength progression",
    core: "Strength + mobility support",
    tip: "Add one set to a safe strength movement.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add one set to a safe strength movement.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 17,
    theme: "Strength progression",
    core: "Strength + mobility support",
    tip: "Slow down the lowering phase of a squat or push-up.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Slow down the lowering phase of a squat or push-up.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 17,
    theme: "Strength progression",
    core: "Strength + mobility support",
    tip: "Use a resistance band once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use a resistance band once.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 17,
    theme: "Strength progression",
    core: "Strength + mobility support",
    tip: "Practice carrying weight safely.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Practice carrying weight safely.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 17,
    theme: "Strength progression",
    core: "Strength + mobility support",
    tip: "Progress only when form stays clean.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Progress only when form stays clean.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 18,
    theme: "Metabolic heart link",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Walk after your largest carb meal.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Walk after your largest carb meal.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "nutrition",
  },
  {
    category: "heart_fitness",
    week: 18,
    theme: "Metabolic heart link",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Build a protein + fiber lunch.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Build a protein + fiber lunch.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "nutrition",
  },
  {
    category: "heart_fitness",
    week: 18,
    theme: "Metabolic heart link",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Track waist measurement monthly if appropriate.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track waist measurement monthly if appropriate.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "behavioral",
  },
  {
    category: "heart_fitness",
    week: 18,
    theme: "Metabolic heart link",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Review blood sugar labs with your clinician if elevated.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Review blood sugar labs with your clinician if elevated.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "nutrition",
  },
  {
    category: "heart_fitness",
    week: 18,
    theme: "Metabolic heart link",
    core: "Risk-factor monitoring + symptom safety",
    tip: "Treat weight, BP, sleep, and activity as one system.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Treat weight, BP, sleep, and activity as one system.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "nutrition",
  },
  {
    category: "heart_fitness",
    week: 19,
    theme: "Social fitness",
    core: "Aerobic base progression",
    tip: "Invite someone for a walk.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Invite someone for a walk.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 19,
    theme: "Social fitness",
    core: "Aerobic base progression",
    tip: "Join one low-pressure class or group walk.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Join one low-pressure class or group walk.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 19,
    theme: "Social fitness",
    core: "Aerobic base progression",
    tip: "Use accountability, not competition.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use accountability, not competition.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 19,
    theme: "Social fitness",
    core: "Aerobic base progression",
    tip: "Walk while catching up with a friend.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Walk while catching up with a friend.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 19,
    theme: "Social fitness",
    core: "Aerobic base progression",
    tip: "Choose the social activity that keeps you coming back.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Choose the social activity that keeps you coming back.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 20,
    theme: "Maintenance",
    core: "Strength + mobility support",
    tip: "Keep one aerobic anchor and one strength anchor.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep one aerobic anchor and one strength anchor.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 20,
    theme: "Maintenance",
    core: "Strength + mobility support",
    tip: "Review weekly minutes once per week.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Review weekly minutes once per week.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 20,
    theme: "Maintenance",
    core: "Strength + mobility support",
    tip: "Deload if you feel run down.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Deload if you feel run down.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 20,
    theme: "Maintenance",
    core: "Strength + mobility support",
    tip: "Update goals every 4 weeks.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Update goals every 4 weeks.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "heart_fitness",
    week: 20,
    theme: "Maintenance",
    core: "Strength + mobility support",
    tip: "Train for the life you want to keep living.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Train for the life you want to keep living.",
    tracking: "Minutes, steps, RPE, symptoms",
    safety: "Stop for chest pain, fainting, new severe shortness of breath, or neurologic symptoms.",
    mode: "physical",
  },
  {
    category: "stress_mental",
    week: 1,
    theme: "Fast downshift",
    core: "Nervous-system downshift",
    tip: "Take 5 slow breaths before responding to stress.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take 5 slow breaths before responding to stress.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "physical",
  },
  {
    category: "stress_mental",
    week: 1,
    theme: "Fast downshift",
    core: "Nervous-system downshift",
    tip: "Do two physiological sighs.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do two physiological sighs.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "physical",
  },
  {
    category: "stress_mental",
    week: 1,
    theme: "Fast downshift",
    core: "Nervous-system downshift",
    tip: "Relax jaw and shoulders three times today.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Relax jaw and shoulders three times today.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "physical",
  },
  {
    category: "stress_mental",
    week: 1,
    theme: "Fast downshift",
    core: "Nervous-system downshift",
    tip: "Put both feet on the floor and name 5 things you see.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Put both feet on the floor and name 5 things you see.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "physical",
  },
  {
    category: "stress_mental",
    week: 1,
    theme: "Fast downshift",
    core: "Nervous-system downshift",
    tip: "Use a 2-minute breathing timer before bed.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use a 2-minute breathing timer before bed.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "physical",
  },
  {
    category: "stress_mental",
    week: 2,
    theme: "Recovery block",
    core: "Recovery boundaries + workload control",
    tip: "Protect one 10-minute phone-free break.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Protect one 10-minute phone-free break.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 2,
    theme: "Recovery block",
    core: "Recovery boundaries + workload control",
    tip: "Schedule one 30-minute recovery block this week.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Schedule one 30-minute recovery block this week.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 2,
    theme: "Recovery block",
    core: "Recovery boundaries + workload control",
    tip: "Take a screen-free meal.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take a screen-free meal.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 2,
    theme: "Recovery block",
    core: "Recovery boundaries + workload control",
    tip: "Sit outside for 5 minutes with no task.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Sit outside for 5 minutes with no task.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 2,
    theme: "Recovery block",
    core: "Recovery boundaries + workload control",
    tip: "Do not turn recovery into another project.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not turn recovery into another project.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 3,
    theme: "Boundary rep",
    core: "Recovery boundaries + workload control",
    tip: "Say no to one optional request.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Say no to one optional request.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 3,
    theme: "Boundary rep",
    core: "Recovery boundaries + workload control",
    tip: "Delay an answer: 'Let me check and get back to you.'",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Delay an answer: 'Let me check and get back to you.'",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 3,
    theme: "Boundary rep",
    core: "Recovery boundaries + workload control",
    tip: "Turn off one notification.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Turn off one notification.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 3,
    theme: "Boundary rep",
    core: "Recovery boundaries + workload control",
    tip: "End work at a planned stop point once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: End work at a planned stop point once.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 3,
    theme: "Boundary rep",
    core: "Recovery boundaries + workload control",
    tip: "Do not explain a boundary more than needed.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not explain a boundary more than needed.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 4,
    theme: "Workload triage",
    core: "Recovery boundaries + workload control",
    tip: "Write your top 3 tasks only.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Write your top 3 tasks only.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 4,
    theme: "Workload triage",
    core: "Recovery boundaries + workload control",
    tip: "Move one non-urgent task to another day.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Move one non-urgent task to another day.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 4,
    theme: "Workload triage",
    core: "Recovery boundaries + workload control",
    tip: "Ask what actually has to be done today.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask what actually has to be done today.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 4,
    theme: "Workload triage",
    core: "Recovery boundaries + workload control",
    tip: "Choose a 'good enough' finish for one item.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Choose a 'good enough' finish for one item.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 4,
    theme: "Workload triage",
    core: "Recovery boundaries + workload control",
    tip: "Stop working when the planned block ends.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stop working when the planned block ends.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 5,
    theme: "Connection",
    core: "Connection + professional support when needed",
    tip: "Text one person you trust.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Text one person you trust.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 5,
    theme: "Connection",
    core: "Connection + professional support when needed",
    tip: "Ask for help with one specific thing.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask for help with one specific thing.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 5,
    theme: "Connection",
    core: "Connection + professional support when needed",
    tip: "Take a walk with someone.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take a walk with someone.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 5,
    theme: "Connection",
    core: "Connection + professional support when needed",
    tip: "Tell someone the honest version, not the polished version.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Tell someone the honest version, not the polished version.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 5,
    theme: "Connection",
    core: "Connection + professional support when needed",
    tip: "Schedule one connection before you feel isolated.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Schedule one connection before you feel isolated.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 6,
    theme: "Sleep support",
    core: "Nervous-system downshift",
    tip: "Start a 10-minute wind-down tonight.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Start a 10-minute wind-down tonight.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 6,
    theme: "Sleep support",
    core: "Nervous-system downshift",
    tip: "Write down worries before bed.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Write down worries before bed.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 6,
    theme: "Sleep support",
    core: "Nervous-system downshift",
    tip: "Keep phone out of bed once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep phone out of bed once.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 6,
    theme: "Sleep support",
    core: "Nervous-system downshift",
    tip: "Move caffeine earlier to reduce nighttime anxiety.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Move caffeine earlier to reduce nighttime anxiety.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 6,
    theme: "Sleep support",
    core: "Nervous-system downshift",
    tip: "Treat sleep as recovery, not a reward.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Treat sleep as recovery, not a reward.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 7,
    theme: "Movement for stress",
    core: "Nervous-system downshift",
    tip: "Walk 5–10 minutes when stress spikes.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Walk 5–10 minutes when stress spikes.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 7,
    theme: "Movement for stress",
    core: "Nervous-system downshift",
    tip: "Use stairs or a brisk lap to discharge adrenaline.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use stairs or a brisk lap to discharge adrenaline.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "physical",
  },
  {
    category: "stress_mental",
    week: 7,
    theme: "Movement for stress",
    core: "Nervous-system downshift",
    tip: "Stretch neck and hips for 2 minutes.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stretch neck and hips for 2 minutes.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 7,
    theme: "Movement for stress",
    core: "Nervous-system downshift",
    tip: "Do gentle movement on high-stress days instead of skipping all movement.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do gentle movement on high-stress days instead of skipping all movement.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 7,
    theme: "Movement for stress",
    core: "Nervous-system downshift",
    tip: "Notice mood before and after the walk.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Notice mood before and after the walk.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 8,
    theme: "Nature reset",
    core: "Nervous-system downshift",
    tip: "Stand outside for 5 minutes.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stand outside for 5 minutes.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 8,
    theme: "Nature reset",
    core: "Nervous-system downshift",
    tip: "Look at trees, sky, or water without a phone.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Look at trees, sky, or water without a phone.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 8,
    theme: "Nature reset",
    core: "Nervous-system downshift",
    tip: "Take one meeting or call outdoors if possible.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take one meeting or call outdoors if possible.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 8,
    theme: "Nature reset",
    core: "Nervous-system downshift",
    tip: "Eat one snack outside.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Eat one snack outside.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "nutrition",
  },
  {
    category: "stress_mental",
    week: 8,
    theme: "Nature reset",
    core: "Nervous-system downshift",
    tip: "Use daylight as a stress reset.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use daylight as a stress reset.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 9,
    theme: "Information boundaries",
    core: "Recovery boundaries + workload control",
    tip: "Check news once instead of repeatedly.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Check news once instead of repeatedly.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 9,
    theme: "Information boundaries",
    core: "Recovery boundaries + workload control",
    tip: "Move social apps off the home screen.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Move social apps off the home screen.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 9,
    theme: "Information boundaries",
    core: "Recovery boundaries + workload control",
    tip: "Use a 15-minute social media window.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use a 15-minute social media window.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 9,
    theme: "Information boundaries",
    core: "Recovery boundaries + workload control",
    tip: "Do not start the day with inbox or news.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not start the day with inbox or news.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 9,
    theme: "Information boundaries",
    core: "Recovery boundaries + workload control",
    tip: "Turn off push alerts that do not protect your life or work.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Turn off push alerts that do not protect your life or work.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 10,
    theme: "Self-talk",
    core: "Nervous-system downshift",
    tip: "Replace 'I failed' with 'That was data.'",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Replace 'I failed' with 'That was data.'",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 10,
    theme: "Self-talk",
    core: "Nervous-system downshift",
    tip: "Say: 'I can lower the bar and still move.'",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Say: 'I can lower the bar and still move.'",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 10,
    theme: "Self-talk",
    core: "Nervous-system downshift",
    tip: "Write one thing you handled today.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Write one thing you handled today.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 10,
    theme: "Self-talk",
    core: "Nervous-system downshift",
    tip: "Practice talking to yourself like a coach, not a critic.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Practice talking to yourself like a coach, not a critic.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 10,
    theme: "Self-talk",
    core: "Nervous-system downshift",
    tip: "Notice the all-or-nothing thought and choose one small action.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Notice the all-or-nothing thought and choose one small action.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 11,
    theme: "Burnout early warning",
    core: "Connection + professional support when needed",
    tip: "Rate exhaustion 1–10 daily.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Rate exhaustion 1–10 daily.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 11,
    theme: "Burnout early warning",
    core: "Connection + professional support when needed",
    tip: "Track loss of joy or emotional numbness.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track loss of joy or emotional numbness.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 11,
    theme: "Burnout early warning",
    core: "Connection + professional support when needed",
    tip: "Name one thing you are over-committed to.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Name one thing you are over-committed to.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 11,
    theme: "Burnout early warning",
    core: "Connection + professional support when needed",
    tip: "Schedule one recovery block before burnout escalates.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Schedule one recovery block before burnout escalates.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 11,
    theme: "Burnout early warning",
    core: "Connection + professional support when needed",
    tip: "Ask for professional support if recovery is not working.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask for professional support if recovery is not working.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 12,
    theme: "Professional support",
    core: "Connection + professional support when needed",
    tip: "Save your doctor/therapist/crisis contact in your phone.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Save your doctor/therapist/crisis contact in your phone.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 12,
    theme: "Professional support",
    core: "Connection + professional support when needed",
    tip: "Send one portal message if symptoms are persistent.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Send one portal message if symptoms are persistent.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 12,
    theme: "Professional support",
    core: "Connection + professional support when needed",
    tip: "Use 988 if self-harm thoughts appear.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use 988 if self-harm thoughts appear.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 12,
    theme: "Professional support",
    core: "Connection + professional support when needed",
    tip: "Tell a trusted person if you cannot function.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Tell a trusted person if you cannot function.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 12,
    theme: "Professional support",
    core: "Connection + professional support when needed",
    tip: "Do not treat crisis as a coaching issue.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not treat crisis as a coaching issue.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 13,
    theme: "Time buffers",
    core: "Recovery boundaries + workload control",
    tip: "Add 10 minutes between two commitments.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add 10 minutes between two commitments.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 13,
    theme: "Time buffers",
    core: "Recovery boundaries + workload control",
    tip: "Show up 5 minutes early once to reduce rushing.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Show up 5 minutes early once to reduce rushing.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 13,
    theme: "Time buffers",
    core: "Recovery boundaries + workload control",
    tip: "Leave one blank space on the calendar.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Leave one blank space on the calendar.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 13,
    theme: "Time buffers",
    core: "Recovery boundaries + workload control",
    tip: "Do one transition breath between work and home.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do one transition breath between work and home.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "physical",
  },
  {
    category: "stress_mental",
    week: 13,
    theme: "Time buffers",
    core: "Recovery boundaries + workload control",
    tip: "Stop stacking obligations without recovery.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stop stacking obligations without recovery.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 14,
    theme: "Gratitude and meaning",
    core: "Connection + professional support when needed",
    tip: "Write one thing that did not go wrong today.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Write one thing that did not go wrong today.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 14,
    theme: "Gratitude and meaning",
    core: "Connection + professional support when needed",
    tip: "Thank one person specifically.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Thank one person specifically.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 14,
    theme: "Gratitude and meaning",
    core: "Connection + professional support when needed",
    tip: "Notice one small win and let it count.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Notice one small win and let it count.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 14,
    theme: "Gratitude and meaning",
    core: "Connection + professional support when needed",
    tip: "Connect one hard task to why it matters.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Connect one hard task to why it matters.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 14,
    theme: "Gratitude and meaning",
    core: "Connection + professional support when needed",
    tip: "Do not use gratitude to deny real problems.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not use gratitude to deny real problems.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 15,
    theme: "Breathing variety",
    core: "Nervous-system downshift",
    tip: "Try 4-second inhale, 6-second exhale for 2 minutes.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Try 4-second inhale, 6-second exhale for 2 minutes.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "physical",
  },
  {
    category: "stress_mental",
    week: 15,
    theme: "Breathing variety",
    core: "Nervous-system downshift",
    tip: "Use box breathing for one stressful moment.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use box breathing for one stressful moment.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "physical",
  },
  {
    category: "stress_mental",
    week: 15,
    theme: "Breathing variety",
    core: "Nervous-system downshift",
    tip: "Exhale longer than inhale before a difficult conversation.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Exhale longer than inhale before a difficult conversation.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "physical",
  },
  {
    category: "stress_mental",
    week: 15,
    theme: "Breathing variety",
    core: "Nervous-system downshift",
    tip: "Pair breathing with walking if sitting still is hard.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Pair breathing with walking if sitting still is hard.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "physical",
  },
  {
    category: "stress_mental",
    week: 15,
    theme: "Breathing variety",
    core: "Nervous-system downshift",
    tip: "Stop if breathing practice makes panic worse and use grounding instead.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stop if breathing practice makes panic worse and use grounding instead.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "physical",
  },
  {
    category: "stress_mental",
    week: 16,
    theme: "Family/home stress",
    core: "Recovery boundaries + workload control",
    tip: "Ask for one household task to be shared.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask for one household task to be shared.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 16,
    theme: "Family/home stress",
    core: "Recovery boundaries + workload control",
    tip: "Create a 10-minute decompression window after work.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Create a 10-minute decompression window after work.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 16,
    theme: "Family/home stress",
    core: "Recovery boundaries + workload control",
    tip: "Do not walk into the house on your phone once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not walk into the house on your phone once.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 16,
    theme: "Family/home stress",
    core: "Recovery boundaries + workload control",
    tip: "Use a simple phrase: 'I need 10 minutes, then I’m available.'",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use a simple phrase: 'I need 10 minutes, then I’m available.'",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 16,
    theme: "Family/home stress",
    core: "Recovery boundaries + workload control",
    tip: "Plan one easy meal on a hard day.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Plan one easy meal on a hard day.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 17,
    theme: "Financial/admin stress",
    core: "Recovery boundaries + workload control",
    tip: "Set a 15-minute admin block.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Set a 15-minute admin block.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 17,
    theme: "Financial/admin stress",
    core: "Recovery boundaries + workload control",
    tip: "Open the bill or form, even if you do not finish it.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Open the bill or form, even if you do not finish it.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 17,
    theme: "Financial/admin stress",
    core: "Recovery boundaries + workload control",
    tip: "Write the next action on paper.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Write the next action on paper.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 17,
    theme: "Financial/admin stress",
    core: "Recovery boundaries + workload control",
    tip: "Ask for help with one confusing task.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask for help with one confusing task.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 17,
    theme: "Financial/admin stress",
    core: "Recovery boundaries + workload control",
    tip: "Stop after the timer and schedule the next step.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stop after the timer and schedule the next step.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 18,
    theme: "Emotional recovery",
    core: "Connection + professional support when needed",
    tip: "Name the emotion without fixing it.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Name the emotion without fixing it.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 18,
    theme: "Emotional recovery",
    core: "Connection + professional support when needed",
    tip: "Journal for 5 minutes longhand.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Journal for 5 minutes longhand.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 18,
    theme: "Emotional recovery",
    core: "Connection + professional support when needed",
    tip: "Take a slow walk before making a major decision.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take a slow walk before making a major decision.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 18,
    theme: "Emotional recovery",
    core: "Connection + professional support when needed",
    tip: "Share the real issue with one trusted person.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Share the real issue with one trusted person.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 18,
    theme: "Emotional recovery",
    core: "Connection + professional support when needed",
    tip: "Seek professional support for grief, trauma, or persistent depression.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Seek professional support for grief, trauma, or persistent depression.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 19,
    theme: "Relapse plan",
    core: "Nervous-system downshift",
    tip: "Choose the smallest action for bad days: breathe, walk, eat, sleep.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Choose the smallest action for bad days: breathe, walk, eat, sleep.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "physical",
  },
  {
    category: "stress_mental",
    week: 19,
    theme: "Relapse plan",
    core: "Nervous-system downshift",
    tip: "Create a 'when I spiral' note in your phone.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Create a 'when I spiral' note in your phone.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 19,
    theme: "Relapse plan",
    core: "Nervous-system downshift",
    tip: "Repeat last week’s habit instead of adding more.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Repeat last week’s habit instead of adding more.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 19,
    theme: "Relapse plan",
    core: "Nervous-system downshift",
    tip: "Reduce goals by half during overload.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Reduce goals by half during overload.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 19,
    theme: "Relapse plan",
    core: "Nervous-system downshift",
    tip: "Judge the restart, not the stumble.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Judge the restart, not the stumble.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 20,
    theme: "Maintenance",
    core: "Recovery boundaries + workload control",
    tip: "Keep one downshift skill that works.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep one downshift skill that works.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 20,
    theme: "Maintenance",
    core: "Recovery boundaries + workload control",
    tip: "Keep one boundary that gives energy back.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep one boundary that gives energy back.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 20,
    theme: "Maintenance",
    core: "Recovery boundaries + workload control",
    tip: "Review stress score weekly.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Review stress score weekly.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 20,
    theme: "Maintenance",
    core: "Recovery boundaries + workload control",
    tip: "Schedule connection before isolation builds.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Schedule connection before isolation builds.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "stress_mental",
    week: 20,
    theme: "Maintenance",
    core: "Recovery boundaries + workload control",
    tip: "Get support early, not only when things break.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Get support early, not only when things break.",
    tracking: "Stress 1–10 / recovery blocks / support action",
    safety: "Escalate self-harm thoughts, inability to function, severe depression/panic, or substance crisis.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 1,
    theme: "Hydration start",
    core: "Sleep/hydration/fueling baseline",
    tip: "Drink 16 oz water within 30 minutes of waking.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Drink 16 oz water within 30 minutes of waking.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 1,
    theme: "Hydration start",
    core: "Sleep/hydration/fueling baseline",
    tip: "Drink water before coffee.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Drink water before coffee.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 1,
    theme: "Hydration start",
    core: "Sleep/hydration/fueling baseline",
    tip: "Keep water visible at your desk.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep water visible at your desk.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 1,
    theme: "Hydration start",
    core: "Sleep/hydration/fueling baseline",
    tip: "Add electrolytes only if appropriate for your health and sweat level.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add electrolytes only if appropriate for your health and sweat level.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 1,
    theme: "Hydration start",
    core: "Sleep/hydration/fueling baseline",
    tip: "Track urine color once without obsessing.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track urine color once without obsessing.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 2,
    theme: "Protein breakfast",
    core: "Sleep/hydration/fueling baseline",
    tip: "Eat protein at breakfast or first meal.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Eat protein at breakfast or first meal.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 2,
    theme: "Protein breakfast",
    core: "Sleep/hydration/fueling baseline",
    tip: "Add Greek yogurt, eggs, cottage cheese, tofu, or protein shake once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add Greek yogurt, eggs, cottage cheese, tofu, or protein shake once.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 2,
    theme: "Protein breakfast",
    core: "Sleep/hydration/fueling baseline",
    tip: "Do not let breakfast be only sugar/starch.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not let breakfast be only sugar/starch.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 2,
    theme: "Protein breakfast",
    core: "Sleep/hydration/fueling baseline",
    tip: "Pair fruit with protein.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Pair fruit with protein.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 2,
    theme: "Protein breakfast",
    core: "Sleep/hydration/fueling baseline",
    tip: "Notice mid-morning energy after a protein meal.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Notice mid-morning energy after a protein meal.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 3,
    theme: "Blood sugar steadiness",
    core: "Blood-sugar + caffeine timing",
    tip: "Pair carbs with protein, fat, or fiber.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Pair carbs with protein, fat, or fiber.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 3,
    theme: "Blood sugar steadiness",
    core: "Blood-sugar + caffeine timing",
    tip: "Take a 10-minute walk after lunch.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take a 10-minute walk after lunch.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 3,
    theme: "Blood sugar steadiness",
    core: "Blood-sugar + caffeine timing",
    tip: "Avoid a carb-only afternoon snack.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Avoid a carb-only afternoon snack.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 3,
    theme: "Blood sugar steadiness",
    core: "Blood-sugar + caffeine timing",
    tip: "Add vegetables or beans to one meal.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add vegetables or beans to one meal.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 3,
    theme: "Blood sugar steadiness",
    core: "Blood-sugar + caffeine timing",
    tip: "Track the crash time if it happens.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track the crash time if it happens.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 4,
    theme: "Caffeine timing",
    core: "Blood-sugar + caffeine timing",
    tip: "Set caffeine cutoff at least 8 hours before sleep.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Set caffeine cutoff at least 8 hours before sleep.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 4,
    theme: "Caffeine timing",
    core: "Blood-sugar + caffeine timing",
    tip: "Delay caffeine 30–60 minutes after waking if tolerated.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Delay caffeine 30–60 minutes after waking if tolerated.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 4,
    theme: "Caffeine timing",
    core: "Blood-sugar + caffeine timing",
    tip: "Swap late caffeine for a walk.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Swap late caffeine for a walk.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 4,
    theme: "Caffeine timing",
    core: "Blood-sugar + caffeine timing",
    tip: "Count cups honestly for one day.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Count cups honestly for one day.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 4,
    theme: "Caffeine timing",
    core: "Blood-sugar + caffeine timing",
    tip: "Reduce total caffeine slowly, not cold turkey.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Reduce total caffeine slowly, not cold turkey.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 5,
    theme: "Sleep opportunity",
    core: "Sleep/hydration/fueling baseline",
    tip: "Give yourself a 7-hour sleep opportunity tonight.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Give yourself a 7-hour sleep opportunity tonight.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 5,
    theme: "Sleep opportunity",
    core: "Sleep/hydration/fueling baseline",
    tip: "Move bedtime 15 minutes earlier once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Move bedtime 15 minutes earlier once.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 5,
    theme: "Sleep opportunity",
    core: "Sleep/hydration/fueling baseline",
    tip: "Keep wake time stable even after a rough night.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep wake time stable even after a rough night.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 5,
    theme: "Sleep opportunity",
    core: "Sleep/hydration/fueling baseline",
    tip: "Keep phone out of bed tonight.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep phone out of bed tonight.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 5,
    theme: "Sleep opportunity",
    core: "Sleep/hydration/fueling baseline",
    tip: "Track sleep hours and energy the next day.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track sleep hours and energy the next day.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 6,
    theme: "Movement breaks",
    core: "Movement breaks + medical rule-out",
    tip: "Take three 2-minute movement breaks.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take three 2-minute movement breaks.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 6,
    theme: "Movement breaks",
    core: "Movement breaks + medical rule-out",
    tip: "Stand during one call.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stand during one call.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 6,
    theme: "Movement breaks",
    core: "Movement breaks + medical rule-out",
    tip: "Walk 5 minutes when energy drops.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Walk 5 minutes when energy drops.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 6,
    theme: "Movement breaks",
    core: "Movement breaks + medical rule-out",
    tip: "Use stairs once if safe.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use stairs once if safe.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 6,
    theme: "Movement breaks",
    core: "Movement breaks + medical rule-out",
    tip: "Set a timer instead of relying on memory.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Set a timer instead of relying on memory.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 7,
    theme: "Morning light",
    core: "Sleep/hydration/fueling baseline",
    tip: "Step outside for 5 minutes in the morning.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Step outside for 5 minutes in the morning.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 7,
    theme: "Morning light",
    core: "Sleep/hydration/fueling baseline",
    tip: "Open blinds immediately.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Open blinds immediately.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 7,
    theme: "Morning light",
    core: "Sleep/hydration/fueling baseline",
    tip: "Take coffee near outdoor light.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take coffee near outdoor light.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 7,
    theme: "Morning light",
    core: "Sleep/hydration/fueling baseline",
    tip: "Use bright indoor light if sunrise is later.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use bright indoor light if sunrise is later.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 7,
    theme: "Morning light",
    core: "Sleep/hydration/fueling baseline",
    tip: "Do not start the day in a dark room if you can avoid it.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not start the day in a dark room if you can avoid it.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 8,
    theme: "Afternoon dip",
    core: "Blood-sugar + caffeine timing",
    tip: "Drink water before treating the dip with caffeine.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Drink water before treating the dip with caffeine.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 8,
    theme: "Afternoon dip",
    core: "Blood-sugar + caffeine timing",
    tip: "Walk 5–10 minutes after lunch.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Walk 5–10 minutes after lunch.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 8,
    theme: "Afternoon dip",
    core: "Blood-sugar + caffeine timing",
    tip: "Check whether lunch was mostly refined carbs.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Check whether lunch was mostly refined carbs.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 8,
    theme: "Afternoon dip",
    core: "Blood-sugar + caffeine timing",
    tip: "Try a protein/fiber snack if truly hungry.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Try a protein/fiber snack if truly hungry.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 8,
    theme: "Afternoon dip",
    core: "Blood-sugar + caffeine timing",
    tip: "Take a 10–20 minute nap only if it does not hurt sleep.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take a 10–20 minute nap only if it does not hurt sleep.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 9,
    theme: "Meal rhythm",
    core: "Sleep/hydration/fueling baseline",
    tip: "Eat three real meals or two meals plus one planned snack.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Eat three real meals or two meals plus one planned snack.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 9,
    theme: "Meal rhythm",
    core: "Sleep/hydration/fueling baseline",
    tip: "Do not skip meals on severe fatigue days.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not skip meals on severe fatigue days.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 9,
    theme: "Meal rhythm",
    core: "Sleep/hydration/fueling baseline",
    tip: "Plan tomorrow’s first meal tonight.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Plan tomorrow’s first meal tonight.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 9,
    theme: "Meal rhythm",
    core: "Sleep/hydration/fueling baseline",
    tip: "Keep an emergency protein option available.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep an emergency protein option available.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 9,
    theme: "Meal rhythm",
    core: "Sleep/hydration/fueling baseline",
    tip: "Track whether long gaps worsen energy.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track whether long gaps worsen energy.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 10,
    theme: "Medical rule-out",
    core: "Movement breaks + medical rule-out",
    tip: "Schedule bloodwork if fatigue lasts 3–4 weeks despite basics.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Schedule bloodwork if fatigue lasts 3–4 weeks despite basics.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 10,
    theme: "Medical rule-out",
    core: "Movement breaks + medical rule-out",
    tip: "Ask about thyroid, anemia/iron, B12, vitamin D, sleep apnea, depression, and medication effects.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask about thyroid, anemia/iron, B12, vitamin D, sleep apnea, depression, and medication effects.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 10,
    theme: "Medical rule-out",
    core: "Movement breaks + medical rule-out",
    tip: "Escalate fatigue with chest pain or shortness of breath.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Escalate fatigue with chest pain or shortness of breath.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 10,
    theme: "Medical rule-out",
    core: "Movement breaks + medical rule-out",
    tip: "Do not push intense workouts during severe fatigue.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not push intense workouts during severe fatigue.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 10,
    theme: "Medical rule-out",
    core: "Movement breaks + medical rule-out",
    tip: "Write symptom patterns before the appointment.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Write symptom patterns before the appointment.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 11,
    theme: "Recovery pacing",
    core: "Movement breaks + medical rule-out",
    tip: "Use gentle walking, not intense training, when depleted.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use gentle walking, not intense training, when depleted.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 11,
    theme: "Recovery pacing",
    core: "Movement breaks + medical rule-out",
    tip: "Stop before you crash.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stop before you crash.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 11,
    theme: "Recovery pacing",
    core: "Movement breaks + medical rule-out",
    tip: "Schedule one true rest block.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Schedule one true rest block.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 11,
    theme: "Recovery pacing",
    core: "Movement breaks + medical rule-out",
    tip: "Rate energy morning and afternoon.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Rate energy morning and afternoon.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 11,
    theme: "Recovery pacing",
    core: "Movement breaks + medical rule-out",
    tip: "Repeat a manageable dose instead of chasing a comeback.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Repeat a manageable dose instead of chasing a comeback.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 12,
    theme: "Stress load",
    core: "Sleep/hydration/fueling baseline",
    tip: "Identify one energy drain you can remove.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Identify one energy drain you can remove.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 12,
    theme: "Stress load",
    core: "Sleep/hydration/fueling baseline",
    tip: "Take a phone-free 10-minute break.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take a phone-free 10-minute break.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 12,
    theme: "Stress load",
    core: "Sleep/hydration/fueling baseline",
    tip: "Practice 2 minutes of slow breathing.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Practice 2 minutes of slow breathing.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 12,
    theme: "Stress load",
    core: "Sleep/hydration/fueling baseline",
    tip: "Set one boundary around after-hours work.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Set one boundary around after-hours work.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 12,
    theme: "Stress load",
    core: "Sleep/hydration/fueling baseline",
    tip: "Ask for help before exhaustion becomes normal.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask for help before exhaustion becomes normal.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 13,
    theme: "Nutrient density",
    core: "Sleep/hydration/fueling baseline",
    tip: "Add one colorful fruit or vegetable.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add one colorful fruit or vegetable.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 13,
    theme: "Nutrient density",
    core: "Sleep/hydration/fueling baseline",
    tip: "Choose iron-rich or protein-rich food once if appropriate.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Choose iron-rich or protein-rich food once if appropriate.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 13,
    theme: "Nutrient density",
    core: "Sleep/hydration/fueling baseline",
    tip: "Add omega-3-rich fish or walnuts/chia/flax once this week.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add omega-3-rich fish or walnuts/chia/flax once this week.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 13,
    theme: "Nutrient density",
    core: "Sleep/hydration/fueling baseline",
    tip: "Do not start many supplements without labs or clinician input.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not start many supplements without labs or clinician input.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 13,
    theme: "Nutrient density",
    core: "Sleep/hydration/fueling baseline",
    tip: "Use food quality before chasing stimulants.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use food quality before chasing stimulants.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 14,
    theme: "Alcohol and energy",
    core: "Blood-sugar + caffeine timing",
    tip: "Notice sleep quality after alcohol.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Notice sleep quality after alcohol.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 14,
    theme: "Alcohol and energy",
    core: "Blood-sugar + caffeine timing",
    tip: "Choose one alcohol-free night.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Choose one alcohol-free night.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 14,
    theme: "Alcohol and energy",
    core: "Blood-sugar + caffeine timing",
    tip: "Stop alcohol several hours before sleep if you drink.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stop alcohol several hours before sleep if you drink.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 14,
    theme: "Alcohol and energy",
    core: "Blood-sugar + caffeine timing",
    tip: "Replace a drink with sparkling water once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Replace a drink with sparkling water once.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 14,
    theme: "Alcohol and energy",
    core: "Blood-sugar + caffeine timing",
    tip: "Track next-day energy after an alcohol-free night.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track next-day energy after an alcohol-free night.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 15,
    theme: "Desk setup",
    core: "Movement breaks + medical rule-out",
    tip: "Put water far enough away that you stand to refill.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Put water far enough away that you stand to refill.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 15,
    theme: "Desk setup",
    core: "Movement breaks + medical rule-out",
    tip: "Set a standing reminder mid-morning.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Set a standing reminder mid-morning.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 15,
    theme: "Desk setup",
    core: "Movement breaks + medical rule-out",
    tip: "Move printer/trash farther if safe.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Move printer/trash farther if safe.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 15,
    theme: "Desk setup",
    core: "Movement breaks + medical rule-out",
    tip: "Use a walking meeting once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use a walking meeting once.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 15,
    theme: "Desk setup",
    core: "Movement breaks + medical rule-out",
    tip: "Make movement easier than staying stuck.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Make movement easier than staying stuck.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 16,
    theme: "Sunset and wind-down",
    core: "Sleep/hydration/fueling baseline",
    tip: "Dim lights 30 minutes before sleep.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Dim lights 30 minutes before sleep.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 16,
    theme: "Sunset and wind-down",
    core: "Sleep/hydration/fueling baseline",
    tip: "Stop work email during wind-down.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stop work email during wind-down.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 16,
    theme: "Sunset and wind-down",
    core: "Sleep/hydration/fueling baseline",
    tip: "Write tomorrow’s task list before bed.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Write tomorrow’s task list before bed.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 16,
    theme: "Sunset and wind-down",
    core: "Sleep/hydration/fueling baseline",
    tip: "Keep phone away from the bed.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep phone away from the bed.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 16,
    theme: "Sunset and wind-down",
    core: "Sleep/hydration/fueling baseline",
    tip: "Use a boring routine to lower nighttime activation.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use a boring routine to lower nighttime activation.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 17,
    theme: "Illness recovery",
    core: "Movement breaks + medical rule-out",
    tip: "Use shorter movement after illness.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use shorter movement after illness.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 17,
    theme: "Illness recovery",
    core: "Movement breaks + medical rule-out",
    tip: "Prioritize sleep and fluids.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Prioritize sleep and fluids.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 17,
    theme: "Illness recovery",
    core: "Movement breaks + medical rule-out",
    tip: "Do not resume hard exercise while symptoms are active.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not resume hard exercise while symptoms are active.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 17,
    theme: "Illness recovery",
    core: "Movement breaks + medical rule-out",
    tip: "Increase activity gradually as energy returns.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Increase activity gradually as energy returns.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 17,
    theme: "Illness recovery",
    core: "Movement breaks + medical rule-out",
    tip: "Seek care for persistent fever, shortness of breath, chest pain, or worsening symptoms.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Seek care for persistent fever, shortness of breath, chest pain, or worsening symptoms.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "physical",
  },
  {
    category: "energy_fatigue",
    week: 18,
    theme: "Motivation vs physiology",
    core: "Sleep/hydration/fueling baseline",
    tip: "Do not call fatigue laziness.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not call fatigue laziness.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 18,
    theme: "Motivation vs physiology",
    core: "Sleep/hydration/fueling baseline",
    tip: "Fix one physical input before blaming discipline.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Fix one physical input before blaming discipline.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 18,
    theme: "Motivation vs physiology",
    core: "Sleep/hydration/fueling baseline",
    tip: "Choose water, meal, walk, or sleep as today’s win.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Choose water, meal, walk, or sleep as today’s win.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 18,
    theme: "Motivation vs physiology",
    core: "Sleep/hydration/fueling baseline",
    tip: "Repeat the smallest helpful habit for a week.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Repeat the smallest helpful habit for a week.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 18,
    theme: "Motivation vs physiology",
    core: "Sleep/hydration/fueling baseline",
    tip: "Use data to identify the weak link.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use data to identify the weak link.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 19,
    theme: "Supplements caution",
    core: "Movement breaks + medical rule-out",
    tip: "Do not add a stimulant stack for fatigue.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not add a stimulant stack for fatigue.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 19,
    theme: "Supplements caution",
    core: "Movement breaks + medical rule-out",
    tip: "Check medication interactions before supplements.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Check medication interactions before supplements.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 19,
    theme: "Supplements caution",
    core: "Movement breaks + medical rule-out",
    tip: "Use labs to guide iron, B12, vitamin D, or thyroid conversations.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use labs to guide iron, B12, vitamin D, or thyroid conversations.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 19,
    theme: "Supplements caution",
    core: "Movement breaks + medical rule-out",
    tip: "Start one change at a time.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Start one change at a time.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 19,
    theme: "Supplements caution",
    core: "Movement breaks + medical rule-out",
    tip: "Track effects and side effects.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track effects and side effects.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "behavioral",
  },
  {
    category: "energy_fatigue",
    week: 20,
    theme: "Maintenance",
    core: "Blood-sugar + caffeine timing",
    tip: "Keep the one habit that lifted energy most.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep the one habit that lifted energy most.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 20,
    theme: "Maintenance",
    core: "Blood-sugar + caffeine timing",
    tip: "Review sleep, food, caffeine, movement every Sunday.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Review sleep, food, caffeine, movement every Sunday.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 20,
    theme: "Maintenance",
    core: "Blood-sugar + caffeine timing",
    tip: "Have a low-energy day plan ready.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Have a low-energy day plan ready.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 20,
    theme: "Maintenance",
    core: "Blood-sugar + caffeine timing",
    tip: "Use medical care if basics stop helping.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use medical care if basics stop helping.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "energy_fatigue",
    week: 20,
    theme: "Maintenance",
    core: "Blood-sugar + caffeine timing",
    tip: "Protect energy before adding more goals.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Protect energy before adding more goals.",
    tracking: "Energy 1–10 / sleep / meals / caffeine cutoff",
    safety: "Escalate severe fatigue, weight change, shortness of breath, chest pain, fainting, or persistent fatigue >3–4 weeks.",
    mode: "nutrition",
  },
  {
    category: "brain_performance",
    week: 1,
    theme: "Single-focus block",
    core: "Focus environment + single-tasking",
    tip: "Do one 20-minute focus block with notifications off.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do one 20-minute focus block with notifications off.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 1,
    theme: "Single-focus block",
    core: "Focus environment + single-tasking",
    tip: "Put your phone in another room during focus.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Put your phone in another room during focus.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 1,
    theme: "Single-focus block",
    core: "Focus environment + single-tasking",
    tip: "Define the task before the timer starts.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Define the task before the timer starts.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 1,
    theme: "Single-focus block",
    core: "Focus environment + single-tasking",
    tip: "Use one browser tab if possible.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use one browser tab if possible.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 1,
    theme: "Single-focus block",
    core: "Focus environment + single-tasking",
    tip: "End with a one-sentence summary of what got done.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: End with a one-sentence summary of what got done.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 2,
    theme: "Distraction audit",
    core: "Focus environment + single-tasking",
    tip: "Write down the top 3 distractions today.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Write down the top 3 distractions today.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 2,
    theme: "Distraction audit",
    core: "Focus environment + single-tasking",
    tip: "Remove one app from your home screen.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Remove one app from your home screen.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 2,
    theme: "Distraction audit",
    core: "Focus environment + single-tasking",
    tip: "Turn off one non-essential notification.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Turn off one non-essential notification.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 2,
    theme: "Distraction audit",
    core: "Focus environment + single-tasking",
    tip: "Check email at planned times, not continuously.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Check email at planned times, not continuously.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 2,
    theme: "Distraction audit",
    core: "Focus environment + single-tasking",
    tip: "Track how often you context-switch for one hour.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track how often you context-switch for one hour.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 3,
    theme: "Deep work ramp",
    core: "Focus environment + single-tasking",
    tip: "Start with 10 minutes if 25 feels too long.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Start with 10 minutes if 25 feels too long.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 3,
    theme: "Deep work ramp",
    core: "Focus environment + single-tasking",
    tip: "Add 5 minutes to one focus block.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add 5 minutes to one focus block.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 3,
    theme: "Deep work ramp",
    core: "Focus environment + single-tasking",
    tip: "Schedule focus before reactive work.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Schedule focus before reactive work.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 3,
    theme: "Deep work ramp",
    core: "Focus environment + single-tasking",
    tip: "Use headphones or a visual do-not-disturb cue.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use headphones or a visual do-not-disturb cue.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 3,
    theme: "Deep work ramp",
    core: "Focus environment + single-tasking",
    tip: "Repeat the same focus time tomorrow.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Repeat the same focus time tomorrow.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "nutrition",
  },
  {
    category: "brain_performance",
    week: 4,
    theme: "Movement for cognition",
    core: "Physical brain-health inputs",
    tip: "Take a 10-minute walk before hard thinking.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take a 10-minute walk before hard thinking.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "physical",
  },
  {
    category: "brain_performance",
    week: 4,
    theme: "Movement for cognition",
    core: "Physical brain-health inputs",
    tip: "Use stairs or light movement to break brain fog.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use stairs or light movement to break brain fog.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "physical",
  },
  {
    category: "brain_performance",
    week: 4,
    theme: "Movement for cognition",
    core: "Physical brain-health inputs",
    tip: "Walk outdoors when possible.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Walk outdoors when possible.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "physical",
  },
  {
    category: "brain_performance",
    week: 4,
    theme: "Movement for cognition",
    core: "Physical brain-health inputs",
    tip: "Track focus before and after movement.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track focus before and after movement.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 4,
    theme: "Movement for cognition",
    core: "Physical brain-health inputs",
    tip: "Treat movement as brain prep, not just fitness.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Treat movement as brain prep, not just fitness.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 5,
    theme: "Sleep for brain",
    core: "Physical brain-health inputs",
    tip: "Protect a 7-hour sleep opportunity.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Protect a 7-hour sleep opportunity.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 5,
    theme: "Sleep for brain",
    core: "Physical brain-health inputs",
    tip: "Keep wake time steady.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep wake time steady.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 5,
    theme: "Sleep for brain",
    core: "Physical brain-health inputs",
    tip: "Phone charges away from bed.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Phone charges away from bed.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 5,
    theme: "Sleep for brain",
    core: "Physical brain-health inputs",
    tip: "Dim lights before sleep.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Dim lights before sleep.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 5,
    theme: "Sleep for brain",
    core: "Physical brain-health inputs",
    tip: "Notice whether sleep drives next-day focus.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Notice whether sleep drives next-day focus.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 6,
    theme: "Learning practice",
    core: "Learning, recall, and social engagement",
    tip: "Learn one small thing for 10 minutes.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Learn one small thing for 10 minutes.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 6,
    theme: "Learning practice",
    core: "Learning, recall, and social engagement",
    tip: "Summarize from memory without looking.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Summarize from memory without looking.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 6,
    theme: "Learning practice",
    core: "Learning, recall, and social engagement",
    tip: "Teach the idea to someone or write it in plain English.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Teach the idea to someone or write it in plain English.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 6,
    theme: "Learning practice",
    core: "Learning, recall, and social engagement",
    tip: "Review yesterday’s learning for 2 minutes.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Review yesterday’s learning for 2 minutes.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 6,
    theme: "Learning practice",
    core: "Learning, recall, and social engagement",
    tip: "Use recall, not rereading, as the win.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use recall, not rereading, as the win.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 7,
    theme: "Reading and notes",
    core: "Learning, recall, and social engagement",
    tip: "Read 5 pages or 10 minutes.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Read 5 pages or 10 minutes.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 7,
    theme: "Reading and notes",
    core: "Learning, recall, and social engagement",
    tip: "Write one useful takeaway.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Write one useful takeaway.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 7,
    theme: "Reading and notes",
    core: "Learning, recall, and social engagement",
    tip: "Highlight less, summarize more.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Highlight less, summarize more.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 7,
    theme: "Reading and notes",
    core: "Learning, recall, and social engagement",
    tip: "Turn one idea into an action.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Turn one idea into an action.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 7,
    theme: "Reading and notes",
    core: "Learning, recall, and social engagement",
    tip: "Review notes once at the end of the week.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Review notes once at the end of the week.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 8,
    theme: "Brain fog basics",
    core: "Physical brain-health inputs",
    tip: "Drink water and eat protein/fiber before assuming brain fog is cognitive.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Drink water and eat protein/fiber before assuming brain fog is cognitive.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "nutrition",
  },
  {
    category: "brain_performance",
    week: 8,
    theme: "Brain fog basics",
    core: "Physical brain-health inputs",
    tip: "Take a 5-minute light break.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take a 5-minute light break.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 8,
    theme: "Brain fog basics",
    core: "Physical brain-health inputs",
    tip: "Check sleep from the last two nights.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Check sleep from the last two nights.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 8,
    theme: "Brain fog basics",
    core: "Physical brain-health inputs",
    tip: "Walk before caffeine if the fog appears mid-afternoon.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Walk before caffeine if the fog appears mid-afternoon.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 8,
    theme: "Brain fog basics",
    core: "Physical brain-health inputs",
    tip: "Seek medical review if fog is new, severe, or persistent.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Seek medical review if fog is new, severe, or persistent.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 9,
    theme: "Planning memory",
    core: "Focus environment + single-tasking",
    tip: "Write tomorrow’s top 3 tasks tonight.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Write tomorrow’s top 3 tasks tonight.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 9,
    theme: "Planning memory",
    core: "Focus environment + single-tasking",
    tip: "Use one capture place for reminders.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use one capture place for reminders.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 9,
    theme: "Planning memory",
    core: "Focus environment + single-tasking",
    tip: "Do not rely on memory for errands.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not rely on memory for errands.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 9,
    theme: "Planning memory",
    core: "Focus environment + single-tasking",
    tip: "Make the next step visible.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Make the next step visible.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "physical",
  },
  {
    category: "brain_performance",
    week: 9,
    theme: "Planning memory",
    core: "Focus environment + single-tasking",
    tip: "Review the list at the start of your workday.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Review the list at the start of your workday.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 10,
    theme: "Social brain",
    core: "Learning, recall, and social engagement",
    tip: "Have one real conversation without multitasking.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Have one real conversation without multitasking.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 10,
    theme: "Social brain",
    core: "Learning, recall, and social engagement",
    tip: "Call someone instead of only texting once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Call someone instead of only texting once.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 10,
    theme: "Social brain",
    core: "Learning, recall, and social engagement",
    tip: "Join one group, class, or community touchpoint.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Join one group, class, or community touchpoint.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 10,
    theme: "Social brain",
    core: "Learning, recall, and social engagement",
    tip: "Ask one person a thoughtful question.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask one person a thoughtful question.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 10,
    theme: "Social brain",
    core: "Learning, recall, and social engagement",
    tip: "Use social contact as brain health, not only mood support.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use social contact as brain health, not only mood support.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 11,
    theme: "Hearing and vision",
    core: "Physical brain-health inputs",
    tip: "Schedule hearing or vision check if you notice changes.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Schedule hearing or vision check if you notice changes.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 11,
    theme: "Hearing and vision",
    core: "Physical brain-health inputs",
    tip: "Do not ignore hearing loss in conversations.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not ignore hearing loss in conversations.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 11,
    theme: "Hearing and vision",
    core: "Physical brain-health inputs",
    tip: "Use glasses/hearing aids consistently if prescribed.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use glasses/hearing aids consistently if prescribed.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 11,
    theme: "Hearing and vision",
    core: "Physical brain-health inputs",
    tip: "Reduce background noise for important conversations.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Reduce background noise for important conversations.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 11,
    theme: "Hearing and vision",
    core: "Physical brain-health inputs",
    tip: "Tell your clinician about new hearing or vision changes.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Tell your clinician about new hearing or vision changes.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 12,
    theme: "Blood pressure and brain",
    core: "Physical brain-health inputs",
    tip: "Check BP if you have a cuff and risk factors.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Check BP if you have a cuff and risk factors.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 12,
    theme: "Blood pressure and brain",
    core: "Physical brain-health inputs",
    tip: "Track readings properly, not randomly.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track readings properly, not randomly.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 12,
    theme: "Blood pressure and brain",
    core: "Physical brain-health inputs",
    tip: "Share patterns with your clinician.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Share patterns with your clinician.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 12,
    theme: "Blood pressure and brain",
    core: "Physical brain-health inputs",
    tip: "Walk and reduce sodium as brain-health supports.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Walk and reduce sodium as brain-health supports.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 12,
    theme: "Blood pressure and brain",
    core: "Physical brain-health inputs",
    tip: "Do not ignore high readings.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not ignore high readings.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 13,
    theme: "Nutrition and brain",
    core: "Physical brain-health inputs",
    tip: "Add one protein + fiber meal.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add one protein + fiber meal.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "nutrition",
  },
  {
    category: "brain_performance",
    week: 13,
    theme: "Nutrition and brain",
    core: "Physical brain-health inputs",
    tip: "Choose fish, olive oil, nuts, beans, greens, or berries once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Choose fish, olive oil, nuts, beans, greens, or berries once.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 13,
    theme: "Nutrition and brain",
    core: "Physical brain-health inputs",
    tip: "Reduce a sugary drink once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Reduce a sugary drink once.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "nutrition",
  },
  {
    category: "brain_performance",
    week: 13,
    theme: "Nutrition and brain",
    core: "Physical brain-health inputs",
    tip: "Do not work through hunger and call it focus.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not work through hunger and call it focus.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 13,
    theme: "Nutrition and brain",
    core: "Physical brain-health inputs",
    tip: "Track whether lunch improves or hurts afternoon focus.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track whether lunch improves or hurts afternoon focus.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 14,
    theme: "Creative work",
    core: "Learning, recall, and social engagement",
    tip: "Spend 10 minutes making something.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Spend 10 minutes making something.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 14,
    theme: "Creative work",
    core: "Learning, recall, and social engagement",
    tip: "Write before consuming content.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Write before consuming content.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 14,
    theme: "Creative work",
    core: "Learning, recall, and social engagement",
    tip: "Keep one idea notebook.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep one idea notebook.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 14,
    theme: "Creative work",
    core: "Learning, recall, and social engagement",
    tip: "Use a bad first draft as the goal.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use a bad first draft as the goal.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 14,
    theme: "Creative work",
    core: "Learning, recall, and social engagement",
    tip: "Do not judge creative reps by quality.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not judge creative reps by quality.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 15,
    theme: "Task switching",
    core: "Focus environment + single-tasking",
    tip: "Batch small tasks into one block.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Batch small tasks into one block.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 15,
    theme: "Task switching",
    core: "Focus environment + single-tasking",
    tip: "Do not leave email open during writing or thinking.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not leave email open during writing or thinking.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 15,
    theme: "Task switching",
    core: "Focus environment + single-tasking",
    tip: "Finish one task to a clear stopping point.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Finish one task to a clear stopping point.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 15,
    theme: "Task switching",
    core: "Focus environment + single-tasking",
    tip: "Write 'parking lot' ideas instead of chasing them.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Write 'parking lot' ideas instead of chasing them.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 15,
    theme: "Task switching",
    core: "Focus environment + single-tasking",
    tip: "Use a 5-minute transition after meetings.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use a 5-minute transition after meetings.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 16,
    theme: "Environment design",
    core: "Focus environment + single-tasking",
    tip: "Clear one surface before a focus block.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Clear one surface before a focus block.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 16,
    theme: "Environment design",
    core: "Focus environment + single-tasking",
    tip: "Keep water and notes ready.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep water and notes ready.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "nutrition",
  },
  {
    category: "brain_performance",
    week: 16,
    theme: "Environment design",
    core: "Focus environment + single-tasking",
    tip: "Put distracting devices out of sight.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Put distracting devices out of sight.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 16,
    theme: "Environment design",
    core: "Focus environment + single-tasking",
    tip: "Use the same workspace cue for deep work.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use the same workspace cue for deep work.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "physical",
  },
  {
    category: "brain_performance",
    week: 16,
    theme: "Environment design",
    core: "Focus environment + single-tasking",
    tip: "End the day by resetting the workspace.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: End the day by resetting the workspace.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "physical",
  },
  {
    category: "brain_performance",
    week: 17,
    theme: "Mood and cognition",
    core: "Physical brain-health inputs",
    tip: "Rate mood before starting work.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Rate mood before starting work.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 17,
    theme: "Mood and cognition",
    core: "Physical brain-health inputs",
    tip: "Walk or breathe before forcing focus when stressed.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Walk or breathe before forcing focus when stressed.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "physical",
  },
  {
    category: "brain_performance",
    week: 17,
    theme: "Mood and cognition",
    core: "Physical brain-health inputs",
    tip: "Ask whether the problem is attention or emotion.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask whether the problem is attention or emotion.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 17,
    theme: "Mood and cognition",
    core: "Physical brain-health inputs",
    tip: "Reach out if low mood is persistent.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Reach out if low mood is persistent.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 17,
    theme: "Mood and cognition",
    core: "Physical brain-health inputs",
    tip: "Do not confuse depression-related fog with laziness.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not confuse depression-related fog with laziness.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 18,
    theme: "Cognitive training caution",
    core: "Learning, recall, and social engagement",
    tip: "Use brain games only as games, not guaranteed brain improvement.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use brain games only as games, not guaranteed brain improvement.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 18,
    theme: "Cognitive training caution",
    core: "Learning, recall, and social engagement",
    tip: "Prioritize exercise, sleep, learning, and connection first.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Prioritize exercise, sleep, learning, and connection first.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 18,
    theme: "Cognitive training caution",
    core: "Learning, recall, and social engagement",
    tip: "Choose real-world skills over abstract games.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Choose real-world skills over abstract games.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 18,
    theme: "Cognitive training caution",
    core: "Learning, recall, and social engagement",
    tip: "Track whether training transfers to life tasks.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track whether training transfers to life tasks.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 18,
    theme: "Cognitive training caution",
    core: "Learning, recall, and social engagement",
    tip: "Do not let apps replace medical evaluation for decline.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not let apps replace medical evaluation for decline.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 19,
    theme: "Neurologic red flags",
    core: "Physical brain-health inputs",
    tip: "Seek immediate help for sudden weakness or facial droop.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Seek immediate help for sudden weakness or facial droop.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 19,
    theme: "Neurologic red flags",
    core: "Physical brain-health inputs",
    tip: "Seek immediate help for speech trouble or sudden confusion.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Seek immediate help for speech trouble or sudden confusion.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 19,
    theme: "Neurologic red flags",
    core: "Physical brain-health inputs",
    tip: "Seek immediate help for sudden vision changes.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Seek immediate help for sudden vision changes.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 19,
    theme: "Neurologic red flags",
    core: "Physical brain-health inputs",
    tip: "Report head injury with worsening symptoms.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Report head injury with worsening symptoms.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 19,
    theme: "Neurologic red flags",
    core: "Physical brain-health inputs",
    tip: "Treat sudden cognitive change as medical, not coaching.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Treat sudden cognitive change as medical, not coaching.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 20,
    theme: "Maintenance",
    core: "Learning, recall, and social engagement",
    tip: "Keep one focus block daily.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep one focus block daily.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 20,
    theme: "Maintenance",
    core: "Learning, recall, and social engagement",
    tip: "Keep one weekly learning session.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep one weekly learning session.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 20,
    theme: "Maintenance",
    core: "Learning, recall, and social engagement",
    tip: "Keep movement before hard thinking.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep movement before hard thinking.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 20,
    theme: "Maintenance",
    core: "Learning, recall, and social engagement",
    tip: "Review distraction rules weekly.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Review distraction rules weekly.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "brain_performance",
    week: 20,
    theme: "Maintenance",
    core: "Learning, recall, and social engagement",
    tip: "Protect sleep as the first cognitive protocol.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Protect sleep as the first cognitive protocol.",
    tracking: "Focus block completed / distraction count",
    safety: "Escalate sudden confusion, weakness, speech/vision changes, head injury, or rapid cognitive change.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 1,
    theme: "Healthspan mindset",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Choose one action that helps you feel better this year, not just live longer.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Choose one action that helps you feel better this year, not just live longer.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 1,
    theme: "Healthspan mindset",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Track energy, strength, sleep, and connection as healthspan signs.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track energy, strength, sleep, and connection as healthspan signs.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 1,
    theme: "Healthspan mindset",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Pick the smallest useful habit today.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Pick the smallest useful habit today.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 1,
    theme: "Healthspan mindset",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Do not chase every longevity trend at once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not chase every longevity trend at once.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 1,
    theme: "Healthspan mindset",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Ask: will this help me be stronger, sharper, or more independent?",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask: will this help me be stronger, sharper, or more independent?",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 2,
    theme: "Preventive checkup",
    core: "Preventive screening + vital tracking",
    tip: "Schedule your overdue primary-care visit.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Schedule your overdue primary-care visit.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 2,
    theme: "Preventive checkup",
    core: "Preventive screening + vital tracking",
    tip: "Write 3 questions before the appointment.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Write 3 questions before the appointment.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 2,
    theme: "Preventive checkup",
    core: "Preventive screening + vital tracking",
    tip: "Bring medication and supplement list.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Bring medication and supplement list.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 2,
    theme: "Preventive checkup",
    core: "Preventive screening + vital tracking",
    tip: "Ask which screenings fit your age, sex, family history, and risks.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask which screenings fit your age, sex, family history, and risks.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 2,
    theme: "Preventive checkup",
    core: "Preventive screening + vital tracking",
    tip: "Put the follow-up step on your calendar before leaving.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Put the follow-up step on your calendar before leaving.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 3,
    theme: "Blood pressure",
    core: "Preventive screening + vital tracking",
    tip: "Take BP seated with proper technique if you have a cuff.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Take BP seated with proper technique if you have a cuff.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 3,
    theme: "Blood pressure",
    core: "Preventive screening + vital tracking",
    tip: "Record two readings one minute apart.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Record two readings one minute apart.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 3,
    theme: "Blood pressure",
    core: "Preventive screening + vital tracking",
    tip: "Bring readings to your clinician.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Bring readings to your clinician.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 3,
    theme: "Blood pressure",
    core: "Preventive screening + vital tracking",
    tip: "Use walking, sleep, and sodium reduction as BP-support habits.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use walking, sleep, and sodium reduction as BP-support habits.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 3,
    theme: "Blood pressure",
    core: "Preventive screening + vital tracking",
    tip: "Know emergency BP symptoms and act immediately.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Know emergency BP symptoms and act immediately.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 4,
    theme: "Labs and biomarkers",
    core: "Preventive screening + vital tracking",
    tip: "Find your latest labs and note what is missing.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Find your latest labs and note what is missing.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 4,
    theme: "Labs and biomarkers",
    core: "Preventive screening + vital tracking",
    tip: "Ask your clinician about lipids, A1c/glucose, kidney/liver markers, and inflammation only when appropriate.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask your clinician about lipids, A1c/glucose, kidney/liver markers, and inflammation only when appropriate.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 4,
    theme: "Labs and biomarkers",
    core: "Preventive screening + vital tracking",
    tip: "Do not interpret labs in isolation.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not interpret labs in isolation.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 4,
    theme: "Labs and biomarkers",
    core: "Preventive screening + vital tracking",
    tip: "Track trends over time.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track trends over time.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 4,
    theme: "Labs and biomarkers",
    core: "Preventive screening + vital tracking",
    tip: "Make one follow-up appointment if labs are abnormal.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Make one follow-up appointment if labs are abnormal.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 5,
    theme: "Cancer screening",
    core: "Preventive screening + vital tracking",
    tip: "Check which cancer screenings apply to you.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Check which cancer screenings apply to you.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 5,
    theme: "Cancer screening",
    core: "Preventive screening + vital tracking",
    tip: "Schedule one overdue screening conversation.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Schedule one overdue screening conversation.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 5,
    theme: "Cancer screening",
    core: "Preventive screening + vital tracking",
    tip: "Ask how family history changes timing.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask how family history changes timing.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 5,
    theme: "Cancer screening",
    core: "Preventive screening + vital tracking",
    tip: "Do not use generic app guidance as a diagnosis.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not use generic app guidance as a diagnosis.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 5,
    theme: "Cancer screening",
    core: "Preventive screening + vital tracking",
    tip: "Celebrate scheduling as the win.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Celebrate scheduling as the win.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 6,
    theme: "Vaccines",
    core: "Preventive screening + vital tracking",
    tip: "Review vaccine status with your clinician/pharmacy.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Review vaccine status with your clinician/pharmacy.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 6,
    theme: "Vaccines",
    core: "Preventive screening + vital tracking",
    tip: "Check flu/COVID/tetanus/shingles/pneumonia eligibility as appropriate.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Check flu/COVID/tetanus/shingles/pneumonia eligibility as appropriate.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 6,
    theme: "Vaccines",
    core: "Preventive screening + vital tracking",
    tip: "Put next vaccine date on calendar.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Put next vaccine date on calendar.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 6,
    theme: "Vaccines",
    core: "Preventive screening + vital tracking",
    tip: "Ask about travel vaccines before travel.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask about travel vaccines before travel.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 6,
    theme: "Vaccines",
    core: "Preventive screening + vital tracking",
    tip: "Use vaccines as prevention, not politics.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use vaccines as prevention, not politics.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 7,
    theme: "Dental/vision/hearing",
    core: "Preventive screening + vital tracking",
    tip: "Schedule dental cleaning if overdue.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Schedule dental cleaning if overdue.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 7,
    theme: "Dental/vision/hearing",
    core: "Preventive screening + vital tracking",
    tip: "Schedule eye exam if overdue.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Schedule eye exam if overdue.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 7,
    theme: "Dental/vision/hearing",
    core: "Preventive screening + vital tracking",
    tip: "Ask for hearing check if conversations are harder.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask for hearing check if conversations are harder.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 7,
    theme: "Dental/vision/hearing",
    core: "Preventive screening + vital tracking",
    tip: "Use prescribed glasses/hearing aids consistently.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use prescribed glasses/hearing aids consistently.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 7,
    theme: "Dental/vision/hearing",
    core: "Preventive screening + vital tracking",
    tip: "Treat sensory health as brain and safety health.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Treat sensory health as brain and safety health.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 8,
    theme: "Strengthspan",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Do one set of sit-to-stands.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do one set of sit-to-stands.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "physical",
  },
  {
    category: "longevity_prevention",
    week: 8,
    theme: "Strengthspan",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Schedule two strength sessions this week.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Schedule two strength sessions this week.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 8,
    theme: "Strengthspan",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Train grip, legs, push, pull, and carry over time.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Train grip, legs, push, pull, and carry over time.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "physical",
  },
  {
    category: "longevity_prevention",
    week: 8,
    theme: "Strengthspan",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Progress slowly and safely.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Progress slowly and safely.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "physical",
  },
  {
    category: "longevity_prevention",
    week: 8,
    theme: "Strengthspan",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Track strength as independence insurance.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track strength as independence insurance.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 9,
    theme: "Cardiorespiratory base",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Walk 10 minutes today.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Walk 10 minutes today.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "physical",
  },
  {
    category: "longevity_prevention",
    week: 9,
    theme: "Cardiorespiratory base",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Build toward 150 minutes/week gradually.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Build toward 150 minutes/week gradually.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "physical",
  },
  {
    category: "longevity_prevention",
    week: 9,
    theme: "Cardiorespiratory base",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Use conversational pace as the base.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use conversational pace as the base.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "physical",
  },
  {
    category: "longevity_prevention",
    week: 9,
    theme: "Cardiorespiratory base",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Add hills or intervals only after consistency.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add hills or intervals only after consistency.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "physical",
  },
  {
    category: "longevity_prevention",
    week: 9,
    theme: "Cardiorespiratory base",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Track weekly minutes.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track weekly minutes.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 10,
    theme: "Balance and falls",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Practice balance near support for 20 seconds.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Practice balance near support for 20 seconds.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 10,
    theme: "Balance and falls",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Clear one tripping hazard at home.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Clear one tripping hazard at home.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "physical",
  },
  {
    category: "longevity_prevention",
    week: 10,
    theme: "Balance and falls",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Use good lighting at night.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use good lighting at night.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "physical",
  },
  {
    category: "longevity_prevention",
    week: 10,
    theme: "Balance and falls",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Train legs with sit-to-stands.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Train legs with sit-to-stands.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "physical",
  },
  {
    category: "longevity_prevention",
    week: 10,
    theme: "Balance and falls",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Discuss falls, dizziness, or neuropathy with a clinician.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Discuss falls, dizziness, or neuropathy with a clinician.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "physical",
  },
  {
    category: "longevity_prevention",
    week: 11,
    theme: "Protein and muscle",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Add protein to one meal.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add protein to one meal.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "nutrition",
  },
  {
    category: "longevity_prevention",
    week: 11,
    theme: "Protein and muscle",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Pair protein with strength training days.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Pair protein with strength training days.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "physical",
  },
  {
    category: "longevity_prevention",
    week: 11,
    theme: "Protein and muscle",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Use whole-food protein when possible.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use whole-food protein when possible.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "nutrition",
  },
  {
    category: "longevity_prevention",
    week: 11,
    theme: "Protein and muscle",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Do not diet away muscle.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not diet away muscle.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "nutrition",
  },
  {
    category: "longevity_prevention",
    week: 11,
    theme: "Protein and muscle",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Ask a clinician/dietitian if kidney disease or other issues affect protein needs.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask a clinician/dietitian if kidney disease or other issues affect protein needs.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 12,
    theme: "Fiber and metabolic health",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Add beans, vegetables, fruit, oats, or whole grains today.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Add beans, vegetables, fruit, oats, or whole grains today.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "nutrition",
  },
  {
    category: "longevity_prevention",
    week: 12,
    theme: "Fiber and metabolic health",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Choose protein + fiber before refined carbs.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Choose protein + fiber before refined carbs.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "nutrition",
  },
  {
    category: "longevity_prevention",
    week: 12,
    theme: "Fiber and metabolic health",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Walk after one meal.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Walk after one meal.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "physical",
  },
  {
    category: "longevity_prevention",
    week: 12,
    theme: "Fiber and metabolic health",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Reduce one added-sugar item.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Reduce one added-sugar item.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "nutrition",
  },
  {
    category: "longevity_prevention",
    week: 12,
    theme: "Fiber and metabolic health",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Track waist or weight trend if appropriate.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track waist or weight trend if appropriate.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 13,
    theme: "Sleep longevity",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Give yourself 7+ hours sleep opportunity.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Give yourself 7+ hours sleep opportunity.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 13,
    theme: "Sleep longevity",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Keep wake time stable.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep wake time stable.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 13,
    theme: "Sleep longevity",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Screen for apnea if snoring plus sleepiness.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Screen for apnea if snoring plus sleepiness.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 13,
    theme: "Sleep longevity",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Move caffeine earlier.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Move caffeine earlier.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 13,
    theme: "Sleep longevity",
    core: "Movement, nutrition, and sleep foundation",
    tip: "Treat sleep as repair time.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Treat sleep as repair time.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 14,
    theme: "Social connection",
    core: "Connection, accountability, and risk reduction",
    tip: "Text or call one person.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Text or call one person.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 14,
    theme: "Social connection",
    core: "Connection, accountability, and risk reduction",
    tip: "Schedule a walk with someone.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Schedule a walk with someone.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 14,
    theme: "Social connection",
    core: "Connection, accountability, and risk reduction",
    tip: "Join one group or recurring activity.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Join one group or recurring activity.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 14,
    theme: "Social connection",
    core: "Connection, accountability, and risk reduction",
    tip: "Ask for accountability on one habit.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask for accountability on one habit.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 14,
    theme: "Social connection",
    core: "Connection, accountability, and risk reduction",
    tip: "Do not let health become a solo project.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not let health become a solo project.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 15,
    theme: "Tobacco/nicotine risk",
    core: "Connection, accountability, and risk reduction",
    tip: "Track nicotine exposure honestly.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track nicotine exposure honestly.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 15,
    theme: "Tobacco/nicotine risk",
    core: "Connection, accountability, and risk reduction",
    tip: "Ask your clinician about cessation tools.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask your clinician about cessation tools.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 15,
    theme: "Tobacco/nicotine risk",
    core: "Connection, accountability, and risk reduction",
    tip: "Make one smoke-free space.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Make one smoke-free space.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 15,
    theme: "Tobacco/nicotine risk",
    core: "Connection, accountability, and risk reduction",
    tip: "Delay first nicotine use by 10 minutes if quitting feels too big.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Delay first nicotine use by 10 minutes if quitting feels too big.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 15,
    theme: "Tobacco/nicotine risk",
    core: "Connection, accountability, and risk reduction",
    tip: "Do not rely on shame; use support.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not rely on shame; use support.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 16,
    theme: "Alcohol reduction",
    core: "Connection, accountability, and risk reduction",
    tip: "Choose one alcohol-free night.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Choose one alcohol-free night.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 16,
    theme: "Alcohol reduction",
    core: "Connection, accountability, and risk reduction",
    tip: "Track sleep after drinking versus not drinking.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track sleep after drinking versus not drinking.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 16,
    theme: "Alcohol reduction",
    core: "Connection, accountability, and risk reduction",
    tip: "Drink water between alcoholic drinks if you drink.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Drink water between alcoholic drinks if you drink.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "nutrition",
  },
  {
    category: "longevity_prevention",
    week: 16,
    theme: "Alcohol reduction",
    core: "Connection, accountability, and risk reduction",
    tip: "Stop alcohol several hours before bed.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stop alcohol several hours before bed.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 16,
    theme: "Alcohol reduction",
    core: "Connection, accountability, and risk reduction",
    tip: "Ask for support if alcohol feels hard to control.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Ask for support if alcohol feels hard to control.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 17,
    theme: "Medication/supplement safety",
    core: "Preventive screening + vital tracking",
    tip: "Update your medication and supplement list.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Update your medication and supplement list.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 17,
    theme: "Medication/supplement safety",
    core: "Preventive screening + vital tracking",
    tip: "Check interactions with clinician/pharmacist.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Check interactions with clinician/pharmacist.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 17,
    theme: "Medication/supplement safety",
    core: "Preventive screening + vital tracking",
    tip: "Do not add multiple supplements at once.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not add multiple supplements at once.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 17,
    theme: "Medication/supplement safety",
    core: "Preventive screening + vital tracking",
    tip: "Track why you take each supplement.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Track why you take each supplement.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 17,
    theme: "Medication/supplement safety",
    core: "Preventive screening + vital tracking",
    tip: "Stop guessing when symptoms or labs are involved.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Stop guessing when symptoms or labs are involved.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 18,
    theme: "Skin and sun safety",
    core: "Preventive screening + vital tracking",
    tip: "Use sun protection during outdoor time.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Use sun protection during outdoor time.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 18,
    theme: "Skin and sun safety",
    core: "Preventive screening + vital tracking",
    tip: "Check new or changing skin spots.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Check new or changing skin spots.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 18,
    theme: "Skin and sun safety",
    core: "Preventive screening + vital tracking",
    tip: "Schedule dermatology if high risk or concerning changes.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Schedule dermatology if high risk or concerning changes.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 18,
    theme: "Skin and sun safety",
    core: "Preventive screening + vital tracking",
    tip: "Balance sunlight benefits with burn prevention.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Balance sunlight benefits with burn prevention.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 18,
    theme: "Skin and sun safety",
    core: "Preventive screening + vital tracking",
    tip: "Do not ignore bleeding/changing lesions.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Do not ignore bleeding/changing lesions.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 19,
    theme: "Weekly planning",
    core: "Connection, accountability, and risk reduction",
    tip: "Pick one healthspan habit for this week.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Pick one healthspan habit for this week.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 19,
    theme: "Weekly planning",
    core: "Connection, accountability, and risk reduction",
    tip: "Put it on the calendar.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Put it on the calendar.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 19,
    theme: "Weekly planning",
    core: "Connection, accountability, and risk reduction",
    tip: "Choose a backup version for bad days.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Choose a backup version for bad days.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 19,
    theme: "Weekly planning",
    core: "Connection, accountability, and risk reduction",
    tip: "Review wins every Sunday.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Review wins every Sunday.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 19,
    theme: "Weekly planning",
    core: "Connection, accountability, and risk reduction",
    tip: "Repeat what worked before adding more.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Repeat what worked before adding more.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 20,
    theme: "Maintenance",
    core: "Connection, accountability, and risk reduction",
    tip: "Keep one screening task current.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep one screening task current.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 20,
    theme: "Maintenance",
    core: "Connection, accountability, and risk reduction",
    tip: "Keep one movement anchor.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep one movement anchor.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 20,
    theme: "Maintenance",
    core: "Connection, accountability, and risk reduction",
    tip: "Keep one nutrition anchor.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep one nutrition anchor.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 20,
    theme: "Maintenance",
    core: "Connection, accountability, and risk reduction",
    tip: "Keep one sleep anchor.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep one sleep anchor.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },
  {
    category: "longevity_prevention",
    week: 20,
    theme: "Maintenance",
    core: "Connection, accountability, and risk reduction",
    tip: "Keep one relationship anchor — healthspan is not only biology.",
    framing: "I’m not asking for perfect. I’m asking for one honest rep today: Keep one relationship anchor — healthspan is not only biology.",
    tracking: "Preventive task completed / vital tracked / follow-up scheduled",
    safety: "Personalize screening with clinician; urgent symptoms require immediate care.",
    mode: "behavioral",
  },

  // ─────────────────────────────────────────────────────────────────────────
  // NEW CATEGORIES — Skin / Strength / Digestive (300 tips from May 2026 expert pass)
  // ─────────────────────────────────────────────────────────────────────────
  {
    category: "skin_health",
    week: 1,
    theme: "Sun Shield",
    core: "Sun Shield",
    tip: "Apply broad-spectrum SPF 30+ to face, neck, ears, and hands before outdoor exposure.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Apply broad-spectrum SPF 30+ to face, neck, ears, and hands before outdoor exposure.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 2,
    theme: "Sun Shield",
    core: "Sun Shield",
    tip: "Put sunscreen next to your toothbrush so it becomes automatic.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Put sunscreen next to your toothbrush so it becomes automatic.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 3,
    theme: "Sun Shield",
    core: "Sun Shield",
    tip: "Reapply sunscreen every two hours when outdoors or sweating.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Reapply sunscreen every two hours when outdoors or sweating.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 4,
    theme: "Sun Shield",
    core: "Sun Shield",
    tip: "Use a hat and sunglasses for long outdoor time.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use a hat and sunglasses for long outdoor time.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 5,
    theme: "Sun Shield",
    core: "Sun Shield",
    tip: "Keep sunscreen in your car, gym bag, and bathroom.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Keep sunscreen in your car, gym bag, and bathroom.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 6,
    theme: "Sun Shield",
    core: "Sun Shield",
    tip: "Choose shade for the highest-sun part of your day when possible.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Choose shade for the highest-sun part of your day when possible.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 7,
    theme: "Sun Shield",
    core: "Sun Shield",
    tip: "Use UPF clothing for walks, golf, boating, or cycling.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use UPF clothing for walks, golf, boating, or cycling.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "physical",
  },
  {
    category: "skin_health",
    week: 8,
    theme: "Sun Shield",
    core: "Sun Shield",
    tip: "Protect the back of your hands while driving.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Protect the back of your hands while driving.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 9,
    theme: "Sun Shield",
    core: "Sun Shield",
    tip: "Do not use tanning beds. They age skin and increase skin cancer risk.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not use tanning beds. They age skin and increase skin cancer risk.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 10,
    theme: "Sun Shield",
    core: "Sun Shield",
    tip: "Check UV index before long outdoor plans.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Check UV index before long outdoor plans.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 11,
    theme: "Skin Cancer Awareness",
    core: "Skin Cancer Awareness",
    tip: "Do a 5-minute skin self-check once this month.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do a 5-minute skin self-check once this month.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 12,
    theme: "Skin Cancer Awareness",
    core: "Skin Cancer Awareness",
    tip: "Use the ABCDE rule for moles: asymmetry, border, color, diameter, evolving.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use the ABCDE rule for moles: asymmetry, border, color, diameter, evolving.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 1,
    theme: "Skin Cancer Awareness",
    core: "Skin Cancer Awareness",
    tip: "Take a clear photo of any spot you are watching so you can compare it later.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Take a clear photo of any spot you are watching so you can compare it later.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 2,
    theme: "Skin Cancer Awareness",
    core: "Skin Cancer Awareness",
    tip: "Ask a partner to check your back, scalp line, and hard-to-see areas.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Ask a partner to check your back, scalp line, and hard-to-see areas.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 3,
    theme: "Skin Cancer Awareness",
    core: "Skin Cancer Awareness",
    tip: "Book a dermatology check if you have a changing or bleeding spot.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Book a dermatology check if you have a changing or bleeding spot.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 4,
    theme: "Skin Cancer Awareness",
    core: "Skin Cancer Awareness",
    tip: "Do not cover up a suspicious spot with cosmetic treatments before it is evaluated.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not cover up a suspicious spot with cosmetic treatments before it is evaluated.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 5,
    theme: "Skin Cancer Awareness",
    core: "Skin Cancer Awareness",
    tip: "Track spots that itch, bleed, crust, or do not heal.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track spots that itch, bleed, crust, or do not heal.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 6,
    theme: "Skin Cancer Awareness",
    core: "Skin Cancer Awareness",
    tip: "If you have a history of skin cancer, set a recurring skin-check reminder.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: If you have a history of skin cancer, set a recurring skin-check reminder.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 7,
    theme: "Skin Cancer Awareness",
    core: "Skin Cancer Awareness",
    tip: "Check nails for new dark lines or changes.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Check nails for new dark lines or changes.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 8,
    theme: "Skin Cancer Awareness",
    core: "Skin Cancer Awareness",
    tip: "Any non-healing sore gets medical attention.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Any non-healing sore gets medical attention.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 9,
    theme: "Barrier Repair",
    core: "Barrier Repair",
    tip: "Use a gentle cleanser instead of harsh scrubs.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use a gentle cleanser instead of harsh scrubs.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 10,
    theme: "Barrier Repair",
    core: "Barrier Repair",
    tip: "Moisturize after showering while skin is still slightly damp.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Moisturize after showering while skin is still slightly damp.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 11,
    theme: "Barrier Repair",
    core: "Barrier Repair",
    tip: "Shorten hot showers to protect the skin barrier.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Shorten hot showers to protect the skin barrier.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 12,
    theme: "Barrier Repair",
    core: "Barrier Repair",
    tip: "Use fragrance-free moisturizer if skin is irritated.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use fragrance-free moisturizer if skin is irritated.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 1,
    theme: "Barrier Repair",
    core: "Barrier Repair",
    tip: "Do not introduce multiple new skin products at once.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not introduce multiple new skin products at once.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 2,
    theme: "Barrier Repair",
    core: "Barrier Repair",
    tip: "Patch test a new product on a small area first.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Patch test a new product on a small area first.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 3,
    theme: "Barrier Repair",
    core: "Barrier Repair",
    tip: "Use lip balm with SPF when outdoors.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use lip balm with SPF when outdoors.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 4,
    theme: "Barrier Repair",
    core: "Barrier Repair",
    tip: "Add a humidifier if indoor air is very dry.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add a humidifier if indoor air is very dry.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 5,
    theme: "Barrier Repair",
    core: "Barrier Repair",
    tip: "Avoid over-exfoliating; more irritation is not more progress.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Avoid over-exfoliating; more irritation is not more progress.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 6,
    theme: "Barrier Repair",
    core: "Barrier Repair",
    tip: "If skin stings with everything, simplify routine for one week.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: If skin stings with everything, simplify routine for one week.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 7,
    theme: "Repair at Night",
    core: "Repair at Night",
    tip: "Wash off sunscreen, sweat, and daily grime before bed.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Wash off sunscreen, sweat, and daily grime before bed.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 8,
    theme: "Repair at Night",
    core: "Repair at Night",
    tip: "Keep your night routine to cleanser and moisturizer until consistent.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Keep your night routine to cleanser and moisturizer until consistent.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 9,
    theme: "Repair at Night",
    core: "Repair at Night",
    tip: "Change pillowcase weekly.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Change pillowcase weekly.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 10,
    theme: "Repair at Night",
    core: "Repair at Night",
    tip: "Avoid sleeping in makeup.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Avoid sleeping in makeup.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 11,
    theme: "Repair at Night",
    core: "Repair at Night",
    tip: "Keep the bedroom cool to reduce night sweating and irritation.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Keep the bedroom cool to reduce night sweating and irritation.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 12,
    theme: "Repair at Night",
    core: "Repair at Night",
    tip: "Add a consistent sleep schedule to support repair.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add a consistent sleep schedule to support repair.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 1,
    theme: "Repair at Night",
    core: "Repair at Night",
    tip: "Do not pick at blemishes or scabs.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not pick at blemishes or scabs.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 2,
    theme: "Repair at Night",
    core: "Repair at Night",
    tip: "Use a clean towel for your face.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use a clean towel for your face.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 3,
    theme: "Repair at Night",
    core: "Repair at Night",
    tip: "Keep hair products off face if they cause breakouts.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Keep hair products off face if they cause breakouts.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 4,
    theme: "Repair at Night",
    core: "Repair at Night",
    tip: "Track whether poor sleep makes skin worse.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track whether poor sleep makes skin worse.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 5,
    theme: "Collagen Support",
    core: "Collagen Support",
    tip: "Include protein at one meal to support collagen and tissue repair.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Include protein at one meal to support collagen and tissue repair.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "nutrition",
  },
  {
    category: "skin_health",
    week: 6,
    theme: "Collagen Support",
    core: "Collagen Support",
    tip: "Add vitamin C foods such as citrus, peppers, berries, or kiwi.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add vitamin C foods such as citrus, peppers, berries, or kiwi.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "nutrition",
  },
  {
    category: "skin_health",
    week: 7,
    theme: "Collagen Support",
    core: "Collagen Support",
    tip: "Consider collagen peptides only after protein and SPF habits are consistent.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Consider collagen peptides only after protein and SPF habits are consistent.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "nutrition",
  },
  {
    category: "skin_health",
    week: 8,
    theme: "Collagen Support",
    core: "Collagen Support",
    tip: "Support joints and skin with strength training, not just creams.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Support joints and skin with strength training, not just creams.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "nutrition",
  },
  {
    category: "skin_health",
    week: 9,
    theme: "Collagen Support",
    core: "Collagen Support",
    tip: "Add colorful plants to supply antioxidants.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add colorful plants to supply antioxidants.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "nutrition",
  },
  {
    category: "skin_health",
    week: 10,
    theme: "Collagen Support",
    core: "Collagen Support",
    tip: "Avoid crash dieting; rapid weight loss can make skin look older.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Avoid crash dieting; rapid weight loss can make skin look older.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "nutrition",
  },
  {
    category: "skin_health",
    week: 11,
    theme: "Collagen Support",
    core: "Collagen Support",
    tip: "Drink water earlier in the day so skin and energy both benefit.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Drink water earlier in the day so skin and energy both benefit.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "nutrition",
  },
  {
    category: "skin_health",
    week: 12,
    theme: "Collagen Support",
    core: "Collagen Support",
    tip: "Limit smoking or vaping exposure; it accelerates skin aging.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Limit smoking or vaping exposure; it accelerates skin aging.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "nutrition",
  },
  {
    category: "skin_health",
    week: 1,
    theme: "Collagen Support",
    core: "Collagen Support",
    tip: "Choose omega-3 foods such as salmon, sardines, chia, flax, or walnuts.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Choose omega-3 foods such as salmon, sardines, chia, flax, or walnuts.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "nutrition",
  },
  {
    category: "skin_health",
    week: 2,
    theme: "Collagen Support",
    core: "Collagen Support",
    tip: "Do not expect collagen to replace sunscreen or sleep.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not expect collagen to replace sunscreen or sleep.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "nutrition",
  },
  {
    category: "skin_health",
    week: 3,
    theme: "Topical Actives",
    core: "Topical Actives",
    tip: "Consider vitamin C serum in the morning only if skin tolerates it.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Consider vitamin C serum in the morning only if skin tolerates it.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "nutrition",
  },
  {
    category: "skin_health",
    week: 4,
    theme: "Topical Actives",
    core: "Topical Actives",
    tip: "Consider niacinamide for redness/barrier support if tolerated.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Consider niacinamide for redness/barrier support if tolerated.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 5,
    theme: "Topical Actives",
    core: "Topical Actives",
    tip: "Discuss retinoid or retinol use for fine lines with a clinician or dermatologist.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Discuss retinoid or retinol use for fine lines with a clinician or dermatologist.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 6,
    theme: "Topical Actives",
    core: "Topical Actives",
    tip: "Do not use retinoids if pregnant unless cleared by a clinician.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not use retinoids if pregnant unless cleared by a clinician.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 7,
    theme: "Topical Actives",
    core: "Topical Actives",
    tip: "Introduce only one active product every 2-3 weeks.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Introduce only one active product every 2-3 weeks.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 8,
    theme: "Topical Actives",
    core: "Topical Actives",
    tip: "Use moisturizer with actives to reduce irritation.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use moisturizer with actives to reduce irritation.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 9,
    theme: "Topical Actives",
    core: "Topical Actives",
    tip: "Use sunscreen daily if using retinoids or exfoliating acids.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use sunscreen daily if using retinoids or exfoliating acids.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 10,
    theme: "Topical Actives",
    core: "Topical Actives",
    tip: "Stop a product that causes persistent burning or rash.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Stop a product that causes persistent burning or rash.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 11,
    theme: "Topical Actives",
    core: "Topical Actives",
    tip: "Do not combine too many acids, scrubs, and retinoids at once.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not combine too many acids, scrubs, and retinoids at once.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 12,
    theme: "Topical Actives",
    core: "Topical Actives",
    tip: "Take a photo monthly, not daily, to judge skin changes.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Take a photo monthly, not daily, to judge skin changes.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 1,
    theme: "Inflammation Control",
    core: "Inflammation Control",
    tip: "Walk 10 minutes after a meal to support blood sugar and inflammation.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Walk 10 minutes after a meal to support blood sugar and inflammation.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "nutrition",
  },
  {
    category: "skin_health",
    week: 2,
    theme: "Inflammation Control",
    core: "Inflammation Control",
    tip: "Reduce alcohol for one week and watch skin redness or puffiness.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Reduce alcohol for one week and watch skin redness or puffiness.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 3,
    theme: "Inflammation Control",
    core: "Inflammation Control",
    tip: "Add one omega-3-rich meal this week.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add one omega-3-rich meal this week.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "nutrition",
  },
  {
    category: "skin_health",
    week: 4,
    theme: "Inflammation Control",
    core: "Inflammation Control",
    tip: "Keep added sugar lower for one week and observe skin changes.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Keep added sugar lower for one week and observe skin changes.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 5,
    theme: "Inflammation Control",
    core: "Inflammation Control",
    tip: "Use breath work to lower stress before bed.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use breath work to lower stress before bed.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 6,
    theme: "Inflammation Control",
    core: "Inflammation Control",
    tip: "Prioritize 7+ hours of sleep when possible.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Prioritize 7+ hours of sleep when possible.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 7,
    theme: "Inflammation Control",
    core: "Inflammation Control",
    tip: "Do not chase skin results while ignoring stress and sleep.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not chase skin results while ignoring stress and sleep.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 8,
    theme: "Inflammation Control",
    core: "Inflammation Control",
    tip: "Add green tea or berries as a polyphenol habit.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add green tea or berries as a polyphenol habit.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 9,
    theme: "Inflammation Control",
    core: "Inflammation Control",
    tip: "Keep hydration steady instead of drinking it all at night.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Keep hydration steady instead of drinking it all at night.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "nutrition",
  },
  {
    category: "skin_health",
    week: 10,
    theme: "Inflammation Control",
    core: "Inflammation Control",
    tip: "Track flares against food, stress, and sleep.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track flares against food, stress, and sleep.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "nutrition",
  },
  {
    category: "skin_health",
    week: 11,
    theme: "Environment",
    core: "Environment",
    tip: "Rinse sweat off after workouts when possible.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Rinse sweat off after workouts when possible.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "physical",
  },
  {
    category: "skin_health",
    week: 12,
    theme: "Environment",
    core: "Environment",
    tip: "Use sunscreen even on cloudy days when outdoors.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use sunscreen even on cloudy days when outdoors.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 1,
    theme: "Environment",
    core: "Environment",
    tip: "Wear gloves for harsh cleaning chemicals.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Wear gloves for harsh cleaning chemicals.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 2,
    theme: "Environment",
    core: "Environment",
    tip: "Keep razors clean and replace dull blades.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Keep razors clean and replace dull blades.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 3,
    theme: "Environment",
    core: "Environment",
    tip: "Protect skin from wind and cold with moisturizer and clothing.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Protect skin from wind and cold with moisturizer and clothing.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 4,
    theme: "Environment",
    core: "Environment",
    tip: "Use non-comedogenic products if acne-prone.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use non-comedogenic products if acne-prone.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 5,
    theme: "Environment",
    core: "Environment",
    tip: "Avoid fragrance-heavy products if sensitive.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Avoid fragrance-heavy products if sensitive.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 6,
    theme: "Environment",
    core: "Environment",
    tip: "Use mineral sunscreen if chemical sunscreen irritates skin.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use mineral sunscreen if chemical sunscreen irritates skin.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 7,
    theme: "Environment",
    core: "Environment",
    tip: "Check medications that increase sun sensitivity with your pharmacist.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Check medications that increase sun sensitivity with your pharmacist.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 8,
    theme: "Environment",
    core: "Environment",
    tip: "Keep routine simple when traveling.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Keep routine simple when traveling.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 9,
    theme: "Tracking",
    core: "Tracking",
    tip: "Track sunscreen days completed this week.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track sunscreen days completed this week.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 10,
    theme: "Tracking",
    core: "Tracking",
    tip: "Track new or changing spots in a notes app.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track new or changing spots in a notes app.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 11,
    theme: "Tracking",
    core: "Tracking",
    tip: "Take monthly skin photos in the same lighting.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Take monthly skin photos in the same lighting.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 12,
    theme: "Tracking",
    core: "Tracking",
    tip: "Score skin dryness 1-10 for seven days.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Score skin dryness 1-10 for seven days.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "physical",
  },
  {
    category: "skin_health",
    week: 1,
    theme: "Tracking",
    core: "Tracking",
    tip: "Track redness or irritation after new products.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track redness or irritation after new products.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 2,
    theme: "Tracking",
    core: "Tracking",
    tip: "Write down top triggers: sun, alcohol, stress, food, sleep.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Write down top triggers: sun, alcohol, stress, food, sleep.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "nutrition",
  },
  {
    category: "skin_health",
    week: 3,
    theme: "Tracking",
    core: "Tracking",
    tip: "Track sleep duration alongside skin quality.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track sleep duration alongside skin quality.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 4,
    theme: "Tracking",
    core: "Tracking",
    tip: "Track whether you reapplied sunscreen during long outdoor days.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track whether you reapplied sunscreen during long outdoor days.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 5,
    theme: "Tracking",
    core: "Tracking",
    tip: "Track if your hands/neck receive the same care as your face.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track if your hands/neck receive the same care as your face.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 6,
    theme: "Tracking",
    core: "Tracking",
    tip: "Review your skin routine every month and remove products that do nothing.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Review your skin routine every month and remove products that do nothing.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 7,
    theme: "Clinical Escalation",
    core: "Clinical Escalation",
    tip: "Call a dermatologist for a changing, bleeding, or non-healing spot.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Call a dermatologist for a changing, bleeding, or non-healing spot.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 8,
    theme: "Clinical Escalation",
    core: "Clinical Escalation",
    tip: "Do not delay care for a mole that looks different from the others.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not delay care for a mole that looks different from the others.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 9,
    theme: "Clinical Escalation",
    core: "Clinical Escalation",
    tip: "Ask about annual skin checks if you have high sun exposure or family history.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Ask about annual skin checks if you have high sun exposure or family history.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 10,
    theme: "Clinical Escalation",
    core: "Clinical Escalation",
    tip: "Seek care for a rash that spreads, hurts, or becomes infected.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Seek care for a rash that spreads, hurts, or becomes infected.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 11,
    theme: "Clinical Escalation",
    core: "Clinical Escalation",
    tip: "Ask a clinician before using prescription-strength actives.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Ask a clinician before using prescription-strength actives.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "physical",
  },
  {
    category: "skin_health",
    week: 12,
    theme: "Clinical Escalation",
    core: "Clinical Escalation",
    tip: "Discuss supplement use if on blood thinners, pregnant, or treating cancer.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Discuss supplement use if on blood thinners, pregnant, or treating cancer.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 1,
    theme: "Clinical Escalation",
    core: "Clinical Escalation",
    tip: "Get medical care for sudden swelling, hives, or allergic reaction.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Get medical care for sudden swelling, hives, or allergic reaction.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 2,
    theme: "Clinical Escalation",
    core: "Clinical Escalation",
    tip: "Do not use online advice to evaluate possible skin cancer.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not use online advice to evaluate possible skin cancer.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 3,
    theme: "Clinical Escalation",
    core: "Clinical Escalation",
    tip: "Ask about skin screening if immunosuppressed.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Ask about skin screening if immunosuppressed.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "skin_health",
    week: 4,
    theme: "Clinical Escalation",
    core: "Clinical Escalation",
    tip: "When in doubt, get the spot looked at.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: When in doubt, get the spot looked at.",
    tracking: "Days protected / spots tracked",
    safety: "Escalate any new, changing, bleeding, itching, or non-healing skin lesion to a dermatologist.",
    mode: "behavioral",
  },
  {
    category: "strength_function",
    week: 1,
    theme: "Protein Foundation",
    core: "Protein Foundation",
    tip: "Put a palm-sized protein serving at breakfast.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Put a palm-sized protein serving at breakfast.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 2,
    theme: "Protein Foundation",
    core: "Protein Foundation",
    tip: "Add protein to lunch before adding snacks.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add protein to lunch before adding snacks.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 3,
    theme: "Protein Foundation",
    core: "Protein Foundation",
    tip: "Use Greek yogurt, eggs, fish, poultry, beans, tofu, or lean meat as easy anchors.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use Greek yogurt, eggs, fish, poultry, beans, tofu, or lean meat as easy anchors.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 4,
    theme: "Protein Foundation",
    core: "Protein Foundation",
    tip: "If appetite is low, use a protein smoothie as a bridge.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: If appetite is low, use a protein smoothie as a bridge.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 5,
    theme: "Protein Foundation",
    core: "Protein Foundation",
    tip: "Spread protein across the day instead of saving it all for dinner.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Spread protein across the day instead of saving it all for dinner.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 6,
    theme: "Protein Foundation",
    core: "Protein Foundation",
    tip: "Pair protein with fiber to stay full longer.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Pair protein with fiber to stay full longer.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 7,
    theme: "Protein Foundation",
    core: "Protein Foundation",
    tip: "Track protein for one meal only this week.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track protein for one meal only this week.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 8,
    theme: "Protein Foundation",
    core: "Protein Foundation",
    tip: "Do not diet so hard that strength collapses.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not diet so hard that strength collapses.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 9,
    theme: "Protein Foundation",
    core: "Protein Foundation",
    tip: "After workouts, eat a protein-containing meal within a reasonable window.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: After workouts, eat a protein-containing meal within a reasonable window.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 10,
    theme: "Protein Foundation",
    core: "Protein Foundation",
    tip: "Ask a clinician about protein targets if kidney disease is present.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Ask a clinician about protein targets if kidney disease is present.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 11,
    theme: "Creatine Support",
    core: "Creatine Support",
    tip: "Consider creatine monohydrate only after strength practice is consistent.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Consider creatine monohydrate only after strength practice is consistent.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 12,
    theme: "Creatine Support",
    core: "Creatine Support",
    tip: "Use creatine as training support, not a replacement for training.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use creatine as training support, not a replacement for training.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 1,
    theme: "Creatine Support",
    core: "Creatine Support",
    tip: "Discuss creatine with a clinician if kidney disease or complex medications exist.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Discuss creatine with a clinician if kidney disease or complex medications exist.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 2,
    theme: "Creatine Support",
    core: "Creatine Support",
    tip: "Hydrate consistently if using creatine.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Hydrate consistently if using creatine.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 3,
    theme: "Creatine Support",
    core: "Creatine Support",
    tip: "Choose third-party-tested creatine when possible.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Choose third-party-tested creatine when possible.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 4,
    theme: "Creatine Support",
    core: "Creatine Support",
    tip: "Do not use stimulant pre-workouts to force training.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not use stimulant pre-workouts to force training.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 5,
    theme: "Creatine Support",
    core: "Creatine Support",
    tip: "Track strength, not scale changes, when creatine is added.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track strength, not scale changes, when creatine is added.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 6,
    theme: "Creatine Support",
    core: "Creatine Support",
    tip: "Expect possible water-weight change with creatine.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Expect possible water-weight change with creatine.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 7,
    theme: "Creatine Support",
    core: "Creatine Support",
    tip: "Keep dose simple; avoid proprietary blends.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Keep dose simple; avoid proprietary blends.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 8,
    theme: "Creatine Support",
    core: "Creatine Support",
    tip: "Stop and seek advice if unusual symptoms occur.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Stop and seek advice if unusual symptoms occur.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 9,
    theme: "Grip & Carry",
    core: "Grip & Carry",
    tip: "Carry two grocery bags for 30 seconds.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Carry two grocery bags for 30 seconds.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 10,
    theme: "Grip & Carry",
    core: "Grip & Carry",
    tip: "Practice opening jars with controlled grip effort.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Practice opening jars with controlled grip effort.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 11,
    theme: "Grip & Carry",
    core: "Grip & Carry",
    tip: "Hold a heavy book at your side for 30 seconds.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Hold a heavy book at your side for 30 seconds.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 12,
    theme: "Grip & Carry",
    core: "Grip & Carry",
    tip: "Do a dead hang only if shoulders tolerate it.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do a dead hang only if shoulders tolerate it.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 1,
    theme: "Grip & Carry",
    core: "Grip & Carry",
    tip: "Add one suitcase carry down a hallway.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add one suitcase carry down a hallway.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 2,
    theme: "Grip & Carry",
    core: "Grip & Carry",
    tip: "Switch hands halfway through a carry.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Switch hands halfway through a carry.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 3,
    theme: "Grip & Carry",
    core: "Grip & Carry",
    tip: "Stand tall during carries; do not lean hard to one side.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Stand tall during carries; do not lean hard to one side.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 4,
    theme: "Grip & Carry",
    core: "Grip & Carry",
    tip: "Track carry time once weekly.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track carry time once weekly.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 5,
    theme: "Grip & Carry",
    core: "Grip & Carry",
    tip: "If grip causes numbness or tingling, stop and get evaluated.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: If grip causes numbness or tingling, stop and get evaluated.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 6,
    theme: "Grip & Carry",
    core: "Grip & Carry",
    tip: "Use grip work to make daily life easier, not to prove toughness.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use grip work to make daily life easier, not to prove toughness.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 7,
    theme: "Leg Strength",
    core: "Leg Strength",
    tip: "Do 5 chair sit-to-stands.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do 5 chair sit-to-stands.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 8,
    theme: "Leg Strength",
    core: "Leg Strength",
    tip: "Use a higher chair if knees are sensitive.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use a higher chair if knees are sensitive.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 9,
    theme: "Leg Strength",
    core: "Leg Strength",
    tip: "Push through the floor slowly and controlled.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Push through the floor slowly and controlled.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 10,
    theme: "Leg Strength",
    core: "Leg Strength",
    tip: "Add one extra rep only after form feels easy.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add one extra rep only after form feels easy.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 11,
    theme: "Leg Strength",
    core: "Leg Strength",
    tip: "Practice stair climbing at a comfortable pace.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Practice stair climbing at a comfortable pace.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 12,
    theme: "Leg Strength",
    core: "Leg Strength",
    tip: "Use hand support if balance is an issue.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use hand support if balance is an issue.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 1,
    theme: "Leg Strength",
    core: "Leg Strength",
    tip: "Stop if knee pain becomes sharp.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Stop if knee pain becomes sharp.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 2,
    theme: "Leg Strength",
    core: "Leg Strength",
    tip: "Track how many sit-to-stands you can do comfortably.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track how many sit-to-stands you can do comfortably.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 3,
    theme: "Leg Strength",
    core: "Leg Strength",
    tip: "Do not hold your breath during effort.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not hold your breath during effort.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 4,
    theme: "Leg Strength",
    core: "Leg Strength",
    tip: "Leg strength is independence; treat it like a savings account.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Leg strength is independence; treat it like a savings account.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 5,
    theme: "Core Function",
    core: "Core Function",
    tip: "Practice a 10-second wall plank.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Practice a 10-second wall plank.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 6,
    theme: "Core Function",
    core: "Core Function",
    tip: "Carry groceries evenly to train the trunk.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Carry groceries evenly to train the trunk.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 7,
    theme: "Core Function",
    core: "Core Function",
    tip: "Do one slow bird-dog each side.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do one slow bird-dog each side.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 8,
    theme: "Core Function",
    core: "Core Function",
    tip: "Brace gently before standing from a chair.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Brace gently before standing from a chair.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 9,
    theme: "Core Function",
    core: "Core Function",
    tip: "Practice tall posture during walks.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Practice tall posture during walks.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 10,
    theme: "Core Function",
    core: "Core Function",
    tip: "Avoid sit-up marathons; train control first.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Avoid sit-up marathons; train control first.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 11,
    theme: "Core Function",
    core: "Core Function",
    tip: "Add 3 slow marches while standing near a wall.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add 3 slow marches while standing near a wall.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 12,
    theme: "Core Function",
    core: "Core Function",
    tip: "Use breathing, not breath-holding, during core work.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use breathing, not breath-holding, during core work.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 1,
    theme: "Core Function",
    core: "Core Function",
    tip: "Stop if back pain shoots down the leg.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Stop if back pain shoots down the leg.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 2,
    theme: "Core Function",
    core: "Core Function",
    tip: "Core strength should help daily movement, not just exercise.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Core strength should help daily movement, not just exercise.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 3,
    theme: "Balance",
    core: "Balance",
    tip: "Stand on one foot for 10 seconds near a wall.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Stand on one foot for 10 seconds near a wall.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 4,
    theme: "Balance",
    core: "Balance",
    tip: "Practice heel-to-toe walking for 5 steps.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Practice heel-to-toe walking for 5 steps.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 5,
    theme: "Balance",
    core: "Balance",
    tip: "Do balance work before fatigue sets in.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do balance work before fatigue sets in.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 6,
    theme: "Balance",
    core: "Balance",
    tip: "Keep one hand near support.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Keep one hand near support.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 7,
    theme: "Balance",
    core: "Balance",
    tip: "Add balance to brushing teeth only if safe.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add balance to brushing teeth only if safe.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 8,
    theme: "Balance",
    core: "Balance",
    tip: "Do not close eyes until basic balance is easy.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not close eyes until basic balance is easy.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 9,
    theme: "Balance",
    core: "Balance",
    tip: "Track the side that feels less stable.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track the side that feels less stable.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 10,
    theme: "Balance",
    core: "Balance",
    tip: "Add Tai Chi or gentle balance class if interested.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add Tai Chi or gentle balance class if interested.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 11,
    theme: "Balance",
    core: "Balance",
    tip: "Falls prevention is strength training for your future self.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Falls prevention is strength training for your future self.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 12,
    theme: "Balance",
    core: "Balance",
    tip: "Seek evaluation for new dizziness or falls.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Seek evaluation for new dizziness or falls.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 1,
    theme: "Mobility",
    core: "Mobility",
    tip: "Do 5 slow shoulder circles.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do 5 slow shoulder circles.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 2,
    theme: "Mobility",
    core: "Mobility",
    tip: "Do ankle circles before walking.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do ankle circles before walking.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 3,
    theme: "Mobility",
    core: "Mobility",
    tip: "Stretch calves for 20 seconds after a walk.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Stretch calves for 20 seconds after a walk.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 4,
    theme: "Mobility",
    core: "Mobility",
    tip: "Open hips with a gentle supported lunge.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Open hips with a gentle supported lunge.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 5,
    theme: "Mobility",
    core: "Mobility",
    tip: "Use mobility to prepare for movement, not replace strength.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use mobility to prepare for movement, not replace strength.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 6,
    theme: "Mobility",
    core: "Mobility",
    tip: "Avoid bouncing stretches into pain.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Avoid bouncing stretches into pain.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 7,
    theme: "Mobility",
    core: "Mobility",
    tip: "Practice getting down toward the floor safely.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Practice getting down toward the floor safely.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 8,
    theme: "Mobility",
    core: "Mobility",
    tip: "Do one minute of mobility after sitting long periods.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do one minute of mobility after sitting long periods.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 9,
    theme: "Mobility",
    core: "Mobility",
    tip: "Track stiffness on waking.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track stiffness on waking.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 10,
    theme: "Mobility",
    core: "Mobility",
    tip: "If a joint is swollen or hot, seek care.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: If a joint is swollen or hot, seek care.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 11,
    theme: "Progression",
    core: "Progression",
    tip: "Add one rep, not ten.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add one rep, not ten.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 12,
    theme: "Progression",
    core: "Progression",
    tip: "Add one set only after the first set feels controlled.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add one set only after the first set feels controlled.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 1,
    theme: "Progression",
    core: "Progression",
    tip: "Keep two easy days between harder strength days.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Keep two easy days between harder strength days.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 2,
    theme: "Progression",
    core: "Progression",
    tip: "Use bands or bodyweight before heavy loads.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use bands or bodyweight before heavy loads.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 3,
    theme: "Progression",
    core: "Progression",
    tip: "Progress slowly enough that joints keep up.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Progress slowly enough that joints keep up.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 4,
    theme: "Progression",
    core: "Progression",
    tip: "Repeat a week if soreness is too high.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Repeat a week if soreness is too high.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 5,
    theme: "Progression",
    core: "Progression",
    tip: "Track effort on a 1-10 scale.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track effort on a 1-10 scale.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 6,
    theme: "Progression",
    core: "Progression",
    tip: "Consistency beats perfect programming.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Consistency beats perfect programming.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 7,
    theme: "Progression",
    core: "Progression",
    tip: "Every week does not need to be harder.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Every week does not need to be harder.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 8,
    theme: "Progression",
    core: "Progression",
    tip: "Your best program is the one you repeat.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Your best program is the one you repeat.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 9,
    theme: "Recovery",
    core: "Recovery",
    tip: "Sleep is part of strength training.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Sleep is part of strength training.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 10,
    theme: "Recovery",
    core: "Recovery",
    tip: "Walk on rest days to reduce stiffness.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Walk on rest days to reduce stiffness.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 11,
    theme: "Recovery",
    core: "Recovery",
    tip: "Hydrate after strength work.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Hydrate after strength work.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 12,
    theme: "Recovery",
    core: "Recovery",
    tip: "Eat protein on recovery days too.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Eat protein on recovery days too.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "nutrition",
  },
  {
    category: "strength_function",
    week: 1,
    theme: "Recovery",
    core: "Recovery",
    tip: "Do not train hard through illness.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not train hard through illness.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "behavioral",
  },
  {
    category: "strength_function",
    week: 2,
    theme: "Recovery",
    core: "Recovery",
    tip: "Use gentle mobility when sore.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use gentle mobility when sore.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 3,
    theme: "Recovery",
    core: "Recovery",
    tip: "Track soreness that lasts more than 48 hours.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track soreness that lasts more than 48 hours.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "behavioral",
  },
  {
    category: "strength_function",
    week: 4,
    theme: "Recovery",
    core: "Recovery",
    tip: "Back off if form breaks down.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Back off if form breaks down.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "behavioral",
  },
  {
    category: "strength_function",
    week: 5,
    theme: "Recovery",
    core: "Recovery",
    tip: "Pain is a signal, not a challenge.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Pain is a signal, not a challenge.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "behavioral",
  },
  {
    category: "strength_function",
    week: 6,
    theme: "Recovery",
    core: "Recovery",
    tip: "Recovery is where strength gets built.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Recovery is where strength gets built.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 7,
    theme: "Clinical Safety",
    core: "Clinical Safety",
    tip: "Stop exercise for chest pain.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Stop exercise for chest pain.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 8,
    theme: "Clinical Safety",
    core: "Clinical Safety",
    tip: "Stop for severe shortness of breath out of proportion to effort.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Stop for severe shortness of breath out of proportion to effort.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "behavioral",
  },
  {
    category: "strength_function",
    week: 9,
    theme: "Clinical Safety",
    core: "Clinical Safety",
    tip: "Seek care for dizziness during strength work.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Seek care for dizziness during strength work.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 10,
    theme: "Clinical Safety",
    core: "Clinical Safety",
    tip: "Get joint swelling evaluated.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Get joint swelling evaluated.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "behavioral",
  },
  {
    category: "strength_function",
    week: 11,
    theme: "Clinical Safety",
    core: "Clinical Safety",
    tip: "Ask a clinician before resistance work if medically fragile.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Ask a clinician before resistance work if medically fragile.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "behavioral",
  },
  {
    category: "strength_function",
    week: 12,
    theme: "Clinical Safety",
    core: "Clinical Safety",
    tip: "Use supervision after recent surgery or falls.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use supervision after recent surgery or falls.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "behavioral",
  },
  {
    category: "strength_function",
    week: 1,
    theme: "Clinical Safety",
    core: "Clinical Safety",
    tip: "Avoid heavy lifting until cleared after major medical events.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Avoid heavy lifting until cleared after major medical events.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 2,
    theme: "Clinical Safety",
    core: "Clinical Safety",
    tip: "Discuss supplements if kidney disease is present.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Discuss supplements if kidney disease is present.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "behavioral",
  },
  {
    category: "strength_function",
    week: 3,
    theme: "Clinical Safety",
    core: "Clinical Safety",
    tip: "Get help if pain changes your walking pattern.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Get help if pain changes your walking pattern.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "strength_function",
    week: 4,
    theme: "Clinical Safety",
    core: "Clinical Safety",
    tip: "Build strength, do not gamble with injury.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Build strength, do not gamble with injury.",
    tracking: "Sessions completed / strength reps",
    safety: "Stop and seek care for chest pain, severe shortness of breath, dizziness, fainting, sudden weakness, or significant joint pain.",
    mode: "physical",
  },
  {
    category: "digestive_microbiome",
    week: 1,
    theme: "Fiber Foundation",
    core: "Fiber Foundation",
    tip: "Add fiber slowly; too much too fast causes gas.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add fiber slowly; too much too fast causes gas.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 2,
    theme: "Fiber Foundation",
    core: "Fiber Foundation",
    tip: "Try oats, beans, berries, chia, flax, vegetables, or psyllium.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Try oats, beans, berries, chia, flax, vegetables, or psyllium.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 3,
    theme: "Fiber Foundation",
    core: "Fiber Foundation",
    tip: "Add one fiber food at breakfast.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add one fiber food at breakfast.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 4,
    theme: "Fiber Foundation",
    core: "Fiber Foundation",
    tip: "Pair fiber with water.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Pair fiber with water.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 5,
    theme: "Fiber Foundation",
    core: "Fiber Foundation",
    tip: "If bloating increases, reduce dose and build slower.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: If bloating increases, reduce dose and build slower.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 6,
    theme: "Fiber Foundation",
    core: "Fiber Foundation",
    tip: "Track stool consistency for one week.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track stool consistency for one week.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 7,
    theme: "Fiber Foundation",
    core: "Fiber Foundation",
    tip: "Use psyllium as a simple fiber support if tolerated.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use psyllium as a simple fiber support if tolerated.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 8,
    theme: "Fiber Foundation",
    core: "Fiber Foundation",
    tip: "Do not add multiple fiber supplements at once.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not add multiple fiber supplements at once.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 9,
    theme: "Fiber Foundation",
    core: "Fiber Foundation",
    tip: "Fiber works best as a routine, not a rescue.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Fiber works best as a routine, not a rescue.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 10,
    theme: "Fiber Foundation",
    core: "Fiber Foundation",
    tip: "Ask a clinician about fiber if bowel narrowing or swallowing issues exist.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Ask a clinician about fiber if bowel narrowing or swallowing issues exist.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 11,
    theme: "Hydration & Motility",
    core: "Hydration & Motility",
    tip: "Drink water early in the day.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Drink water early in the day.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 12,
    theme: "Hydration & Motility",
    core: "Hydration & Motility",
    tip: "Add a morning water habit before coffee.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add a morning water habit before coffee.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 1,
    theme: "Hydration & Motility",
    core: "Hydration & Motility",
    tip: "Walk 10 minutes after a meal.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Walk 10 minutes after a meal.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 2,
    theme: "Hydration & Motility",
    core: "Hydration & Motility",
    tip: "Use warm fluids in the morning if constipated.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use warm fluids in the morning if constipated.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 3,
    theme: "Hydration & Motility",
    core: "Hydration & Motility",
    tip: "Do not rely only on laxatives without addressing routine.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not rely only on laxatives without addressing routine.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 4,
    theme: "Hydration & Motility",
    core: "Hydration & Motility",
    tip: "Track bowel movement timing.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track bowel movement timing.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 5,
    theme: "Hydration & Motility",
    core: "Hydration & Motility",
    tip: "Add magnesium citrate only with clinician/pharmacist guidance if constipation persists.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add magnesium citrate only with clinician/pharmacist guidance if constipation persists.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 6,
    theme: "Hydration & Motility",
    core: "Hydration & Motility",
    tip: "Reduce evening fluids if night urination is disrupting sleep.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Reduce evening fluids if night urination is disrupting sleep.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 7,
    theme: "Hydration & Motility",
    core: "Hydration & Motility",
    tip: "Hydration supports fiber; fiber without water can backfire.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Hydration supports fiber; fiber without water can backfire.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 8,
    theme: "Hydration & Motility",
    core: "Hydration & Motility",
    tip: "Seek care for severe constipation or pain.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Seek care for severe constipation or pain.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 9,
    theme: "Meal Rhythm",
    core: "Meal Rhythm",
    tip: "Eat meals at roughly consistent times.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Eat meals at roughly consistent times.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 10,
    theme: "Meal Rhythm",
    core: "Meal Rhythm",
    tip: "Avoid constant grazing for one week.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Avoid constant grazing for one week.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 11,
    theme: "Meal Rhythm",
    core: "Meal Rhythm",
    tip: "Use a 12-hour overnight food break if appropriate.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use a 12-hour overnight food break if appropriate.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 12,
    theme: "Meal Rhythm",
    core: "Meal Rhythm",
    tip: "Do not fast if pregnant, underweight, or eating-disorder history.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not fast if pregnant, underweight, or eating-disorder history.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 1,
    theme: "Meal Rhythm",
    core: "Meal Rhythm",
    tip: "Avoid lying down right after large meals.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Avoid lying down right after large meals.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 2,
    theme: "Meal Rhythm",
    core: "Meal Rhythm",
    tip: "Finish larger meals earlier if reflux is a problem.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Finish larger meals earlier if reflux is a problem.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 3,
    theme: "Meal Rhythm",
    core: "Meal Rhythm",
    tip: "Slow the first five bites of your meal.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Slow the first five bites of your meal.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 4,
    theme: "Meal Rhythm",
    core: "Meal Rhythm",
    tip: "Chew more than usual for one meal.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Chew more than usual for one meal.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 5,
    theme: "Meal Rhythm",
    core: "Meal Rhythm",
    tip: "Track symptoms after late meals.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track symptoms after late meals.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 6,
    theme: "Meal Rhythm",
    core: "Meal Rhythm",
    tip: "Rhythm helps your gut know what to expect.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Rhythm helps your gut know what to expect.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 7,
    theme: "Plant Diversity",
    core: "Plant Diversity",
    tip: "Add one new plant food this week.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add one new plant food this week.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 8,
    theme: "Plant Diversity",
    core: "Plant Diversity",
    tip: "Use herbs and spices as plant diversity.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use herbs and spices as plant diversity.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 9,
    theme: "Plant Diversity",
    core: "Plant Diversity",
    tip: "Try berries or greens as a daily add-on.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Try berries or greens as a daily add-on.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 10,
    theme: "Plant Diversity",
    core: "Plant Diversity",
    tip: "Add beans in small portions if tolerated.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add beans in small portions if tolerated.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 11,
    theme: "Plant Diversity",
    core: "Plant Diversity",
    tip: "Use olive oil as a polyphenol-rich fat.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use olive oil as a polyphenol-rich fat.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 12,
    theme: "Plant Diversity",
    core: "Plant Diversity",
    tip: "Rotate vegetables instead of eating the same two.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Rotate vegetables instead of eating the same two.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 1,
    theme: "Plant Diversity",
    core: "Plant Diversity",
    tip: "Add nuts or seeds if tolerated.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add nuts or seeds if tolerated.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 2,
    theme: "Plant Diversity",
    core: "Plant Diversity",
    tip: "Track which plants cause symptoms.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track which plants cause symptoms.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 3,
    theme: "Plant Diversity",
    core: "Plant Diversity",
    tip: "Cook vegetables if raw ones bother you.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Cook vegetables if raw ones bother you.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 4,
    theme: "Plant Diversity",
    core: "Plant Diversity",
    tip: "Progress slowly if your gut is sensitive.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Progress slowly if your gut is sensitive.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 5,
    theme: "Fermented Foods & Probiotics",
    core: "Fermented Foods & Probiotics",
    tip: "Try yogurt or kefir with live cultures if dairy is tolerated.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Try yogurt or kefir with live cultures if dairy is tolerated.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 6,
    theme: "Fermented Foods & Probiotics",
    core: "Fermented Foods & Probiotics",
    tip: "Try sauerkraut or kimchi in a small amount.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Try sauerkraut or kimchi in a small amount.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 7,
    theme: "Fermented Foods & Probiotics",
    core: "Fermented Foods & Probiotics",
    tip: "Do not force fermented foods if they worsen symptoms.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not force fermented foods if they worsen symptoms.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 8,
    theme: "Fermented Foods & Probiotics",
    core: "Fermented Foods & Probiotics",
    tip: "Use targeted probiotics for a specific goal, not random stacks.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use targeted probiotics for a specific goal, not random stacks.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 9,
    theme: "Fermented Foods & Probiotics",
    core: "Fermented Foods & Probiotics",
    tip: "Ask a clinician before probiotics if immunocompromised.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Ask a clinician before probiotics if immunocompromised.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 10,
    theme: "Fermented Foods & Probiotics",
    core: "Fermented Foods & Probiotics",
    tip: "Probiotics are not a replacement for fiber.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Probiotics are not a replacement for fiber.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 11,
    theme: "Fermented Foods & Probiotics",
    core: "Fermented Foods & Probiotics",
    tip: "Track symptoms for two weeks after adding a probiotic.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track symptoms for two weeks after adding a probiotic.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 12,
    theme: "Fermented Foods & Probiotics",
    core: "Fermented Foods & Probiotics",
    tip: "Do not add probiotic and fiber supplement the same day.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not add probiotic and fiber supplement the same day.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 1,
    theme: "Fermented Foods & Probiotics",
    core: "Fermented Foods & Probiotics",
    tip: "Stop if a probiotic clearly worsens symptoms.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Stop if a probiotic clearly worsens symptoms.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 2,
    theme: "Fermented Foods & Probiotics",
    core: "Fermented Foods & Probiotics",
    tip: "Food-based fermented options are a gentle first step.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Food-based fermented options are a gentle first step.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 3,
    theme: "Reflux Support",
    core: "Reflux Support",
    tip: "Avoid lying down for 2-3 hours after a heavy meal.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Avoid lying down for 2-3 hours after a heavy meal.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 4,
    theme: "Reflux Support",
    core: "Reflux Support",
    tip: "Make dinner smaller if reflux is worse at night.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Make dinner smaller if reflux is worse at night.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 5,
    theme: "Reflux Support",
    core: "Reflux Support",
    tip: "Identify trigger foods without assuming everything is a trigger.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Identify trigger foods without assuming everything is a trigger.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 6,
    theme: "Reflux Support",
    core: "Reflux Support",
    tip: "Track coffee, alcohol, chocolate, spicy foods, and late meals.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track coffee, alcohol, chocolate, spicy foods, and late meals.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 7,
    theme: "Reflux Support",
    core: "Reflux Support",
    tip: "Elevate head of bed if nighttime reflux is frequent.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Elevate head of bed if nighttime reflux is frequent.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 8,
    theme: "Reflux Support",
    core: "Reflux Support",
    tip: "Peppermint can worsen reflux even if it helps IBS-type cramps.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Peppermint can worsen reflux even if it helps IBS-type cramps.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 9,
    theme: "Reflux Support",
    core: "Reflux Support",
    tip: "Avoid tight waistbands after large meals.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Avoid tight waistbands after large meals.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 10,
    theme: "Reflux Support",
    core: "Reflux Support",
    tip: "Slow meals to reduce air swallowing.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Slow meals to reduce air swallowing.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 11,
    theme: "Reflux Support",
    core: "Reflux Support",
    tip: "Seek care for trouble swallowing or food sticking.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Seek care for trouble swallowing or food sticking.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 12,
    theme: "Reflux Support",
    core: "Reflux Support",
    tip: "Persistent reflux deserves medical evaluation.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Persistent reflux deserves medical evaluation.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 1,
    theme: "IBS-Type Symptoms",
    core: "IBS-Type Symptoms",
    tip: "Track bloating, pain, stool pattern, and triggers.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track bloating, pain, stool pattern, and triggers.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 2,
    theme: "IBS-Type Symptoms",
    core: "IBS-Type Symptoms",
    tip: "Consider a low-FODMAP trial only with proper guidance.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Consider a low-FODMAP trial only with proper guidance.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 3,
    theme: "IBS-Type Symptoms",
    core: "IBS-Type Symptoms",
    tip: "Try enteric-coated peppermint oil only if no reflux and clinician agrees.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Try enteric-coated peppermint oil only if no reflux and clinician agrees.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 4,
    theme: "IBS-Type Symptoms",
    core: "IBS-Type Symptoms",
    tip: "Use stress downshifts before meals.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use stress downshifts before meals.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 5,
    theme: "IBS-Type Symptoms",
    core: "IBS-Type Symptoms",
    tip: "Add soluble fiber slowly.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add soluble fiber slowly.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 6,
    theme: "IBS-Type Symptoms",
    core: "IBS-Type Symptoms",
    tip: "Avoid declaring foods 'bad' from one bad day.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Avoid declaring foods 'bad' from one bad day.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 7,
    theme: "IBS-Type Symptoms",
    core: "IBS-Type Symptoms",
    tip: "Look for repeat patterns over a week.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Look for repeat patterns over a week.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 8,
    theme: "IBS-Type Symptoms",
    core: "IBS-Type Symptoms",
    tip: "Do not use restrictive diets indefinitely without guidance.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not use restrictive diets indefinitely without guidance.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 9,
    theme: "IBS-Type Symptoms",
    core: "IBS-Type Symptoms",
    tip: "Consider lactose-free trial if dairy is a clear trigger.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Consider lactose-free trial if dairy is a clear trigger.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 10,
    theme: "IBS-Type Symptoms",
    core: "IBS-Type Symptoms",
    tip: "Get red flags evaluated before self-coaching.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Get red flags evaluated before self-coaching.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 11,
    theme: "Digestive Enzymes & Tolerance",
    core: "Digestive Enzymes & Tolerance",
    tip: "Use lactase only when lactose is the likely issue.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use lactase only when lactose is the likely issue.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 12,
    theme: "Digestive Enzymes & Tolerance",
    core: "Digestive Enzymes & Tolerance",
    tip: "Do not take digestive enzymes for every meal without a reason.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not take digestive enzymes for every meal without a reason.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 1,
    theme: "Digestive Enzymes & Tolerance",
    core: "Digestive Enzymes & Tolerance",
    tip: "Track whether high-fat meals trigger symptoms.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track whether high-fat meals trigger symptoms.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 2,
    theme: "Digestive Enzymes & Tolerance",
    core: "Digestive Enzymes & Tolerance",
    tip: "Ask about pancreatic/gallbladder issues if fatty-food intolerance is severe.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Ask about pancreatic/gallbladder issues if fatty-food intolerance is severe.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 3,
    theme: "Digestive Enzymes & Tolerance",
    core: "Digestive Enzymes & Tolerance",
    tip: "Introduce one tolerance experiment at a time.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Introduce one tolerance experiment at a time.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 4,
    theme: "Digestive Enzymes & Tolerance",
    core: "Digestive Enzymes & Tolerance",
    tip: "Use smaller portions of trigger foods to test dose response.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use smaller portions of trigger foods to test dose response.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 5,
    theme: "Digestive Enzymes & Tolerance",
    core: "Digestive Enzymes & Tolerance",
    tip: "Cook foods softer if raw foods bother digestion.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Cook foods softer if raw foods bother digestion.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 6,
    theme: "Digestive Enzymes & Tolerance",
    core: "Digestive Enzymes & Tolerance",
    tip: "Avoid supplement stacks that promise to fix every food sensitivity.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Avoid supplement stacks that promise to fix every food sensitivity.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 7,
    theme: "Digestive Enzymes & Tolerance",
    core: "Digestive Enzymes & Tolerance",
    tip: "Keep a simple food/symptom log.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Keep a simple food/symptom log.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 8,
    theme: "Digestive Enzymes & Tolerance",
    core: "Digestive Enzymes & Tolerance",
    tip: "Medical testing beats guessing when symptoms persist.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Medical testing beats guessing when symptoms persist.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 9,
    theme: "Stress & Gut-Brain Axis",
    core: "Stress & Gut-Brain Axis",
    tip: "Take 3 slow breaths before meals.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Take 3 slow breaths before meals.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 10,
    theme: "Stress & Gut-Brain Axis",
    core: "Stress & Gut-Brain Axis",
    tip: "Eat one meal without a screen.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Eat one meal without a screen.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 11,
    theme: "Stress & Gut-Brain Axis",
    core: "Stress & Gut-Brain Axis",
    tip: "Walk after stressful meals.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Walk after stressful meals.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 12,
    theme: "Stress & Gut-Brain Axis",
    core: "Stress & Gut-Brain Axis",
    tip: "Notice whether stress changes symptoms.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Notice whether stress changes symptoms.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 1,
    theme: "Stress & Gut-Brain Axis",
    core: "Stress & Gut-Brain Axis",
    tip: "Use a 2-minute breathing practice during flares.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use a 2-minute breathing practice during flares.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 2,
    theme: "Stress & Gut-Brain Axis",
    core: "Stress & Gut-Brain Axis",
    tip: "Do not label symptoms as 'all in your head' — the gut-brain connection is real.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not label symptoms as 'all in your head' — the gut-brain connection is real.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 3,
    theme: "Stress & Gut-Brain Axis",
    core: "Stress & Gut-Brain Axis",
    tip: "Prioritize sleep when digestion is flaring.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Prioritize sleep when digestion is flaring.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 4,
    theme: "Stress & Gut-Brain Axis",
    core: "Stress & Gut-Brain Axis",
    tip: "Reduce caffeine if urgency or reflux increases.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Reduce caffeine if urgency or reflux increases.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "nutrition",
  },
  {
    category: "digestive_microbiome",
    week: 5,
    theme: "Stress & Gut-Brain Axis",
    core: "Stress & Gut-Brain Axis",
    tip: "Add gentle movement, not intense workouts, during flares.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add gentle movement, not intense workouts, during flares.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "physical",
  },
  {
    category: "digestive_microbiome",
    week: 6,
    theme: "Stress & Gut-Brain Axis",
    core: "Stress & Gut-Brain Axis",
    tip: "Calm is part of digestion.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Calm is part of digestion.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 7,
    theme: "Clinical Red Flags",
    core: "Clinical Red Flags",
    tip: "Blood in stool needs medical attention.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Blood in stool needs medical attention.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 8,
    theme: "Clinical Red Flags",
    core: "Clinical Red Flags",
    tip: "Black/tarry stool needs urgent evaluation.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Black/tarry stool needs urgent evaluation.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 9,
    theme: "Clinical Red Flags",
    core: "Clinical Red Flags",
    tip: "Unexplained weight loss is not a coaching issue.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Unexplained weight loss is not a coaching issue.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 10,
    theme: "Clinical Red Flags",
    core: "Clinical Red Flags",
    tip: "Trouble swallowing requires medical care.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Trouble swallowing requires medical care.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 11,
    theme: "Clinical Red Flags",
    core: "Clinical Red Flags",
    tip: "Persistent vomiting requires medical care.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Persistent vomiting requires medical care.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 12,
    theme: "Clinical Red Flags",
    core: "Clinical Red Flags",
    tip: "Severe or worsening abdominal pain needs evaluation.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Severe or worsening abdominal pain needs evaluation.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 1,
    theme: "Clinical Red Flags",
    core: "Clinical Red Flags",
    tip: "New bowel changes after age 45 should be discussed with a clinician.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: New bowel changes after age 45 should be discussed with a clinician.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 2,
    theme: "Clinical Red Flags",
    core: "Clinical Red Flags",
    tip: "Fever with significant GI symptoms deserves care.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Fever with significant GI symptoms deserves care.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 3,
    theme: "Clinical Red Flags",
    core: "Clinical Red Flags",
    tip: "Anemia plus GI symptoms needs medical evaluation.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Anemia plus GI symptoms needs medical evaluation.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },
  {
    category: "digestive_microbiome",
    week: 4,
    theme: "Clinical Red Flags",
    core: "Clinical Red Flags",
    tip: "Do not use supplements to delay diagnosis.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not use supplements to delay diagnosis.",
    tracking: "Days logged / symptom score 1–10",
    safety: "Seek care for blood in stool, black stools, unexplained weight loss, trouble swallowing, severe pain, or major changes in bowel habits.",
    mode: "behavioral",
  },,

  // ─────────────────────────────────────────────────────────────────────────
  // HORMONE HEALTH & VITALITY — 100 tips (May 2026 expert addendum)
  // ─────────────────────────────────────────────────────────────────────────
  {
    category: "hormone_health_vitality",
    week: 1,
    theme: "Lifestyle foundation",
    core: "Everyone",
    tip: "Prioritize consistent sleep timing because sleep disruption can worsen energy, mood, appetite, and hormone-related symptoms.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Prioritize consistent sleep timing because sleep disruption can worsen energy, mood, appetite, and hormone-related symptoms.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 2,
    theme: "Lifestyle foundation",
    core: "Everyone",
    tip: "Track sleep quality, energy, mood, temperature changes, urinary comfort, and intimate-function concerns for 14 days before assuming a hormone problem.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track sleep quality, energy, mood, temperature changes, urinary comfort, and intimate-function concerns for 14 days before assuming a hormone problem.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 3,
    theme: "Lifestyle foundation",
    core: "Everyone",
    tip: "Use resistance training two to four times weekly if safe, because muscle mass and strength are major hormone-health and aging markers.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use resistance training two to four times weekly if safe, because muscle mass and strength are major hormone-health and aging markers.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "physical",
  },
  {
    category: "hormone_health_vitality",
    week: 4,
    theme: "Lifestyle foundation",
    core: "Everyone",
    tip: "Add daily walking or zone-2-style movement to support metabolic health, circulation, stress regulation, and healthy body composition.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Add daily walking or zone-2-style movement to support metabolic health, circulation, stress regulation, and healthy body composition.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "physical",
  },
  {
    category: "hormone_health_vitality",
    week: 5,
    theme: "Lifestyle foundation",
    core: "Everyone",
    tip: "Eat protein at each meal to support muscle, satiety, recovery, and healthy aging.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Eat protein at each meal to support muscle, satiety, recovery, and healthy aging.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 6,
    theme: "Lifestyle foundation",
    core: "Everyone",
    tip: "Avoid crash dieting because severe calorie restriction may worsen fatigue, sleep, mood, and reproductive or hormone-related symptoms.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Avoid crash dieting because severe calorie restriction may worsen fatigue, sleep, mood, and reproductive or hormone-related symptoms.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 7,
    theme: "Lifestyle foundation",
    core: "Everyone",
    tip: "Reduce evening alcohol intake if sleep, hot flashes, night sweats, urinary symptoms, or intimate performance are concerns.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Reduce evening alcohol intake if sleep, hot flashes, night sweats, urinary symptoms, or intimate performance are concerns.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 8,
    theme: "Lifestyle foundation",
    core: "Everyone",
    tip: "Use stress-reduction practices such as breathing, walking, journaling, or mindfulness because chronic stress can worsen perceived hormone symptoms.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use stress-reduction practices such as breathing, walking, journaling, or mindfulness because chronic stress can worsen perceived hormone symptoms.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "physical",
  },
  {
    category: "hormone_health_vitality",
    week: 9,
    theme: "Lifestyle foundation",
    core: "Everyone",
    tip: "Review medications with a clinician if symptoms began after a new prescription, because some medications affect libido, arousal, energy, sleep, or urinary function.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Review medications with a clinician if symptoms began after a new prescription, because some medications affect libido, arousal, energy, sleep, or urinary function.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 10,
    theme: "Lifestyle foundation",
    core: "Everyone",
    tip: "Build a symptom timeline that includes age, surgeries, medications, major weight changes, stress, sleep changes, and new symptoms.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Build a symptom timeline that includes age, surgeries, medications, major weight changes, stress, sleep changes, and new symptoms.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 11,
    theme: "Lifestyle foundation",
    core: "Everyone",
    tip: "Use waist measurement and strength markers rather than weight alone to assess progress.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use waist measurement and strength markers rather than weight alone to assess progress.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "physical",
  },
  {
    category: "hormone_health_vitality",
    week: 12,
    theme: "Lifestyle foundation",
    core: "Everyone",
    tip: "Limit nicotine exposure because vascular health strongly affects energy, recovery, urinary health, and intimate function.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Limit nicotine exposure because vascular health strongly affects energy, recovery, urinary health, and intimate function.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 1,
    theme: "Lifestyle foundation",
    core: "Everyone",
    tip: "Address sleep apnea risk if snoring, morning headaches, daytime sleepiness, or resistant fatigue are present.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Address sleep apnea risk if snoring, morning headaches, daytime sleepiness, or resistant fatigue are present.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 2,
    theme: "Lifestyle foundation",
    core: "Everyone",
    tip: "Maintain hydration and electrolytes when appropriate, especially if heat exposure, exercise, or urinary symptoms are present.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Maintain hydration and electrolytes when appropriate, especially if heat exposure, exercise, or urinary symptoms are present.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 3,
    theme: "Lifestyle foundation",
    core: "Everyone",
    tip: "Treat hormone health as a full-body topic involving sleep, stress, body composition, cardiovascular health, medication review, and clinical testing.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Treat hormone health as a full-body topic involving sleep, stress, body composition, cardiovascular health, medication review, and clinical testing.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "physical",
  },
  {
    category: "hormone_health_vitality",
    week: 4,
    theme: "Lifestyle foundation",
    core: "Everyone",
    tip: "Create a weekly recovery score using sleep, soreness, mood, libido/interest, energy, and motivation.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Create a weekly recovery score using sleep, soreness, mood, libido/interest, energy, and motivation.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "physical",
  },
  {
    category: "hormone_health_vitality",
    week: 5,
    theme: "Lifestyle foundation",
    core: "Everyone",
    tip: "Use sunlight exposure early in the day when appropriate to support circadian rhythm and sleep timing.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use sunlight exposure early in the day when appropriate to support circadian rhythm and sleep timing.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 6,
    theme: "Lifestyle foundation",
    core: "Everyone",
    tip: "Do not rely on online symptom lists alone; hormone-related symptoms overlap with thyroid disease, anemia, depression, medication effects, and sleep disorders.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not rely on online symptom lists alone; hormone-related symptoms overlap with thyroid disease, anemia, depression, medication effects, and sleep disorders.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 7,
    theme: "Lifestyle foundation",
    core: "Everyone",
    tip: "Pair strength training with adequate recovery because overtraining can worsen fatigue and perceived hormone symptoms.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Pair strength training with adequate recovery because overtraining can worsen fatigue and perceived hormone symptoms.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "physical",
  },
  {
    category: "hormone_health_vitality",
    week: 8,
    theme: "Lifestyle foundation",
    core: "Everyone",
    tip: "Use the app to prepare better clinician conversations rather than self-diagnosing hormone conditions.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use the app to prepare better clinician conversations rather than self-diagnosing hormone conditions.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 9,
    theme: "Clinical check",
    core: "Everyone",
    tip: "Ask a qualified clinician about lab testing if symptoms are persistent, disruptive, or worsening.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Ask a qualified clinician about lab testing if symptoms are persistent, disruptive, or worsening.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 10,
    theme: "Clinical check",
    core: "Everyone",
    tip: "Consider thyroid evaluation when fatigue, weight change, temperature intolerance, constipation, hair changes, or mood symptoms are present.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Consider thyroid evaluation when fatigue, weight change, temperature intolerance, constipation, hair changes, or mood symptoms are present.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 11,
    theme: "Clinical check",
    core: "Everyone",
    tip: "Discuss anemia, B12, iron, vitamin D, and metabolic labs if fatigue, weakness, or exercise intolerance are present.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Discuss anemia, B12, iron, vitamin D, and metabolic labs if fatigue, weakness, or exercise intolerance are present.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 12,
    theme: "Clinical check",
    core: "Men / testosterone context",
    tip: "Do not label low testosterone from symptoms alone; testosterone deficiency requires symptoms plus consistently low properly timed lab values.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not label low testosterone from symptoms alone; testosterone deficiency requires symptoms plus consistently low properly timed lab values.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 1,
    theme: "Clinical check",
    core: "Men / testosterone context",
    tip: "For testosterone testing, ask the clinician whether morning repeat testing is appropriate before any treatment decision.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: For testosterone testing, ask the clinician whether morning repeat testing is appropriate before any treatment decision.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 2,
    theme: "Clinical check",
    core: "Men / prostate context",
    tip: "Discuss urinary frequency, urgency, weak stream, nighttime urination, pelvic discomfort, or blood in urine with a clinician.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Discuss urinary frequency, urgency, weak stream, nighttime urination, pelvic discomfort, or blood in urine with a clinician.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 3,
    theme: "Clinical check",
    core: "Men / prostate context",
    tip: "Ask whether prostate evaluation or PSA discussion is appropriate based on age, symptoms, family history, and risk profile.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Ask whether prostate evaluation or PSA discussion is appropriate based on age, symptoms, family history, and risk profile.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 4,
    theme: "Clinical check",
    core: "Women / menopause context",
    tip: "Track hot flashes, night sweats, sleep disruption, cycle changes, mood changes, brain fog, and urogenital comfort before a menopause visit.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track hot flashes, night sweats, sleep disruption, cycle changes, mood changes, brain fog, and urogenital comfort before a menopause visit.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 5,
    theme: "Clinical check",
    core: "Women / menopause context",
    tip: "Discuss perimenopause even if periods are still occurring, because symptoms can begin before final menstrual period.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Discuss perimenopause even if periods are still occurring, because symptoms can begin before final menstrual period.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 6,
    theme: "Clinical check",
    core: "Women / GSM context",
    tip: "Discuss persistent vaginal, urinary, or intimate-comfort symptoms with a menopause-informed clinician rather than assuming they are simply normal aging.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Discuss persistent vaginal, urinary, or intimate-comfort symptoms with a menopause-informed clinician rather than assuming they are simply normal aging.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 7,
    theme: "Clinical check",
    core: "Everyone",
    tip: "Seek prompt medical attention for chest pain, fainting, severe shortness of breath, sudden neurologic symptoms, or unexplained bleeding.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Seek prompt medical attention for chest pain, fainting, severe shortness of breath, sudden neurologic symptoms, or unexplained bleeding.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 8,
    theme: "Clinical check",
    core: "Everyone",
    tip: "Do not start hormone therapy, peptides, or injectable treatments without clinician evaluation and monitoring.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not start hormone therapy, peptides, or injectable treatments without clinician evaluation and monitoring.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 9,
    theme: "Clinical check",
    core: "Everyone",
    tip: "Ask whether mental health, relationship stress, chronic pain, or medication effects may be contributing to intimate-function concerns.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Ask whether mental health, relationship stress, chronic pain, or medication effects may be contributing to intimate-function concerns.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 10,
    theme: "Clinical check",
    core: "Everyone",
    tip: "If fertility is a current or future goal, discuss this before any hormone therapy because some treatments can affect fertility.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: If fertility is a current or future goal, discuss this before any hormone therapy because some treatments can affect fertility.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 11,
    theme: "Clinical check",
    core: "Everyone",
    tip: "Use shared decision-making: personal risks, symptom severity, goals, family history, and treatment preferences should guide next steps.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use shared decision-making: personal risks, symptom severity, goals, family history, and treatment preferences should guide next steps.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 12,
    theme: "Male hormone support",
    core: "Men / testosterone context",
    tip: "Build leg and back strength because large-muscle resistance training supports body composition, energy, and functional vitality.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Build leg and back strength because large-muscle resistance training supports body composition, energy, and functional vitality.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "physical",
  },
  {
    category: "hormone_health_vitality",
    week: 1,
    theme: "Male hormone support",
    core: "Men / testosterone context",
    tip: "Improve sleep duration before assuming low testosterone, because short sleep can worsen fatigue, libido, and recovery.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Improve sleep duration before assuming low testosterone, because short sleep can worsen fatigue, libido, and recovery.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 2,
    theme: "Male hormone support",
    core: "Men / testosterone context",
    tip: "Reduce abdominal fat through diet, resistance training, and walking because metabolic health is tied to hormone function.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Reduce abdominal fat through diet, resistance training, and walking because metabolic health is tied to hormone function.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "physical",
  },
  {
    category: "hormone_health_vitality",
    week: 3,
    theme: "Male hormone support",
    core: "Men / testosterone context",
    tip: "Avoid heavy alcohol use because it can worsen sleep, body composition, liver function, and intimate performance.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Avoid heavy alcohol use because it can worsen sleep, body composition, liver function, and intimate performance.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 4,
    theme: "Male hormone support",
    core: "Men / testosterone context",
    tip: "Train grip strength and lower-body strength as practical markers of aging resilience.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Train grip strength and lower-body strength as practical markers of aging resilience.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "physical",
  },
  {
    category: "hormone_health_vitality",
    week: 5,
    theme: "Male hormone support",
    core: "Men / testosterone context",
    tip: "Address insulin resistance risk with nutrition, activity, and clinician-guided labs if waist size or blood sugar is a concern.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Address insulin resistance risk with nutrition, activity, and clinician-guided labs if waist size or blood sugar is a concern.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "physical",
  },
  {
    category: "hormone_health_vitality",
    week: 6,
    theme: "Male hormone support",
    core: "Men / testosterone context",
    tip: "Discuss testosterone only if symptoms and repeat lab results support deficiency; do not treat numbers alone.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Discuss testosterone only if symptoms and repeat lab results support deficiency; do not treat numbers alone.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 7,
    theme: "Male hormone support",
    core: "Men / testosterone context",
    tip: "Ask about risks and monitoring before TRT, including hematocrit, fertility goals, prostate evaluation, sleep apnea, and cardiovascular history.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Ask about risks and monitoring before TRT, including hematocrit, fertility goals, prostate evaluation, sleep apnea, and cardiovascular history.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "physical",
  },
  {
    category: "hormone_health_vitality",
    week: 8,
    theme: "Male hormone support",
    core: "Men / testosterone context",
    tip: "Avoid testosterone therapy if trying to conceive unless a qualified clinician specifically addresses fertility-preserving alternatives.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Avoid testosterone therapy if trying to conceive unless a qualified clinician specifically addresses fertility-preserving alternatives.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 9,
    theme: "Prostate/urinary support",
    core: "Men / prostate context",
    tip: "Track urinary symptoms such as weak stream, urgency, frequency, nighttime urination, incomplete emptying, or pelvic discomfort.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track urinary symptoms such as weak stream, urgency, frequency, nighttime urination, incomplete emptying, or pelvic discomfort.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 10,
    theme: "Prostate/urinary support",
    core: "Men / prostate context",
    tip: "Reduce evening fluids and alcohol if nighttime urination is disrupting sleep, unless medically contraindicated.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Reduce evening fluids and alcohol if nighttime urination is disrupting sleep, unless medically contraindicated.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 11,
    theme: "Prostate/urinary support",
    core: "Men / prostate context",
    tip: "Ask about pelvic floor physical therapy if pelvic discomfort, urinary urgency, or post-void dribbling are present.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Ask about pelvic floor physical therapy if pelvic discomfort, urinary urgency, or post-void dribbling are present.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "physical",
  },
  {
    category: "hormone_health_vitality",
    week: 12,
    theme: "Prostate/urinary support",
    core: "Men / prostate context",
    tip: "Do not assume prostate supplements are safe; review saw palmetto, beta-sitosterol, pygeum, or other formulas with a clinician.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not assume prostate supplements are safe; review saw palmetto, beta-sitosterol, pygeum, or other formulas with a clinician.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 1,
    theme: "Intimate function support",
    core: "Men / intimate function context",
    tip: "Treat intimate performance as a vascular, metabolic, psychological, medication, sleep, and relationship topic, not only a hormone topic.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Treat intimate performance as a vascular, metabolic, psychological, medication, sleep, and relationship topic, not only a hormone topic.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 2,
    theme: "Intimate function support",
    core: "Men / intimate function context",
    tip: "Discuss new or worsening erectile function changes with a clinician because they can be an early cardiovascular risk marker.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Discuss new or worsening erectile function changes with a clinician because they can be an early cardiovascular risk marker.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "physical",
  },
  {
    category: "hormone_health_vitality",
    week: 3,
    theme: "Intimate function support",
    core: "Men / intimate function context",
    tip: "Improve cardiovascular conditioning and walking consistency to support circulation and stamina.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Improve cardiovascular conditioning and walking consistency to support circulation and stamina.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "physical",
  },
  {
    category: "hormone_health_vitality",
    week: 4,
    theme: "Intimate function support",
    core: "Men / intimate function context",
    tip: "Ask a clinician whether medication options, pelvic floor therapy, vascular evaluation, or hormone testing are appropriate.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Ask a clinician whether medication options, pelvic floor therapy, vascular evaluation, or hormone testing are appropriate.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "physical",
  },
  {
    category: "hormone_health_vitality",
    week: 5,
    theme: "Intimate function support",
    core: "Men / intimate function context",
    tip: "Use non-shaming language: performance changes are common and medically addressable.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use non-shaming language: performance changes are common and medically addressable.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 6,
    theme: "Male hormone support",
    core: "Men / testosterone context",
    tip: "Do not use online testosterone boosters with undisclosed ingredients or anabolic agents.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not use online testosterone boosters with undisclosed ingredients or anabolic agents.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 7,
    theme: "Male hormone support",
    core: "Men / testosterone context",
    tip: "If on TRT, keep scheduled monitoring and do not adjust dose without the prescribing clinician.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: If on TRT, keep scheduled monitoring and do not adjust dose without the prescribing clinician.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 8,
    theme: "Menopause support",
    core: "Women / menopause context",
    tip: "Track hot flashes, night sweats, sleep disruption, cycle changes, mood, brain fog, joint aches, urinary symptoms, and intimate comfort.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track hot flashes, night sweats, sleep disruption, cycle changes, mood, brain fog, joint aches, urinary symptoms, and intimate comfort.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 9,
    theme: "Menopause support",
    core: "Women / menopause context",
    tip: "Identify hot-flash triggers such as alcohol, spicy foods, overheating, sleep disruption, and stress.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Identify hot-flash triggers such as alcohol, spicy foods, overheating, sleep disruption, and stress.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 10,
    theme: "Menopause support",
    core: "Women / menopause context",
    tip: "Use cooling strategies, breathable sleepwear, and bedroom temperature control for night sweats.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use cooling strategies, breathable sleepwear, and bedroom temperature control for night sweats.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 11,
    theme: "Menopause support",
    core: "Women / menopause context",
    tip: "Prioritize resistance training and protein because menopause transition can accelerate muscle and body-composition changes.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Prioritize resistance training and protein because menopause transition can accelerate muscle and body-composition changes.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 12,
    theme: "Menopause support",
    core: "Women / menopause context",
    tip: "Support bone health through strength training, impact activity if safe, vitamin D sufficiency, calcium-rich foods, and clinician-guided screening.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Support bone health through strength training, impact activity if safe, vitamin D sufficiency, calcium-rich foods, and clinician-guided screening.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 1,
    theme: "Menopause support",
    core: "Women / menopause context",
    tip: "Ask a menopause-informed clinician whether hormone therapy is appropriate based on symptoms, age, time since menopause, uterus status, and risk factors.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Ask a menopause-informed clinician whether hormone therapy is appropriate based on symptoms, age, time since menopause, uterus status, and risk factors.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 2,
    theme: "Menopause support",
    core: "Women / menopause context",
    tip: "If systemic estrogen is used and the user has a uterus, clinician guidance is needed on endometrial protection.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: If systemic estrogen is used and the user has a uterus, clinician guidance is needed on endometrial protection.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 3,
    theme: "Menopause support",
    core: "Women / menopause context",
    tip: "Discuss route of hormone therapy because oral and transdermal options can have different risk considerations.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Discuss route of hormone therapy because oral and transdermal options can have different risk considerations.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 4,
    theme: "Menopause support",
    core: "Women / menopause context",
    tip: "Avoid compounded hormones unless a clinician explains why an FDA-approved option is not suitable.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Avoid compounded hormones unless a clinician explains why an FDA-approved option is not suitable.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 5,
    theme: "Menopause support",
    core: "Women / menopause context",
    tip: "Do not rely on saliva hormone tests alone to determine menopause treatment decisions unless a clinician explains their role.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not rely on saliva hormone tests alone to determine menopause treatment decisions unless a clinician explains their role.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 6,
    theme: "Urogenital comfort",
    core: "Women / GSM context",
    tip: "Use app-safe terminology such as urogenital comfort, urinary comfort, intimate comfort, and tissue health.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use app-safe terminology such as urogenital comfort, urinary comfort, intimate comfort, and tissue health.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 7,
    theme: "Urogenital comfort",
    core: "Women / GSM context",
    tip: "Track dryness, irritation, urinary urgency, recurrent UTIs, discomfort with intimacy, and pelvic discomfort as possible urogenital menopause symptoms.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Track dryness, irritation, urinary urgency, recurrent UTIs, discomfort with intimacy, and pelvic discomfort as possible urogenital menopause symptoms.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 8,
    theme: "Urogenital comfort",
    core: "Women / GSM context",
    tip: "Try nonhormonal vaginal moisturizers or lubricants when appropriate, using neutral clinical language in the app.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Try nonhormonal vaginal moisturizers or lubricants when appropriate, using neutral clinical language in the app.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 9,
    theme: "Urogenital comfort",
    core: "Women / GSM context",
    tip: "Discuss low-dose vaginal estrogen, vaginal DHEA, or other clinician-guided options when persistent urogenital symptoms are present.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Discuss low-dose vaginal estrogen, vaginal DHEA, or other clinician-guided options when persistent urogenital symptoms are present.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 10,
    theme: "Urogenital comfort",
    core: "Women / GSM context",
    tip: "Users with a history of hormone-sensitive cancer should discuss local hormone options with their oncology and gynecology team.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Users with a history of hormone-sensitive cancer should discuss local hormone options with their oncology and gynecology team.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 11,
    theme: "Intimate function support",
    core: "Women / intimate function context",
    tip: "Normalize changes in desire, arousal, comfort, and response during perimenopause and postmenopause using respectful clinical language.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Normalize changes in desire, arousal, comfort, and response during perimenopause and postmenopause using respectful clinical language.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 12,
    theme: "Intimate function support",
    core: "Women / intimate function context",
    tip: "Discuss pain, discomfort, or avoidance of intimacy with a clinician trained in menopause, pelvic floor, or sexual medicine.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Discuss pain, discomfort, or avoidance of intimacy with a clinician trained in menopause, pelvic floor, or sexual medicine.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "physical",
  },
  {
    category: "hormone_health_vitality",
    week: 1,
    theme: "Intimate function support",
    core: "Women / intimate function context",
    tip: "Ask about pelvic floor physical therapy if pelvic pain, urinary urgency, or painful intimacy is present.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Ask about pelvic floor physical therapy if pelvic pain, urinary urgency, or painful intimacy is present.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "physical",
  },
  {
    category: "hormone_health_vitality",
    week: 2,
    theme: "Female testosterone education",
    core: "Women / testosterone context",
    tip: "Discuss testosterone therapy only with a qualified clinician and only for appropriate indications after evaluation of modifiable factors.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Discuss testosterone therapy only with a qualified clinician and only for appropriate indications after evaluation of modifiable factors.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 3,
    theme: "Female testosterone education",
    core: "Women / testosterone context",
    tip: "Do not use male testosterone products without clinician-directed dosing and monitoring.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Do not use male testosterone products without clinician-directed dosing and monitoring.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 4,
    theme: "Supplement consideration",
    core: "Everyone",
    tip: "Use a food-first approach before supplements: protein, fiber, colorful plants, healthy fats, and adequate micronutrients.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use a food-first approach before supplements: protein, fiber, colorful plants, healthy fats, and adequate micronutrients.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 5,
    theme: "Supplement consideration",
    core: "Everyone",
    tip: "Check vitamin D status with a clinician before high-dose supplementation; excessive vitamin D can be harmful.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Check vitamin D status with a clinician before high-dose supplementation; excessive vitamin D can be harmful.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 6,
    theme: "Supplement consideration",
    core: "Everyone",
    tip: "Consider magnesium only as a clinician-reviewed option for sleep, muscle cramps, or constipation, especially if kidney disease or medications are present.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Consider magnesium only as a clinician-reviewed option for sleep, muscle cramps, or constipation, especially if kidney disease or medications are present.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 7,
    theme: "Supplement consideration",
    core: "Everyone",
    tip: "Consider omega-3 intake from food or supplements only after reviewing bleeding risk, medications, and clinical goals.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Consider omega-3 intake from food or supplements only after reviewing bleeding risk, medications, and clinical goals.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 8,
    theme: "Supplement consideration",
    core: "Everyone",
    tip: "Use zinc only when intake or deficiency is a concern; long-term high-dose zinc can create copper deficiency and other issues.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Use zinc only when intake or deficiency is a concern; long-term high-dose zinc can create copper deficiency and other issues.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 9,
    theme: "Supplement consideration",
    core: "Everyone",
    tip: "Creatine monohydrate may be considered for strength and muscle support, but users with kidney disease or complex medical issues should ask a clinician.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Creatine monohydrate may be considered for strength and muscle support, but users with kidney disease or complex medical issues should ask a clinician.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 10,
    theme: "Supplement consideration",
    core: "Everyone",
    tip: "Prioritize adequate dietary protein before using amino acid or protein supplements.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Prioritize adequate dietary protein before using amino acid or protein supplements.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 11,
    theme: "Supplement consideration",
    core: "Men / testosterone context",
    tip: "Ashwagandha may be discussed as a stress/sleep support supplement with limited evidence for testosterone-related markers; avoid in pregnancy, breastfeeding, thyroid/autoimmune conditions, liver concerns, prostate cancer risk, and medication conflicts unless cleared.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Ashwagandha may be discussed as a stress/sleep support supplement with limited evidence for testosterone-related markers; avoid in pregnancy, breastfeeding, thyroid/autoimmune conditions, liver concerns, prostate cancer risk, and medication conflicts unless cleared.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 12,
    theme: "Supplement consideration",
    core: "Everyone",
    tip: "Avoid supplement stacks marketed as hormone boosters unless ingredients, testing, and contraindications are reviewed.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Avoid supplement stacks marketed as hormone boosters unless ingredients, testing, and contraindications are reviewed.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 1,
    theme: "Supplement consideration",
    core: "Women / menopause context",
    tip: "Black cohosh may appear in menopause products, but evidence and product quality vary and liver-related safety concerns should be disclosed.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Black cohosh may appear in menopause products, but evidence and product quality vary and liver-related safety concerns should be disclosed.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 2,
    theme: "Supplement consideration",
    core: "Women / menopause context",
    tip: "Phytoestrogen or soy isoflavone products should be framed as optional and discussed with a clinician for users with hormone-sensitive cancer history or medication concerns.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Phytoestrogen or soy isoflavone products should be framed as optional and discussed with a clinician for users with hormone-sensitive cancer history or medication concerns.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 3,
    theme: "Supplement consideration",
    core: "Everyone",
    tip: "DHEA should not be treated as a casual supplement because it can affect androgen and estrogen pathways.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: DHEA should not be treated as a casual supplement because it can affect androgen and estrogen pathways.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 4,
    theme: "Supplement consideration",
    core: "Everyone",
    tip: "Pregnenolone should not be recommended without clinician supervision because it is a steroid-hormone precursor.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Pregnenolone should not be recommended without clinician supervision because it is a steroid-hormone precursor.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 5,
    theme: "Supplement consideration",
    core: "Women / urogenital context",
    tip: "Vitamin E or other vaginal suppositories should be presented only as clinician-reviewed options; avoid promising treatment benefits or using graphic app language.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Vitamin E or other vaginal suppositories should be presented only as clinician-reviewed options; avoid promising treatment benefits or using graphic app language.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "nutrition",
  },
  {
    category: "hormone_health_vitality",
    week: 6,
    theme: "Supplement consideration",
    core: "Everyone",
    tip: "Require the supplement disclaimer for any hormone-support supplement: not evaluated by FDA and not intended to diagnose, treat, cure, or prevent disease.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Require the supplement disclaimer for any hormone-support supplement: not evaluated by FDA and not intended to diagnose, treat, cure, or prevent disease.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 7,
    theme: "Prescription therapy education",
    core: "Everyone",
    tip: "Hormone therapy should be an educational discussion topic only; the app must not prescribe, dose, source, or instruct users how to obtain hormones.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Hormone therapy should be an educational discussion topic only; the app must not prescribe, dose, source, or instruct users how to obtain hormones.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 8,
    theme: "Prescription therapy education",
    core: "Men / testosterone context",
    tip: "TRT should be presented as clinician-supervised therapy for confirmed testosterone deficiency, not a general anti-aging treatment.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: TRT should be presented as clinician-supervised therapy for confirmed testosterone deficiency, not a general anti-aging treatment.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 9,
    theme: "Prescription therapy education",
    core: "Men / testosterone context",
    tip: "TRT users need monitoring that may include symptoms, testosterone levels, hematocrit, fertility goals, prostate considerations, sleep apnea, and cardiovascular risk.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: TRT users need monitoring that may include symptoms, testosterone levels, hematocrit, fertility goals, prostate considerations, sleep apnea, and cardiovascular risk.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "physical",
  },
  {
    category: "hormone_health_vitality",
    week: 10,
    theme: "Prescription therapy education",
    core: "Men / testosterone context",
    tip: "The app should not recommend TRT for men planning near-term fertility without clinician-directed fertility counseling.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: The app should not recommend TRT for men planning near-term fertility without clinician-directed fertility counseling.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 11,
    theme: "Prescription therapy education",
    core: "Women / menopause context",
    tip: "Systemic estrogen/progesterone therapy should be framed as individualized medical care for appropriate symptoms and risk profiles.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Systemic estrogen/progesterone therapy should be framed as individualized medical care for appropriate symptoms and risk profiles.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 12,
    theme: "Prescription therapy education",
    core: "Women / GSM context",
    tip: "Low-dose vaginal estrogen, vaginal DHEA, or ospemifene should be listed as clinician-guided options for persistent urogenital menopause symptoms.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Low-dose vaginal estrogen, vaginal DHEA, or ospemifene should be listed as clinician-guided options for persistent urogenital menopause symptoms.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 1,
    theme: "Prescription therapy education",
    core: "Women / testosterone context",
    tip: "Female testosterone therapy should be framed as specialist-guided and not a casual wellness add-on.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Female testosterone therapy should be framed as specialist-guided and not a casual wellness add-on.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 2,
    theme: "Prescription therapy education",
    core: "Everyone",
    tip: "Peptides, anabolic steroids, and unregulated hormone products should be blocked from consumer recommendations and allowed only as clinician-discussion education.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Peptides, anabolic steroids, and unregulated hormone products should be blocked from consumer recommendations and allowed only as clinician-discussion education.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 3,
    theme: "Prescription therapy education",
    core: "Everyone",
    tip: "Any hormone-related red flags—unexplained bleeding, breast changes, prostate symptoms, chest pain, severe depression, or neurologic symptoms—should trigger medical guidance language.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: Any hormone-related red flags—unexplained bleeding, breast changes, prostate symptoms, chest pain, severe depression, or neurologic symptoms—should trigger medical guidance language.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },
  {
    category: "hormone_health_vitality",
    week: 4,
    theme: "Prescription therapy education",
    core: "Everyone",
    tip: "The app should always end hormone recommendations with a clinician-discussion prompt and a reminder that the content is educational, not medical advice.",
    framing: "I'm not asking for perfect. I'm asking for one honest rep this week: The app should always end hormone recommendations with a clinician-discussion prompt and a reminder that the content is educational, not medical advice.",
    tracking: "Symptoms logged / clinician conversations prepared",
    safety: "Discuss any hormone, supplement, or therapy change with a qualified clinician. Unexplained bleeding, blood in urine, chest pain, severe depression, or hormone-sensitive cancer history need direct medical care.",
    mode: "behavioral",
  },

  // ═════════════════════════════════════════════════════════════════════════
  // 2026 LONGEVITY BLUEPRINT — 52 micro-habits from the CA/CVD protocol
  // research (Gemini synthesis, reviewed and approved by Keith 2026-05-15).
  // Each habit cross-protects against cancer (CA) and/or cardiovascular
  // disease (CVD) and is tagged with the Phase 2 categories it should
  // surface for. Authored as multi-category tips so the picker can serve
  // them across heart_fitness, longevity_prevention, weight_metabolism,
  // digestive_microbiome, stress_mental, and brain_performance users.
  // Week distribution spreads them across an 8-week protocol arc.
  // ═════════════════════════════════════════════════════════════════════════
  { categories: ['longevity_prevention', 'heart_fitness'], week: 1, theme: 'Cruciferous Crunch', core: 'DNA protection', tip: 'Eat 1 cup of broccoli, cauliflower, or kale today — sulforaphane activates DNA-repair pathways.', framing: "I'm not asking for perfect. I'm asking for one honest rep today: one cup of cruciferous on the plate.", tracking: 'Days with a cruciferous serving', safety: 'Cooked is fine — raw is more potent for sulforaphane but harder on digestion. Adjust to taste.', mode: 'nutrition' },
  { categories: ['heart_fitness', 'longevity_prevention'], week: 1, theme: 'Stair Climb', core: 'Heart rate variability', tip: 'Take the stairs instead of the elevator at least once today.', framing: "Stairs over elevator, once. That's it.", tracking: 'Flights climbed', safety: 'Skip if you have severe knee or hip pain or balance concerns.', mode: 'physical' },
  { categories: ['stress_mental', 'heart_fitness', 'brain_performance'], week: 1, theme: 'Gratitude Journal', core: 'Stress regulation', tip: 'Write down 3 things you appreciated about today before bed — lowers blood pressure and cortisol over time.', framing: "Three lines. Doesn't have to be deep. Anything genuine.", tracking: 'Nights journaled', safety: 'Pause if reflection becomes rumination — talk to a clinician if it does.', mode: 'behavioral' },
  { categories: ['heart_fitness', 'longevity_prevention'], week: 1, theme: 'Omega-3 Loading', core: 'Plaque inflammation', tip: 'Add 2 grams of high-quality fish or algae oil daily — reduces plaque inflammation and triglycerides.', framing: "One supplement habit today: 2 grams of omega-3 with breakfast.", tracking: 'Days taken', safety: 'Talk to your doctor first if you are on blood thinners.', mode: 'nutrition' },
  { categories: ['longevity_prevention', 'weight_metabolism', 'heart_fitness'], week: 1, theme: 'Fiber First', core: 'Insulin regulation', tip: 'Eat your vegetables BEFORE your carbs at this meal — blunts the insulin spike that feeds cancer cells and scars arteries.', framing: "Order matters. Veggies, protein, then carbs. Same food, smaller spike.", tracking: 'Meals where you ate fiber first', safety: 'No safety concerns for typical adults.', mode: 'nutrition' },
  { categories: ['brain_performance', 'strength_function'], week: 1, theme: 'Single-Leg Balance', core: 'Neuro-plasticity', tip: 'Brush your teeth while standing on one leg — single-leg balance under 10 seconds is correlated with all-cause mortality.', framing: "While brushing. One minute on each leg. That's it.", tracking: 'Days you balanced while brushing', safety: 'Stand near a counter for support. Skip if you have severe vertigo.', mode: 'physical' },
  { categories: ['longevity_prevention'], week: 2, theme: 'Cold Finish', core: 'Immune surveillance', tip: 'End your shower with 30 seconds of cold water — boosts Natural Killer cell activity.', framing: "Just 30 seconds at the end. Doesn't have to be all cold.", tracking: 'Days finished cold', safety: 'Skip if you have heart disease, Raynaud\'s, or are pregnant.', mode: 'physical' },
  { categories: ['longevity_prevention', 'heart_fitness'], week: 2, theme: 'Berries Swap', core: 'Antioxidant intake', tip: 'Eat a bowl of berries instead of a sugary dessert today — anthocyanins protect DNA and blood vessels.', framing: "Same dessert slot. Berries instead.", tracking: 'Days you chose berries', safety: 'No safety concerns for typical adults.', mode: 'nutrition' },
  { categories: ['stress_mental', 'longevity_prevention', 'brain_performance'], week: 2, theme: 'Forest Bathing', core: 'Cortisol drop', tip: 'Spend 20 minutes in nature this week — trees release phytoncides that lower cortisol-induced cell mutations.', framing: "Twenty minutes outside, anywhere green. Phone in pocket.", tracking: 'Minutes outside', safety: 'Stay hydrated and wear sun protection.', mode: 'behavioral' },
  { categories: ['longevity_prevention', 'heart_fitness', 'strength_function'], week: 2, theme: 'Vitamin D + K2', core: 'Bone-heart axis', tip: 'Check your vitamin D level — aim for 50+ ng/mL. Supplement D3 + K2 together if low.', framing: "Ask for a vitamin D test at your next doctor visit. It costs almost nothing.", tracking: 'Test scheduled / supplement taken', safety: 'Get tested before supplementing. K2 interacts with blood thinners.', mode: 'nutrition' },
  { categories: ['longevity_prevention', 'brain_performance'], week: 2, theme: 'Green Tea Sip', core: 'Cancer-cell apoptosis', tip: 'Replace one coffee today with green tea — EGCG triggers cancer-cell death and supports brain health.', framing: "One coffee, replaced. That's the assignment.", tracking: 'Days you swapped', safety: 'Limit if you have iron-absorption issues — tannins inhibit iron.', mode: 'nutrition' },
  { categories: ['strength_function', 'heart_fitness'], week: 2, theme: 'Dead Hang', core: 'Grip + spine', tip: 'Hang from a pull-up bar or sturdy doorframe for 30 seconds — grip strength is one of the strongest heart-longevity predictors.', framing: "Thirty seconds. Or as long as you can.", tracking: 'Seconds hung', safety: 'Skip if you have shoulder injury. Build up gradually.', mode: 'physical' },
  { categories: ['heart_fitness', 'longevity_prevention'], week: 3, theme: 'Infrared Sauna', core: 'Cardiovascular mimic', tip: 'Spend 15 minutes in an infrared sauna 2-3 times this week — mimics cardiovascular exercise and flushes toxins.', framing: "Fifteen minutes. Heat does work the heart can\'t.", tracking: 'Sauna sessions', safety: 'Skip if pregnant, on heart medications, or have low blood pressure. Hydrate.', mode: 'physical' },
  { categories: ['heart_fitness', 'longevity_prevention'], week: 3, theme: 'Allium Power', core: 'Blood thinning + sulfur', tip: 'Add raw garlic or onions to a meal today — sulfur compounds thin blood and support DNA repair.', framing: "One meal. A clove or a slice of onion.", tracking: 'Meals with allium', safety: 'Lower the dose if you bruise easily or are on blood thinners.', mode: 'nutrition' },
  { categories: ['stress_mental', 'brain_performance'], week: 3, theme: 'Digital Fast', core: 'Dopamine reset', tip: 'No phone for the first hour after waking today — protects dopamine and lowers baseline anxiety.', framing: "One hour. Coffee, sunlight, your own thoughts.", tracking: 'Mornings phone-free first hour', safety: 'Keep the phone reachable if on-call for emergencies.', mode: 'behavioral' },
  { categories: ['heart_fitness', 'sleep_recovery'], week: 3, theme: 'Magnesium Glycinate', core: 'Vessel relaxation', tip: 'Take 300 mg of magnesium glycinate before bed — relaxes blood vessels and improves sleep depth.', framing: "Right before bed. Glass of water. Easy.", tracking: 'Nights taken', safety: 'Talk to your doctor if you have kidney disease or are on medications.', mode: 'nutrition' },
  { categories: ['digestive_microbiome', 'longevity_prevention'], week: 3, theme: 'Fermented Fuel', core: 'Gut immune training', tip: 'Eat one serving of kimchi, sauerkraut, kefir, or yogurt today — trains the gut immune system.', framing: "One tablespoon. With dinner. Or in a wrap.", tracking: 'Days with a fermented food', safety: 'Start small if you\'re new to fermented foods — gas is normal first week.', mode: 'nutrition' },
  { categories: ['heart_fitness', 'energy_fatigue'], week: 3, theme: 'Zone 2 Cardio', core: 'Mitochondrial density', tip: 'Walk 30 minutes at a "chatty" pace today — Zone 2 builds the mitochondria that defend against both cancer and stiff arteries.', framing: "Talk-but-not-sing pace. Thirty minutes.", tracking: 'Minutes of Zone 2', safety: 'Stop for chest pain, severe shortness of breath, or dizziness.', mode: 'physical' },
  { categories: ['heart_fitness'], week: 3, theme: 'Nasal Breathing', core: 'Nitric oxide', tip: 'Breathe only through your nose at rest today — increases nitric oxide, your body\'s natural vasodilator.', framing: "Tongue on roof of mouth. Mouth closed. Nose breathing only.", tracking: 'Hours of nasal breathing', safety: 'If you have severe nasal congestion, treat the cause first.', mode: 'physical' },
  { categories: ['longevity_prevention', 'heart_fitness'], week: 4, theme: 'Turmeric Golden Milk', core: 'Anti-inflammatory', tip: 'Make warm milk with a teaspoon of turmeric and a pinch of black pepper — curcumin is one of the most-studied anti-inflammatories.', framing: "Evening drink. Replaces dessert. Tastes great.", tracking: 'Days with turmeric', safety: 'Talk to your doctor if you\'re on blood thinners.', mode: 'nutrition' },
  { categories: ['heart_fitness', 'stress_mental'], week: 4, theme: 'Box Breathing', core: 'Vagus nerve', tip: 'Practice 4-4-4-4 box breathing for 2 minutes — directly stimulates the vagus nerve and lowers blood pressure.', framing: "Four in, four hold, four out, four hold. Two minutes.", tracking: 'Sessions today', safety: 'Stop if you feel lightheaded; resume normal breathing.', mode: 'behavioral' },
  { categories: ['heart_fitness', 'energy_fatigue'], week: 4, theme: 'CoQ10', core: 'Heart bioenergetics', tip: 'Take 100 mg of CoQ10 (ubiquinol) daily — especially important if you\'re on a statin.', framing: "One supplement with breakfast.", tracking: 'Days taken', safety: 'Talk to your doctor if you\'re on blood thinners or blood pressure meds.', mode: 'nutrition' },
  { categories: ['longevity_prevention', 'weight_metabolism', 'digestive_microbiome'], week: 4, theme: '12-Hour Window', core: 'Autophagy', tip: 'Eat all your food today within a 12-hour window — gives the body time for cellular cleanup (autophagy).', framing: "If first food is 8 am, last food is 8 pm. That\'s it.", tracking: 'Days you hit the 12-hour window', safety: 'Not for those with eating disorder history, diabetes on insulin, or pregnancy.', mode: 'behavioral' },
  { categories: ['heart_fitness', 'strength_function'], week: 4, theme: 'Grip Strength', core: 'Heart longevity', tip: 'Squeeze a tennis ball or grip trainer for 60 seconds each hand — grip strength correlates with overall longevity.', framing: "One minute. Each hand. While watching TV.", tracking: 'Days you trained grip', safety: 'Stop if you have severe wrist or hand pain.', mode: 'physical' },
  { categories: ['longevity_prevention', 'heart_fitness'], week: 4, theme: 'Grounding', core: 'Free radical neutralization', tip: 'Walk barefoot on grass, sand, or soil for 5 minutes — early research shows it neutralizes free radicals.', framing: "Five minutes. Bare feet. Outside.", tracking: 'Days grounded', safety: 'Watch for sharp objects and insects. Skip if you have foot wounds.', mode: 'physical' },
  { categories: ['heart_fitness'], week: 4, theme: 'Ditch the Seed Oils', core: 'Reduce arterial inflammation', tip: 'Cook with olive or avocado oil today — skip vegetable, soy, canola, and corn oils.', framing: "When you cook today, reach for olive. Skip the bottle of yellow oil.", tracking: 'Meals cooked in olive/avocado', safety: 'Both have high smoke points; olive for low/medium, avocado for high heat.', mode: 'nutrition' },
  { categories: ['stress_mental', 'sleep_recovery'], week: 5, theme: 'Yoga Nidra', core: 'Cortisol clearance', tip: 'Try 15 minutes of "Non-Sleep Deep Rest" (yoga nidra) today — clears cortisol like a power nap without sleeping.', framing: 'Headphones, dim lights, fifteen minutes. Search YouTube for NSDR.', tracking: 'Sessions completed', safety: 'No safety concerns for typical adults.', mode: 'behavioral' },
  { categories: ['longevity_prevention'], week: 5, theme: 'Zinc + Quercetin', core: 'Immune barrier', tip: 'Take zinc + quercetin during cold/flu season — supports the cellular membrane immune barrier.', framing: "Seasonal supplement. With food.", tracking: 'Days taken during season', safety: 'Don\'t take continuously year-round — long-term high zinc depletes copper.', mode: 'nutrition' },
  { categories: ['longevity_prevention'], week: 5, theme: 'Lycopene Load', core: 'Prostate + breast protection', tip: 'Eat cooked tomatoes today (sauce, paste, soup) — lycopene absorbs better cooked than raw.', framing: "Pasta sauce, salsa, or a cup of tomato soup.", tracking: 'Days with cooked tomato', safety: 'No safety concerns for typical adults.', mode: 'nutrition' },
  { categories: ['heart_fitness', 'strength_function', 'longevity_prevention'], week: 5, theme: 'Eccentric Squats', core: 'Myokine release', tip: 'Sit down into a chair very slowly today — eccentric loading triggers myokines that signal repair to heart and brain.', framing: "Three seconds to sit. Stand back up. Five reps.", tracking: 'Days with eccentric work', safety: 'Use a chair or sturdy support. Skip if severe knee pain.', mode: 'physical' },
  { categories: ['longevity_prevention', 'sleep_recovery'], week: 5, theme: 'Blue Light Blockers', core: 'Melatonin protection', tip: 'Wear blue light blockers (or use night-mode) after 7 PM — protects melatonin, your body\'s nightly DNA repairer.', framing: "Glasses on at 7. Or just set your phone to warm.", tracking: 'Nights blocked', safety: 'No safety concerns.', mode: 'physical' },
  { categories: ['longevity_prevention'], week: 5, theme: 'Herb it Up', core: 'Carcinogen blocking', tip: 'Marinate or season meat with rosemary or oregano before cooking — blocks heterocyclic amines (HCAs) formed by charring.', framing: "Sprinkle, marinate, cook. Same meat, fewer carcinogens.", tracking: 'Meals herbed', safety: 'No safety concerns for typical adults.', mode: 'nutrition' },
  { categories: ['heart_fitness', 'stress_mental'], week: 6, theme: 'Laughter Therapy', core: 'Endothelial relaxation', tip: 'Watch something funny for 15 minutes today — laughter directly relaxes the lining of your blood vessels.', framing: "Fifteen minutes. Standup, cartoons, anything that makes you laugh.", tracking: 'Days you laughed on purpose', safety: 'No safety concerns.', mode: 'behavioral' },
  { categories: ['longevity_prevention', 'energy_fatigue'], week: 6, theme: 'NMN or NR', core: 'NAD+ precursors', tip: 'Consider NMN or NR (NAD+ precursors) daily — supports DNA repair and cellular energy.', framing: "Morning supplement. Capsule with water.", tracking: 'Days taken', safety: 'Talk to your doctor first. Not for those with active cancer (NAD pathways can fuel tumor growth).', mode: 'nutrition' },
  { categories: ['heart_fitness'], week: 6, theme: 'Bean Protocol', core: 'Soluble fiber + LDL', tip: 'Eat ½ cup of beans daily — soluble fiber binds LDL cholesterol and removes it.', framing: "Half a cup. Black, kidney, chickpea, lentil — any color works.", tracking: 'Days with beans', safety: 'Build up slowly. Soak dried beans to reduce gas.', mode: 'nutrition' },
  { categories: ['heart_fitness'], week: 6, theme: 'Sprint Interval', core: 'VO2 max', tip: 'Do one 10-second "all-out" sprint (bike, run, or stairs) once this week — biggest VO2 max gain per minute spent.', framing: "Ten seconds. All out. Once. Walk for two minutes after.", tracking: 'Sprints this week', safety: 'Skip if you have heart disease, joint injury, or are sedentary — build up first.', mode: 'physical' },
  { categories: ['heart_fitness'], week: 6, theme: 'Tongue Scraping', core: 'Oral-heart axis', tip: 'Scrape your tongue in the morning — reduces oral bacteria linked to coronary disease.', framing: "Cheap tongue scraper. Ten seconds. Right after brushing.", tracking: 'Mornings scraped', safety: 'No safety concerns.', mode: 'physical' },
  { categories: ['longevity_prevention'], week: 6, theme: 'Citrus Zest', core: 'Liver detoxification', tip: 'Zest a lemon or lime onto a salad or fish today — limonene supports liver detox pathways.', framing: "One pinch of zest. From a real lemon.", tracking: 'Meals with zest', safety: 'Avoid grapefruit zest if you\'re on cardiac or statin medications.', mode: 'nutrition' },
  { categories: ['brain_performance'], week: 6, theme: 'Learning Habit', core: 'Cognitive reserve', tip: 'Read 10 pages of a new (challenging) book today — builds cognitive reserve against dementia.', framing: "Ten pages. Not your phone. A real book.", tracking: 'Pages read', safety: 'No safety concerns.', mode: 'behavioral' },
  { categories: ['longevity_prevention'], week: 7, theme: 'Milk Thistle', core: 'Liver clearance', tip: 'Take milk thistle (silymarin) periodically — supports liver detoxification of environmental toxins.', framing: "One month on, one month off. Morning capsule.", tracking: 'Days taken', safety: 'Talk to your doctor if you\'re on medications metabolized by the liver.', mode: 'nutrition' },
  { categories: ['longevity_prevention', 'hormone_health_vitality'], week: 7, theme: 'Brazil Nut', core: 'Selenium + thyroid', tip: 'Eat 1-2 Brazil nuts today — one of the highest natural sources of selenium.', framing: "One or two. Not more. Selenium has a narrow window.", tracking: 'Days with Brazil nuts', safety: 'Cap at 2 per day — high selenium toxicity is real.', mode: 'nutrition' },
  { categories: ['heart_fitness', 'strength_function'], week: 7, theme: 'Plank Challenge', core: 'Metabolic stability', tip: 'Build to a 2-minute plank — core strength predicts metabolic stability and back health.', framing: "Hold as long as you can. Add five seconds each session.", tracking: 'Seconds planked', safety: 'Skip if you have recent abdominal surgery or back injury.', mode: 'physical' },
  { categories: ['heart_fitness'], week: 7, theme: 'Morning Stretch', core: 'Arterial stiffness', tip: 'Do 5 minutes of cat-cow or spinal flexion in the morning — arterial stiffness reduces in flexible bodies.', framing: "Five minutes. On the floor. Before coffee.", tracking: 'Mornings stretched', safety: 'No safety concerns for typical adults.', mode: 'physical' },
  { categories: ['heart_fitness', 'longevity_prevention'], week: 7, theme: 'Dark Chocolate', core: 'Flavanols + vessel dilation', tip: 'One square of >85% dark chocolate today — flavanols dilate blood vessels and supply antioxidants.', framing: "One square. Real cacao. After lunch.", tracking: 'Days with dark chocolate', safety: 'Cap at one square — calorie-dense and contains caffeine.', mode: 'nutrition' },
  { categories: ['brain_performance', 'sleep_recovery', 'longevity_prevention'], week: 7, theme: 'Deep Sleep Focus', core: 'Glymphatic drainage', tip: 'Set bedroom temperature to 65°F (18°C) tonight — the brain\'s glymphatic clearance system works best when cool.', framing: "Sixty-five degrees. Window cracked or AC on.", tracking: 'Nights at target temp', safety: 'Adjust for very young or very old household members.', mode: 'physical' },
  { categories: ['digestive_microbiome', 'longevity_prevention'], week: 7, theme: 'Probiotics', core: 'Gut immune system', tip: 'Take a high-strain-diversity probiotic — 70% of your immune system lives in your gut.', framing: "Morning capsule with water. Or fermented foods.", tracking: 'Days taken', safety: 'Start low if you\'re immunocompromised; talk to your doctor.', mode: 'nutrition' },
  { categories: ['weight_metabolism', 'longevity_prevention', 'heart_fitness'], week: 8, theme: 'Apple Cider Vinegar', core: 'Glucose spike control', tip: 'Take 1 teaspoon of apple cider vinegar in water before dinner — blunts post-meal glucose spike.', framing: "One teaspoon. Glass of water. Before dinner.", tracking: 'Meals preceded by ACV', safety: 'Always dilute — straight ACV erodes tooth enamel. Skip if you have ulcers or GERD.', mode: 'nutrition' },
  { categories: ['strength_function', 'heart_fitness'], week: 8, theme: 'Push-up Test', core: 'Heart safety predictor', tip: 'Work toward 20-40 non-stop push-ups — this is directly correlated with cardiac event safety in midlife adults.', framing: "Start with knee push-ups. Build up over weeks.", tracking: 'Max consecutive push-ups', safety: 'Skip if you have severe shoulder or wrist pain.', mode: 'physical' },
  { categories: ['longevity_prevention', 'skin_health'], week: 8, theme: 'Sun Exposure', core: 'T-cell activation', tip: 'Get 15 minutes of midday sun on skin (without sunscreen) today — vitamin D activates T-cells.', framing: "Fifteen minutes. Arms, legs, or face. No burning.", tracking: 'Days with sun exposure', safety: 'Avoid burning. Skip if on photosensitizing medications or you have a melanoma history.', mode: 'physical' },
  { categories: ['weight_metabolism', 'longevity_prevention', 'heart_fitness'], week: 8, theme: 'No-Sugar Challenge', core: 'Insulin reset', tip: 'Eat zero added sugar for one week — the "Grand Reset" for insulin sensitivity.', framing: "Read labels. If sugar\'s in the first 3 ingredients, skip it.", tracking: 'Days no added sugar', safety: 'No safety concerns. Fruit is fine.', mode: 'nutrition' },
  { categories: ['stress_mental', 'heart_fitness'], week: 8, theme: 'Social Connection', core: 'Loneliness protection', tip: 'Call or visit a loved one today — social connection reduces "broken heart" stress mortality.', framing: "One person. Five minutes. Not a text — voice.", tracking: 'Days connected', safety: 'No safety concerns.', mode: 'behavioral' },
  { categories: ['longevity_prevention', 'heart_fitness'], week: 8, theme: 'Resveratrol', core: 'SIRT1 activation', tip: 'Consider resveratrol or pterostilbene daily — mimics longevity gene expression patterns from caloric restriction.', framing: "Morning supplement.", tracking: 'Days taken', safety: 'Talk to your doctor if you\'re on blood thinners.', mode: 'nutrition' },
]

// Helper: tips filtered by category and week (any week tipBank.week <= currentWeek
// is fair game, with preference for week === currentWeek). Used downstream.
export function getTipsForCategoryWeek(category, week) {
  return TIP_BANK.filter(t => t.category === category && t.week <= week)
}

export function getTipsForCategory(category) {
  return TIP_BANK.filter(t => t.category === category)
}
